// const fatigueIncrease = 0.05 + Math.random() * 0.09;

// const MAGE_BASE   = 1.55;
// const DRAGON_BASE = 1.45;

// const MAGE_WEIGHTS = {
//   lightforging: 0.055, voidweaving: 0.055,
//   soulbinding:  0.050, stormweaving: 0.045,
//   flamecalling: 0.040, tidecalling:  0.035,
// };
// const DRAGON_WEIGHTS = {
//   stormweaving: 0.175, voidweaving: 0.130,
//   lightforging: 0.120, flamecalling: 0.095,
//   tidecalling:  0.100, soulbinding:  0.090,
// };

// ── AMULETS ──────────────────────────────────────────
//   { id:"ashpendant",     name:"Ashpendant",         slot:"amulet", discipline:"flamecalling",  bonus:0.55, tags:[], desc:"Ember-heart pendant that lets fire reshape rather than destroy" },
//   { id:"stormseye",      name:"Storm's Eye",        slot:"amulet", discipline:"stormweaving",  bonus:1.20, tags:[], desc:"Amulet of perfect calm — the wearer becomes the eye of any storm they call" },
//   { id:"abyssal_pearl",  name:"Abyssal Pearl",      slot:"amulet", discipline:"tidecalling",   bonus:0.75, tags:[], desc:"Pearl from the deepest trench — magnifies water magic tenfold at depth" },
//   { id:"voidheart",      name:"Voidheart",          slot:"amulet", discipline:"voidweaving",   bonus:1.00, tags:[], desc:"Crystallized fragment of true nothingness — unmakes reality around it" },
//   { id:"solcrux",        name:"Solcrux",            slot:"amulet", discipline:"all",  bonus:0.70, tags:[], desc:"Sun-forged crucible worn at the throat — channels blinding radiance" },
//   { id:"dracaldyr",      name:"Dracaldyr",          slot:"amulet", discipline:"soulbinding",   bonus:1.00, tags:[], desc:"Dragon-bone amulet that amplifies willpower to a crushing weight" },
//   { id:"primordial_eye", name:"Primordial Eye",     slot:"amulet", discipline:"all",           bonus:0.70, tags:[], desc:"Ancient artifact of unknown origin — enhances all magical ability" },
//   { id:"echoveil",       name:"Echoveil",           slot:"amulet", discipline:"all",           bonus:0.50, tags:[], desc:"Shimmering veil-pendant that echoes every spell cast through it" },
//   { id:"krythane",       name:"Krythane",           slot:"amulet", discipline:"stormweaving",  bonus:0.65, tags:[], desc:"Stormglass pendant — clouds gather when the wearer raises their voice" },
//   { id:"oblivions_eye",  name:"Oblivion's Eye",     slot:"amulet", discipline:"voidweaving",   bonus:2.20, tags:[], desc:"Obsidian eye of a dead god — erases whatever it gazes upon from existence" },
//   { id:"soulforge_heart", name:"Soulforge Heart",   slot:"amulet", discipline:"soulbinding",   bonus:0.60, tags:[], desc:"Pulsing iron heart that syncs the wearer's will with nearby minds" },
//   { id:"maelstrom_seed", name:"Maelstrom Seed",     slot:"amulet", discipline:"tidecalling",   bonus:2.00, tags:[], desc:"Seed of a primordial ocean storm — unleashes catastrophic tidal force" },
// ];

// const API_BASE = "https://6jmdsp6ama.execute-api.us-east-1.amazonaws.com/prod";
//const API_BASE = "https://rqnfp02u3g.execute-api.us-east-1.amazonaws.com/prod/";
import { useState, useRef, useCallback, useEffect } from "react";

// ── Constants ─────────────────────────────────────────────────────────────────
const GRID_SIZE = 20;
const CANVAS_W = 4000;
const CANVAS_H = 3000;

const ENTITY_COLORS = [
  "#c0392b","#e67e22","#f39c12","#27ae60","#1abc9c",
  "#2980b9","#8e44ad","#e91e63","#d35400","#16a085",
  "#2c3e50","#c2185b","#0288d1","#7b1fa2","#558b2f",
];
const KINGDOM_COLORS = ENTITY_COLORS;
const CHAR_COLORS    = ENTITY_COLORS;
const ARMY_COLORS    = ENTITY_COLORS;
const MAGE_COLORS    = ENTITY_COLORS;
const DRAGON_COLORS  = ENTITY_COLORS;
const DRAGON_SIZES   = ["Wyrmling","Young","Adult","Ancient"];
const MAGE_SCHOOLS   = ["Fire","Ice","Lightning","Necromancy","Arcane","Nature","Blood","Shadow","Holy","Wind"];

const MAGIC_DISCIPLINES = [
  { key:"flamecalling",  label:"Flamecalling",  icon:"🔥", color:"#ef4444", desc:"Raw fire and heat" },
  { key:"stormweaving",  label:"Stormweaving",  icon:"⚡", color:"#3b82f6", desc:"Lightning, wind, pressure" },
  { key:"tidecalling",   label:"Tidecalling",   icon:"🌊", color:"#06b6d4", desc:"Water and ice" },
  { key:"voidweaving",   label:"Voidweaving",   icon:"🌑", color:"#6b21a8", desc:"Darkness, silence, negation" },
  { key:"lightforging",  label:"Lightforging",  icon:"✦",  color:"#eab308", desc:"Radiant energy constructs" },
  { key:"soulbinding",   label:"Soulbinding",   icon:"👁", color:"#be185d", desc:"Will and spirit magic" },
];
const DISCIPLINE_LABELS = ["","Spark","Flicker","Novice","Apprentice","Adept","Channeler","Arcanist","Master","Archon","Mythic","Transcendent","Ascendant"];

// Power formula constants — mages grow steeper, dragons start higher
const MAGE_BASE   = 1.56;
const DRAGON_BASE = 1.45;

const MAGE_WEIGHTS = {
  lightforging: 0.055, voidweaving: 0.055,
  soulbinding:  0.050, stormweaving: 0.045,
  flamecalling: 0.040, tidecalling:  0.035,
};
const DRAGON_WEIGHTS = {
  stormweaving: 0.175, voidweaving: 0.130,
  lightforging: 0.120, flamecalling: 0.095,
  tidecalling:  0.100, soulbinding:  0.090,
};
const PEAK_MULT = 1.60; // Primary affinity bonus — highest discipline gets this multiplier

const CITY_STATUSES  = ["normal","under_attack","besieged"];
const STATUS_COLORS  = { normal:"#22c55e", under_attack:"#f97316", besieged:"#ef4444" };
const STATUS_LABELS  = { normal:"Normal", under_attack:"Under Attack", besieged:"Besieged" };
const SKILL_LABELS   = ["","Rabble","Levy","Militia","Trained","Seasoned","Veteran","Elite","Champion","Legendary","Godlike","Mythic","Transcendent"];

// ── Helpers ───────────────────────────────────────────────────────────────────
const snapToGrid = (x, y) => [Math.round(x / GRID_SIZE) * GRID_SIZE, Math.round(y / GRID_SIZE) * GRID_SIZE];
const coordStr   = (x, y) => `${x},${y}`;
const parseCoord = (s)     => { const [x, y] = s.split(",").map(Number); return { x, y }; };

function distToSegment(px, py, [ax, ay], [bx, by]) {
  const dx = bx - ax, dy = by - ay;
  const lenSq = dx * dx + dy * dy;
  if (lenSq === 0) return Math.hypot(px - ax, py - ay);
  const t = Math.max(0, Math.min(1, ((px - ax) * dx + (py - ay) * dy) / lenSq));
  return Math.hypot(px - (ax + t * dx), py - (ay + t * dy));
}

function pointInPolygon(px, py, polygon) {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i], [xj, yj] = polygon[j];
    if (((yi > py) !== (yj > py)) && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi)
      inside = !inside;
  }
  return inside;
}

// ── API ───────────────────────────────────────────────────────────────────────
const API_BASE = "https://rqnfp02u3g.execute-api.us-east-1.amazonaws.com/prod/";

async function apiGet() {
  const res = await fetch(`${API_BASE}/data`);
  if (!res.ok) throw new Error(`GET failed: ${res.status}`);
  return res.json(); // { kingdoms, cities, characters, armies }
}

async function apiPut(item) {
  // DynamoDB rejects null values — strip them out before sending
  const clean = Object.fromEntries(
    Object.entries(item).filter(([, v]) => v !== null && v !== undefined && v !== "")
  );
  const res = await fetch(`${API_BASE}/data`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ item: clean }),
  });
  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`PUT failed: ${res.status} — ${detail}`);
  }
  return res.json();
}

async function apiDelete(primary_key, sort_key) {
  const res = await fetch(`${API_BASE}/data`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: primary_key, sort_key }),
  });
  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`DELETE failed: ${res.status} — ${detail}`);
  }
  return res.json();
}

// ── Shared UI ─────────────────────────────────────────────────────────────────
const inputStyle = {
  background:"#f9fafb", border:"1px solid #e5e7eb", color:"#111827",
  padding:"5px 8px", borderRadius:5, fontSize:13, outline:"none", width:"100%", boxSizing:"border-box",
};
const selectStyle = { ...inputStyle, cursor:"pointer" };
const mkBtn = (bg) => ({
  background:bg, color:"#fff", border:"none", borderRadius:5,
  padding:"6px 12px", cursor:"pointer", fontSize:13, fontWeight:500, flex:1,
});

function Field({ label, children }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:3 }}>
      <label style={{ fontSize:11, fontWeight:600, color:"#6b7280", letterSpacing:0.5, textTransform:"uppercase" }}>{label}</label>
      {children}
    </div>
  );
}
function FInput(props) { return <input {...props} style={inputStyle} />; }

function Panel({ title, onClose, children }) {
  return (
    <div style={{
      position:"absolute", top:0, right:0, bottom:0, width:300,
      background:"#fff", borderLeft:"1px solid #e5e7eb",
      boxShadow:"-2px 0 12px #0000001a", display:"flex", flexDirection:"column", zIndex:20, overflowY:"auto",
    }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 14px", borderBottom:"1px solid #f3f4f6", flexShrink:0 }}>
        <span style={{ fontWeight:600, fontSize:14, color:"#111827" }}>{title}</span>
        <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:16, color:"#9ca3af" }}>✕</button>
      </div>
      <div style={{ padding:"12px 14px", display:"flex", flexDirection:"column", gap:10 }}>
        {children}
      </div>
    </div>
  );
}

// Computed read-only badge
function Badge({ label, value, color }) {
  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", background:"#f9fafb", border:"1px solid #e5e7eb", borderRadius:5, padding:"4px 8px" }}>
      <span style={{ fontSize:12, color:"#6b7280" }}>{label}</span>
      <span style={{ fontSize:13, fontWeight:600, color: color || "#111827" }}>{value}</span>
    </div>
  );
}

// Artifacts editor for mages and dragons
const ARTIFACT_SLOTS = [
  { key: "crown",  label: "Crown" },
  { key: "weapon", label: "Main Weapon" },
  { key: "dagger", label: "Dagger" },
  { key: "ring",   label: "Ring" },
  { key: "amulet", label: "Amulet" },
  { key: "staff",   label: "Staff" },
  { key: "chain",   label: "Chain / Pendant" },
];

// ── Artifact Catalog ─────────────────────────────────────────────────────────
// discipline: specific key = targets that discipline, "all" = targets all
const ARTIFACT_CATALOG = [
  // ── CROWNS ───────────────────────────────────────────
  { id:"infernalix",     name:"Infernalix",         slot:"crown",  discipline:"flamecalling",  bonus:2.00, tags:[], desc:"Crown of living flame — incinerates the air around the wearer and turns their fire white-hot" },
  { id:"tempest_crown",  name:"Crown of Tempests",  slot:"crown",  discipline:"stormweaving",  bonus:2.20, tags:[], desc:"Crackling diadem that commands all storms within sight — lightning answers to thought alone" },
  { id:"depthcrown",     name:"Abyssal Diadem",     slot:"crown",  discipline:"tidecalling",   bonus:2.00, tags:[], desc:"Crown of deep-trench coral — the ocean itself rises to obey the wearer" },
  { id:"nullcrown",      name:"Crown of Unmaking",  slot:"crown",  discipline:"voidweaving",   bonus:3.20, tags:[], desc:"Crown that exists as a wound in reality — erases anything the wearer wills from existence" },
  { id:"solaris_crown",  name:"Solaris",            slot:"crown",  discipline:"lightforging",  bonus:3.40, tags:[], desc:"Blinding circlet forged from a dying star — constructs of light become permanent and unbreakable" },
  { id:"dominion",       name:"Dominion",           slot:"crown",  discipline:"soulbinding",   bonus:2.80, tags:[], desc:"Iron crown of absolute command — entire armies kneel when the wearer speaks" },
  { id:"crown_of_ages",  name:"Crown of Ages",      slot:"crown",  discipline:"all",           bonus:1.20, tags:[], desc:"Ancient crown worn by the first archmage — amplifies every school of magic equally" },

  // ── WEAPONS ──────────────────────────────────────────
  // Flamecalling
  { id:"caldenvyr",      name:"Caldenvyr",          slot:"weapon", discipline:"flamecalling",  bonus:1.40, tags:[], desc:"Volcanic greatsword that drinks fire and spits it back threefold" },
  { id:"pyrewrath",      name:"Pyrewrath",          slot:"weapon", discipline:"flamecalling",  bonus:0.65, tags:[], desc:"Blackened staff crowned with an ever-burning ember" },
  // Stormweaving
  { id:"khorathis",      name:"Khorathis",          slot:"weapon", discipline:"stormweaving",  bonus:1.80, tags:[], desc:"Spear of living lightning, thrown and recalled by will alone" },
  { id:"galecleaver",    name:"Galecleaver",        slot:"weapon", discipline:"stormweaving",  bonus:0.65, tags:[], desc:"Twin-bladed glaive that screams with compressed wind" },
  {id:"stormbreaker",    name:"Stormbreaker",        slot:"weapon", discipline:"stormweaving",  bonus:1.50, tags:[], desc:"Twin-bladed glaive that screams with compressed wind"},
  // Tidecalling
  { id:"nythirel",       name:"Nythirel",           slot:"weapon", discipline:"tidecalling",   bonus:0.80, tags:[], desc:"Trident forged from deep-sea ice that never melts" },
  { id:"tidesunder",     name:"Tidesunder",         slot:"weapon", discipline:"tidecalling",   bonus:0.55, tags:[], desc:"Curved blade that trails saltwater mist" },
  // Voidweaving
  { id:"drevnahkar",     name:"Drevnahkar",         slot:"weapon", discipline:"voidweaving",   bonus:2.50, tags:[], desc:"Sword of absolute darkness — wounds it makes cannot heal by magic" },
  { id:"voidripper",     name:"Voidripper",         slot:"weapon", discipline:"voidweaving",   bonus:1.20, tags:[], desc:"Serrated blade that cuts through wards and barriers like cloth" },
  // Lightforging
  { id:"Lightbringer",       name:"Lightbringer",    slot:"weapon", discipline:"lightforging",  bonus:3.50, tags:[], desc:"Radiant lance that burns hotter the more magic it absorbs" },
  { id:"dawnbreaker",    name:"Dawnshatter",        slot:"weapon", discipline:"lightforging",  bonus:1.20, tags:[], desc:"Crystalline mace that detonates with stored sunlight on impact" },
  { id:"goldryn",    name:"Goldryn",        slot:"weapon", discipline:"lightforging",  bonus:1.50, tags:[], desc:"Crystalline sword that detonates with stored sunlight on impact" },
  // Soulbinding
  { id:"valdryss",       name:"Valdryss",           slot:"weapon", discipline:"soulbinding",   bonus:1.20, tags:[], desc:"Whispering staff — those who hear it lose the will to fight" },
  { id:"willbreaker",    name:"Willbreaker",        slot:"weapon", discipline:"soulbinding",   bonus:0.75, tags:[], desc:"Iron scepter that paralyzes weaker minds on sight" },
  // All
  { id:"aetherall",      name:"Aetherall",          slot:"weapon", discipline:"all",           bonus:0.60, tags:[], desc:"Ethereal blade that resonates with all schools of magic" },
  { id:"ruinwalker",     name:"Ruinwalker",         slot:"weapon", discipline:"all",           bonus:0.55, tags:[], desc:"Ancient glaive recovered from a god-war battlefield" },
  { id:"godsplinter",    name:"Godsplinter",        slot:"weapon", discipline:"all",           bonus:0.80, tags:[], desc:"Fragment of a divine weapon — warps reality in the hands of any caster" },
   {id:"Aetheryn",    name:"Aetheryn",        slot:"weapon", discipline:"all",           bonus:1.40, tags:[], desc:"Fragment of a divine weapon — warps reality in the hands of any caster" },

  // ── DAGGERS ──────────────────────────────────────────
  { id:"emberfang",      name:"Emberfang",          slot:"dagger", discipline:"flamecalling",  bonus:0.70, tags:[], desc:"Dagger that ignites anything it pierces from the inside" },
  { id:"boltfang",       name:"Boltfang",           slot:"dagger", discipline:"stormweaving",  bonus:0.55, tags:[], desc:"Crackling knife that arcs lightning between wounds" },
  { id:"frostpiercer",   name:"Frostpiercer",       slot:"dagger", discipline:"tidecalling",   bonus:0.60, tags:[], desc:"Ice-crystal stiletto — shatters inside the target" },
  { id:"nulledge",       name:"Nulledge",           slot:"dagger", discipline:"voidweaving",   bonus:0.55, tags:[], desc:"Dagger that severs the target's connection to magic" },
  { id:"gleamfang",      name:"Gleamfang",          slot:"dagger", discipline:"lightforging",  bonus:0.70, tags:[], desc:"Blade of condensed light that blinds on the draw" },
  { id:"dreadeater",     name:"Souleater",          slot:"dagger", discipline:"soulbinding",   bonus:1.80, tags:[], desc:"Feeds on the target's fear, growing sharper with terror" },
  { id:"flickerblade",   name:"Flickerblade",       slot:"dagger", discipline:"all",           bonus:0.50, tags:[], desc:"Phase-shifting dagger — exists in two planes at once" },
  { id:"venomthorn",     name:"Venomthorn",         slot:"dagger", discipline:"tidecalling",   bonus:1.10, tags:[], desc:"Coral dagger laced with abyssal toxin — wounds weep saltwater" },
  { id:"hexfang",        name:"Hexfang",            slot:"dagger", discipline:"soulbinding",   bonus:0.60, tags:[], desc:"Cursed fang that plants suggestions in the stabbed" },
  { id:"sparkpiercer",   name:"Sparkpiercer",       slot:"dagger", discipline:"stormweaving",  bonus:1.30, tags:[], desc:"Needle-thin blade that calls a thunderclap on every strike" },

  // ── RINGS ────────────────────────────────────────────
  { id:"cinderband",     name:"Cinderband",         slot:"ring",   discipline:"flamecalling",  bonus:0.55, tags:[], desc:"Molten ring that shields the wearer from their own flames" },
  { id:"tempestloop",    name:"Tempestloop",        slot:"ring",   discipline:"stormweaving",  bonus:0.55, tags:[], desc:"Coiled lightning frozen in silver — quickens casting" },
  { id:"depthsignet",    name:"Depthsignet",        slot:"ring",   discipline:"tidecalling",   bonus:0.55, tags:[], desc:"Deep-ocean signet that lets the wearer breathe and cast underwater" },
  { id:"wraithstone",    name:"Wraithstone",        slot:"ring",   discipline:"voidweaving",   bonus:0.65, tags:[], desc:"Ring of compressed absence — makes the wearer hard to perceive" },
  { id:"paldoras_gem",   name:"Paldora's Gem",      slot:"ring",   discipline:"lightforging",  bonus:2.00, tags:[], desc:"Legendary gem that amplifies radiant constructs beyond mortal limits" },
  { id:"thrallring",     name:"Thrallring",         slot:"ring",   discipline:"soulbinding",   bonus:0.70, tags:[], desc:"Iron ring that extends the wearer's domination range" },
  { id:"starstone",      name:"Starstone",          slot:"ring",   discipline:"all",           bonus:0.60, tags:[], desc:"Fallen star fragment — hums with raw universal power" },
  { id:"convergence",    name:"Convergence",        slot:"ring",   discipline:"all",           bonus:0.50, tags:[], desc:"Ring forged where six ley lines cross" },
  { id:"ashenveil_band", name:"Ashenveil Band",     slot:"ring",   discipline:"voidweaving",   bonus:1.40, tags:[], desc:"Ring that cloaks the wearer's magic in silence — spells arrive without warning" },
  { id:"pyralis",        name:"Pyralis",            slot:"ring",   discipline:"flamecalling",  bonus:1.30, tags:[], desc:"White-hot band that lets the wearer shape magma with thought alone" },
  { id:"tidewalkers_loop", name:"Tidewalker's Loop", slot:"ring",  discipline:"tidecalling",   bonus:1.00, tags:[], desc:"Ancient mariner's ring — commands currents across vast distances" },

  // ── AMULETS ──────────────────────────────────────────
  { id:"ashpendant",     name:"Ashpendant",         slot:"amulet", discipline:"flamecalling",  bonus:0.55, tags:[], desc:"Ember-heart pendant that lets fire reshape rather than destroy" },
  { id:"stormseye",      name:"Storm's Eye",        slot:"amulet", discipline:"stormweaving",  bonus:1.20, tags:[], desc:"Amulet of perfect calm — the wearer becomes the eye of any storm they call" },
  { id:"abyssal_pearl",  name:"Abyssal Pearl",      slot:"amulet", discipline:"tidecalling",   bonus:0.75, tags:[], desc:"Pearl from the deepest trench — magnifies water magic tenfold at depth" },
  { id:"voidheart",      name:"Voidheart",          slot:"amulet", discipline:"voidweaving",   bonus:1.00, tags:[], desc:"Crystallized fragment of true nothingness — unmakes reality around it" },
  { id:"solcrux",        name:"Solcrux",            slot:"amulet", discipline:"all",  bonus:0.70, tags:[], desc:"Sun-forged crucible worn at the throat — channels blinding radiance" },
  { id:"dracaldyr",      name:"Dracaldyr",          slot:"amulet", discipline:"soulbinding",   bonus:1.00, tags:[], desc:"Dragon-bone amulet that amplifies willpower to a crushing weight" },
  { id:"primordial_eye", name:"Primordial Eye",     slot:"amulet", discipline:"all",           bonus:0.70, tags:[], desc:"Ancient artifact of unknown origin — enhances all magical ability" },
  { id:"echoveil",       name:"Echoveil",           slot:"amulet", discipline:"all",           bonus:0.50, tags:[], desc:"Shimmering veil-pendant that echoes every spell cast through it" },
  { id:"krythane",       name:"Krythane",           slot:"amulet", discipline:"stormweaving",  bonus:0.65, tags:[], desc:"Stormglass pendant — clouds gather when the wearer raises their voice" },
  { id:"oblivions_eye",  name:"Oblivion's Eye",     slot:"amulet", discipline:"voidweaving",   bonus:2.20, tags:[], desc:"Obsidian eye of a dead god — erases whatever it gazes upon from existence" },
  { id:"soulforge_heart", name:"Soulforge Heart",   slot:"amulet", discipline:"soulbinding",   bonus:0.60, tags:[], desc:"Pulsing iron heart that syncs the wearer's will with nearby minds" },
  { id:"maelstrom_seed", name:"Maelstrom Seed",     slot:"amulet", discipline:"tidecalling",   bonus:2.00, tags:[], desc:"Seed of a primordial ocean storm — unleashes catastrophic tidal force" },

  // ── NEW WEAPONS ────────────────────────────────────────
  { id:"scorchbrand",    name:"Scorchbrand",        slot:"weapon", discipline:"flamecalling",  bonus:0.85, tags:[], desc:"Longsword that superheats the air in its wake — swings leave trails of fire" },
  { id:"galvanyss",      name:"Galvanyss",          slot:"weapon", discipline:"stormweaving",  bonus:0.80, tags:[], desc:"Javelin of galvanized steel — calls down a bolt from clear sky on impact" },
  { id:"riptide",        name:"Riptide",            slot:"weapon", discipline:"tidecalling",   bonus:0.70, tags:[], desc:"Curved cutlass that drags enemies into phantom undertow" },
  { id:"hollowfang",     name:"Hollowfang",         slot:"weapon", discipline:"voidweaving",   bonus:0.90, tags:[], desc:"Rapier with no shadow — its strikes leave wounds that forget how to close" },
  { id:"dawnpiercer",    name:"Dawnpiercer",        slot:"weapon", discipline:"lightforging",  bonus:0.75, tags:[], desc:"Spear of crystallized dawn — explodes with radiance when thrown" },
  { id:"thrallbane",     name:"Thrallbane",         slot:"weapon", discipline:"soulbinding",   bonus:0.85, tags:[], desc:"Flail whose chains rattle inside the enemy's mind, not their ears" },

  // ── NEW DAGGERS ────────────────────────────────────────
  { id:"kindlefang",     name:"Kindlefang",         slot:"dagger", discipline:"flamecalling",  bonus:0.55, tags:[], desc:"Tiny blade that plants a slow-burning ember in whatever it cuts" },
  { id:"staticshiv",     name:"Staticshiv",         slot:"dagger", discipline:"stormweaving",  bonus:0.65, tags:[], desc:"Dagger wreathed in static — numbs nerves on contact" },
  { id:"sleetfang",      name:"Sleetfang",          slot:"dagger", discipline:"tidecalling",   bonus:0.50, tags:[], desc:"Ice dagger that reforms itself after shattering inside a wound" },
  { id:"umbrafang",      name:"Umbrafang",          slot:"dagger", discipline:"voidweaving",   bonus:0.75, tags:[], desc:"Blade forged from the shadow of a dying star — cuts through warded flesh" },
  { id:"prismfang",      name:"Prismfang",          slot:"dagger", discipline:"lightforging",  bonus:0.60, tags:[], desc:"Glass dagger that splits light into searing beams on impact" },
  { id:"mindthorn",      name:"Mindthorn",          slot:"dagger", discipline:"soulbinding",   bonus:0.70, tags:[], desc:"Thorn-shaped blade — victims hear whispers for days after being cut" },

  // ── NEW RINGS ──────────────────────────────────────────
  { id:"magmacore",      name:"Magmacore",          slot:"ring",   discipline:"flamecalling",  bonus:0.70, tags:[], desc:"Ring with a molten core — the wearer's flames burn through magical shields" },
  { id:"cyclone_band",   name:"Cyclone Band",       slot:"ring",   discipline:"stormweaving",  bonus:0.75, tags:[], desc:"Wind-carved ring that lets the wearer redirect any incoming projectile" },
  { id:"glacial_seal",   name:"Glacial Seal",       slot:"ring",   discipline:"tidecalling",   bonus:0.65, tags:[], desc:"Frozen signet that flash-freezes anything the wearer touches" },
  { id:"eclipse_band",   name:"Eclipse Band",       slot:"ring",   discipline:"voidweaving",   bonus:0.80, tags:[], desc:"Ring of perpetual eclipse — nearby light sources dim and flicker" },
  { id:"haloband",       name:"Haloband",           slot:"ring",   discipline:"lightforging",  bonus:0.60, tags:[], desc:"Ring that projects a faint protective halo — absorbs minor attacks" },
  { id:"puppet_loop",    name:"Puppet Loop",        slot:"ring",   discipline:"soulbinding",   bonus:0.90, tags:[], desc:"Twisted iron loop — lets the wearer puppet a single weak-willed target" },

  // ── NEW AMULETS ────────────────────────────────────────
  { id:"cinder_heart",   name:"Cinder Heart",       slot:"amulet", discipline:"flamecalling",  bonus:0.80, tags:[], desc:"Smoldering pendant that converts the wearer's rage into hotter flame" },
  { id:"thunderveil",    name:"Thunderveil",        slot:"amulet", discipline:"stormweaving",  bonus:0.70, tags:[], desc:"Pendant that wraps the wearer in rolling thunder — disorients nearby enemies" },
  { id:"tidecaller_pearl", name:"Tidecaller's Pearl", slot:"amulet", discipline:"tidecalling", bonus:0.60, tags:[], desc:"Pearl that hums near water — amplifies casting when rain falls" },
  { id:"nihil_pendant",  name:"Nihil Pendant",      slot:"amulet", discipline:"voidweaving",   bonus:0.85, tags:[], desc:"Pendant of compressed nothing — negates the first spell that hits the wearer" },
  { id:"radiant_focus",  name:"Radiant Focus",      slot:"amulet", discipline:"lightforging",  bonus:0.95, tags:[], desc:"Lens-shaped amulet that focuses scattered light into a devastating beam" },
  { id:"dominus_chain",  name:"Dominus Chain",      slot:"amulet", discipline:"soulbinding",   bonus:0.75, tags:[], desc:"Chain of linked iron wills — extends domination to groups instead of individuals" },

  // ── STAVES ───────────────────────────────────────────
  // Flamecalling
  { id:"infernal_crook",  name:"Infernal Crook",     slot:"staff", discipline:"flamecalling",  bonus:1.10, tags:[], desc:"Crooked iron staff that vents gouts of flame from cracks along its length" },
  { id:"ashen_focus",     name:"Ashen Focus",        slot:"staff", discipline:"flamecalling",  bonus:0.60, tags:[], desc:"Charred oak rod — channels fire without burning the caster's hands" },
  { id:"pyre_conduit",    name:"Pyre Conduit",       slot:"staff", discipline:"flamecalling",  bonus:1.80, tags:[], desc:"Staff forged in a volcanic vent — turns any spark into an inferno" },
  // Stormweaving
  { id:"tempest_rod",     name:"Tempest Rod",        slot:"staff", discipline:"stormweaving",  bonus:1.00, tags:[], desc:"Copper-wound staff that hums with stored static — discharges on command" },
  { id:"zephyr_cane",     name:"Zephyr Cane",        slot:"staff", discipline:"stormweaving",  bonus:0.55, tags:[], desc:"Lightweight cane carved from windwood — amplifies gale-force casting" },
  { id:"thunderspine",    name:"Thunderspine",       slot:"staff", discipline:"stormweaving",  bonus:1.70, tags:[], desc:"Staff carved from a tree struck by lightning a thousand times — every spell thunders" },
  // Tidecalling
  { id:"deepcurrent",     name:"Deepcurrent",        slot:"staff", discipline:"tidecalling",   bonus:0.90, tags:[], desc:"Driftwood staff from the abyssal floor — water obeys it like a conductor's baton" },
  { id:"mistweaver",      name:"Mistweaver",         slot:"staff", discipline:"tidecalling",   bonus:0.55, tags:[], desc:"Staff that exhales perpetual fog — obscures and chills everything nearby" },
  { id:"leviathan_spine", name:"Leviathan Spine",    slot:"staff", discipline:"tidecalling",   bonus:2.00, tags:[], desc:"Spine of an ancient sea beast — commands tidal waves and frozen storms alike" },
  // Voidweaving
  { id:"nihilstaff",      name:"Nihilstaff",         slot:"staff", discipline:"voidweaving",   bonus:1.50, tags:[], desc:"Staff that consumes light around it — spells cast through it arrive as pure negation" },
  { id:"duskrod",         name:"Duskrod",            slot:"staff", discipline:"voidweaving",   bonus:0.65, tags:[], desc:"Rod carved from petrified shadow — muffles all sound near the caster" },
  { id:"entropy_spire",   name:"Entropy Spire",      slot:"staff", discipline:"voidweaving",   bonus:1.90, tags:[], desc:"Staff that accelerates decay — anything it points at begins to unmake itself" },
  // Lightforging
  { id:"sunspire",        name:"Sunspire",           slot:"staff", discipline:"lightforging",  bonus:1.40, tags:[], desc:"Crystal spire that drinks sunlight and releases it as searing beams" },
  { id:"glowstaff",       name:"Glowstaff",          slot:"staff", discipline:"lightforging",  bonus:0.60, tags:[], desc:"Pale staff that steadily brightens — constructs cast through it last longer" },
  { id:"divine_focus",    name:"Divine Focus",       slot:"staff", discipline:"lightforging",  bonus:2.00, tags:[], desc:"Staff of pure condensed radiance — said to be a fragment of the sun itself" },
  // Soulbinding
  { id:"tyrants_rod",     name:"Tyrant's Rod",       slot:"staff", discipline:"soulbinding",   bonus:1.20, tags:[], desc:"Black iron rod of ancient tyrant-kings — amplifies domination at range" },
  { id:"murmur_staff",    name:"Murmur Staff",       slot:"staff", discipline:"soulbinding",   bonus:0.55, tags:[], desc:"Staff that whispers to anyone nearby — plants doubt and obedience" },
  { id:"overlord_spire",  name:"Overlord Spire",     slot:"staff", discipline:"soulbinding",   bonus:1.60, tags:[], desc:"Obsidian spire that broadcasts the wielder's will across an entire battlefield" },
  // All
  { id:"arcanum_spire",   name:"Arcanum Spire",      slot:"staff", discipline:"all",           bonus:0.80, tags:[], desc:"Six-faceted crystal staff — resonates with all schools simultaneously" },
  { id:"wanderers_crook", name:"Wanderer's Crook",   slot:"staff", discipline:"all",           bonus:0.50, tags:[], desc:"Ancient traveler's staff — boosts whatever magic the wielder needs most" },
  { id:"worldstaff",      name:"Worldstaff",         slot:"staff", discipline:"all",           bonus:1.50, tags:[], desc:"Staff grown from the roots of the World Tree — amplifies all magic equally" },

  // ── CHAINS / PENDANTS ────────────────────────────────
  // Flamecalling
  { id:"ember_chain",     name:"Ember Chain",        slot:"chain", discipline:"flamecalling",  bonus:0.75, tags:[], desc:"Smoldering chain links that heat up as the wearer casts — fire feeds fire" },
  { id:"kindlethread",    name:"Kindlethread",       slot:"chain", discipline:"flamecalling",  bonus:0.50, tags:[], desc:"Thin gold thread necklace with a flickering bead — steadies flame control" },
  { id:"pyroheart_links", name:"Pyroheart Links",    slot:"chain", discipline:"flamecalling",  bonus:0.95, tags:[], desc:"Chain of dragon-scale links — each one holds a captive ember waiting to ignite" },
  // Stormweaving
  { id:"stormlink",       name:"Stormlink",          slot:"chain", discipline:"stormweaving",  bonus:0.80, tags:[], desc:"Chain of alternating copper and silver — acts as a lightning rod for spellwork" },
  { id:"staticweave",     name:"Staticweave",        slot:"chain", discipline:"stormweaving",  bonus:0.50, tags:[], desc:"Braided wire pendant that crackles faintly — sharpens storm reflexes" },
  { id:"galvanic_beads",  name:"Galvanic Beads",     slot:"chain", discipline:"stormweaving",  bonus:1.00, tags:[], desc:"Beads of charged lodestone — each one a tiny capacitor for lightning magic" },
  // Tidecalling
  { id:"tidalchain",      name:"Tidal Chain",        slot:"chain", discipline:"tidecalling",   bonus:0.70, tags:[], desc:"Chain of ocean-smoothed links that drip phantom seawater" },
  { id:"frostthread",     name:"Frostthread",        slot:"chain", discipline:"tidecalling",   bonus:0.50, tags:[], desc:"Thin ice-crystal chain that never melts — steadies water magic at range" },
  { id:"deep_current_beads", name:"Deep Current Beads", slot:"chain", discipline:"tidecalling", bonus:0.90, tags:[], desc:"Beads carved from deep-sea pressure stone — amplify tidal magic exponentially with depth" },
  // Voidweaving
  { id:"voidlink",        name:"Voidlink",           slot:"chain", discipline:"voidweaving",   bonus:0.90, tags:[], desc:"Chain whose links are gaps in reality — each one a tiny pocket of nothing" },
  { id:"shadowthread",    name:"Shadowthread",       slot:"chain", discipline:"voidweaving",   bonus:0.55, tags:[], desc:"Thread of woven darkness — makes the wearer's void magic harder to detect" },
  { id:"null_beads",      name:"Null Beads",         slot:"chain", discipline:"voidweaving",   bonus:1.00, tags:[], desc:"Prayer beads of compressed absence — each one silences a different sense" },
  // Lightforging
  { id:"radiant_chain",   name:"Radiant Chain",      slot:"chain", discipline:"lightforging",  bonus:0.85, tags:[], desc:"Golden chain that glows brighter with each spell — stores excess radiance" },
  { id:"gleamthread",     name:"Gleamthread",        slot:"chain", discipline:"lightforging",  bonus:0.50, tags:[], desc:"Delicate luminous thread — steadies light constructs against disruption" },
  { id:"prismatic_links", name:"Prismatic Links",    slot:"chain", discipline:"lightforging",  bonus:1.00, tags:[], desc:"Chain that splits white light into six colors — each link amplifies a different wavelength" },
  // Soulbinding
  { id:"binding_chain",   name:"Binding Chain",      slot:"chain", discipline:"soulbinding",   bonus:1.00, tags:[], desc:"Heavy iron chain worn as a collar — the wearer's will becomes inescapable" },
  { id:"whisperthread",   name:"Whisperthread",      slot:"chain", discipline:"soulbinding",   bonus:0.55, tags:[], desc:"Nearly invisible thread pendant — plants subconscious suggestions in listeners" },
  { id:"thrall_beads",    name:"Thrall Beads",       slot:"chain", discipline:"soulbinding",   bonus:0.80, tags:[], desc:"Beads carved from bone — each one represents a mind the wearer can touch" },
  // All
  { id:"leyline_chain",   name:"Leyline Chain",      slot:"chain", discipline:"all",           bonus:0.65, tags:[], desc:"Chain aligned to natural ley lines — passively enhances all magic nearby" },
  { id:"resonance_beads", name:"Resonance Beads",    slot:"chain", discipline:"all",           bonus:0.50, tags:[], desc:"Prayer beads carved from six different magical stones — one for each discipline" },
  { id:"harmonic_links",  name:"Harmonic Links",     slot:"chain", discipline:"all",           bonus:0.85, tags:[], desc:"Chain that vibrates at the resonant frequency of raw magic — boosts all casting" },

  // ── NEW WEAPONS ────────────────────────────────────────
  { id:"blazekeeper",    name:"Blazekeeper",        slot:"weapon", discipline:"flamecalling",  bonus:0.95, tags:[], desc:"Greatsword with a furnace core — heats to white-hot in the wielder's grip" },
  { id:"inferno_edge",   name:"Inferno Edge",       slot:"weapon", discipline:"flamecalling",  bonus:0.55, tags:[], desc:"Short sword that leaves cauterized wounds — flames linger where it cuts" },
  { id:"stormfury",      name:"Stormfury",          slot:"weapon", discipline:"stormweaving",  bonus:0.75, tags:[], desc:"Warhammer that cracks the air on every swing — thunder follows impact" },
  { id:"arc_lance",      name:"Arc Lance",          slot:"weapon", discipline:"stormweaving",  bonus:0.50, tags:[], desc:"Long lance that arcs electricity between wielder and target" },
  { id:"maelstrom_fang", name:"Maelstrom Fang",     slot:"weapon", discipline:"tidecalling",   bonus:0.90, tags:[], desc:"Harpoon carved from kraken tooth — calls whirlpools wherever it strikes" },
  { id:"brine_edge",     name:"Brine Edge",         slot:"weapon", discipline:"tidecalling",   bonus:0.60, tags:[], desc:"Salt-crusted blade that corrodes armor and wards alike" },
  { id:"abyssal_edge",   name:"Abyssal Edge",       slot:"weapon", discipline:"voidweaving",   bonus:0.70, tags:[], desc:"Sword with a blade of compressed darkness — hums with hungry silence" },
  { id:"entropic_glaive", name:"Entropic Glaive",   slot:"weapon", discipline:"voidweaving",   bonus:0.55, tags:[], desc:"Polearm that accelerates decay in whatever it touches" },
  { id:"novastaff",      name:"Novastaff",          slot:"weapon", discipline:"lightforging",  bonus:0.85, tags:[], desc:"Staff-blade hybrid that channels sunbursts through its cutting edge" },
  { id:"prism_blade",    name:"Prism Blade",        slot:"weapon", discipline:"lightforging",  bonus:0.55, tags:[], desc:"Translucent sword that refracts incoming spells into scattered light" },
  { id:"dominion_blade",  name:"Dominion Blade",    slot:"weapon", discipline:"soulbinding",   bonus:0.65, tags:[], desc:"Sword that cuts will, not flesh — victims become docile after a single wound" },
  { id:"subjugator",     name:"Subjugator",         slot:"weapon", discipline:"soulbinding",   bonus:0.90, tags:[], desc:"Mace wreathed in psychic pressure — nearby enemies fight sluggishly" },

  // ── NEW DAGGERS ────────────────────────────────────────
  { id:"flashburn",      name:"Flashburn",          slot:"dagger", discipline:"flamecalling",  bonus:0.80, tags:[], desc:"Dagger that detonates a flash of fire on the first stab — one devastating strike" },
  { id:"smolder_fang",   name:"Smolder Fang",       slot:"dagger", discipline:"flamecalling",  bonus:0.50, tags:[], desc:"Small blade that leaves smoldering wounds — damage builds over time" },
  { id:"voltpick",       name:"Voltpick",           slot:"dagger", discipline:"stormweaving",  bonus:0.75, tags:[], desc:"Needle-thin dagger that delivers a paralyzing jolt on contact" },
  { id:"galeknife",      name:"Galeknife",          slot:"dagger", discipline:"stormweaving",  bonus:0.50, tags:[], desc:"Blade so light it whistles — throws gusts of cutting wind with each slash" },
  { id:"rime_stiletto",  name:"Rime Stiletto",      slot:"dagger", discipline:"tidecalling",   bonus:0.70, tags:[], desc:"Stiletto of permanent frost — freezes blood on contact" },
  { id:"coral_fang",     name:"Coral Fang",         slot:"dagger", discipline:"tidecalling",   bonus:0.50, tags:[], desc:"Dagger grown from living coral — injects saltwater into wounds" },
  { id:"erasure",        name:"Erasure",            slot:"dagger", discipline:"voidweaving",   bonus:0.85, tags:[], desc:"Dagger that removes what it cuts from memory — victims forget the wound exists" },
  { id:"dim_edge",       name:"Dim Edge",           slot:"dagger", discipline:"voidweaving",   bonus:0.50, tags:[], desc:"Blade that drinks nearby light — attacks arrive from perceived darkness" },
  { id:"solarshard",     name:"Solarshard",         slot:"dagger", discipline:"lightforging",  bonus:0.90, tags:[], desc:"Crystallized sunlight shaped into a blade — blinds and burns simultaneously" },
  { id:"glintknife",     name:"Glintknife",         slot:"dagger", discipline:"lightforging",  bonus:0.50, tags:[], desc:"Tiny reflective blade — redirects light constructs with surgical precision" },
  { id:"coercion_fang",  name:"Coercion Fang",      slot:"dagger", discipline:"soulbinding",   bonus:0.80, tags:[], desc:"Blade laced with psychic venom — victims obey the next command they hear" },
  { id:"docility_spike", name:"Docility Spike",     slot:"dagger", discipline:"soulbinding",   bonus:0.50, tags:[], desc:"Iron spike that dampens aggression — stabbed targets lose the will to resist" },

  // ── NEW RINGS ──────────────────────────────────────────
  { id:"inferno_loop",   name:"Inferno Loop",       slot:"ring",   discipline:"flamecalling",  bonus:0.85, tags:[], desc:"Ring of perpetual combustion — the wearer's fire ignores magical resistance" },
  { id:"spark_band",     name:"Spark Band",         slot:"ring",   discipline:"flamecalling",  bonus:0.50, tags:[], desc:"Simple copper band that warms to the touch — steadies volatile flamecalling" },
  { id:"arc_ring",       name:"Arc Ring",           slot:"ring",   discipline:"stormweaving",  bonus:0.90, tags:[], desc:"Ring that arcs tiny bolts between fingers — speeds up lightning incantations" },
  { id:"breeze_loop",    name:"Breeze Loop",        slot:"ring",   discipline:"stormweaving",  bonus:0.50, tags:[], desc:"Silver ring that hums in wind — attunes the wearer to air pressure shifts" },
  { id:"undertow_band",  name:"Undertow Band",      slot:"ring",   discipline:"tidecalling",   bonus:0.80, tags:[], desc:"Ring that pulls moisture from the air — never far from usable water" },
  { id:"dewdrop_ring",   name:"Dewdrop Ring",       slot:"ring",   discipline:"tidecalling",   bonus:0.50, tags:[], desc:"Ring with a single perpetual dewdrop — focuses small-scale water shaping" },
  { id:"absence_ring",   name:"Absence Ring",       slot:"ring",   discipline:"voidweaving",   bonus:0.70, tags:[], desc:"Ring that casts no shadow — the wearer's void spells cost less effort" },
  { id:"dim_band",       name:"Dim Band",           slot:"ring",   discipline:"voidweaving",   bonus:0.50, tags:[], desc:"Dull iron band that absorbs ambient light — fuels minor void effects" },
  { id:"brilliance_ring", name:"Brilliance Ring",   slot:"ring",   discipline:"lightforging",  bonus:0.75, tags:[], desc:"Diamond ring that stores sunlight — releases it as a protective flash" },
  { id:"glimmer_band",   name:"Glimmer Band",       slot:"ring",   discipline:"lightforging",  bonus:0.50, tags:[], desc:"Faintly glowing ring — extends the duration of light constructs" },
  { id:"authority_ring",  name:"Authority Ring",     slot:"ring",   discipline:"soulbinding",   bonus:0.85, tags:[], desc:"Iron signet ring of command — eye contact through it compels obedience" },
  { id:"calm_band",      name:"Calm Band",          slot:"ring",   discipline:"soulbinding",   bonus:0.50, tags:[], desc:"Smooth stone ring — radiates a calming aura that softens resistance" },

  // ── NEW AMULETS ────────────────────────────────────────
  { id:"conflagration_eye", name:"Conflagration Eye", slot:"amulet", discipline:"flamecalling", bonus:0.90, tags:[], desc:"Ruby eye pendant — lets the wearer see through their own flames" },
  { id:"warmth_pendant",  name:"Warmth Pendant",     slot:"amulet", discipline:"flamecalling",  bonus:0.50, tags:[], desc:"Small ember pendant — keeps fire spells stable in rain and wind" },
  { id:"tempest_heart",   name:"Tempest Heart",      slot:"amulet", discipline:"stormweaving",  bonus:0.85, tags:[], desc:"Pendant containing a trapped micro-storm — caster draws power from it mid-fight" },
  { id:"breeze_charm",    name:"Breeze Charm",       slot:"amulet", discipline:"stormweaving",  bonus:0.50, tags:[], desc:"Feather pendant that hums in high wind — helps time storm spells precisely" },
  { id:"drowned_eye",     name:"Drowned Eye",        slot:"amulet", discipline:"tidecalling",   bonus:0.80, tags:[], desc:"Eye-shaped pendant filled with seawater — the wearer senses all nearby water" },
  { id:"rime_pendant",    name:"Rime Pendant",       slot:"amulet", discipline:"tidecalling",   bonus:0.50, tags:[], desc:"Frost-rimed pendant — keeps ice constructs from melting in warm climates" },
  { id:"abyss_locket",    name:"Abyss Locket",       slot:"amulet", discipline:"voidweaving",   bonus:0.75, tags:[], desc:"Locket that contains a sliver of true void — opens to release silence and darkness" },
  { id:"shade_pendant",   name:"Shade Pendant",      slot:"amulet", discipline:"voidweaving",   bonus:0.50, tags:[], desc:"Pendant carved from darkite — the wearer blends into shadows effortlessly" },
  { id:"solar_locket",    name:"Solar Locket",       slot:"amulet", discipline:"lightforging",  bonus:0.80, tags:[], desc:"Locket that stores hours of sunlight — can release it all in a single blinding pulse" },
  { id:"dawn_charm",      name:"Dawn Charm",         slot:"amulet", discipline:"lightforging",  bonus:0.50, tags:[], desc:"Small sun-shaped charm — light constructs require less concentration" },
  { id:"will_eater",      name:"Will Eater",         slot:"amulet", discipline:"soulbinding",   bonus:0.90, tags:[], desc:"Fanged pendant that feeds on broken wills — grows stronger with each mind subjugated" },
  { id:"serenity_charm",  name:"Serenity Charm",     slot:"amulet", discipline:"soulbinding",   bonus:0.50, tags:[], desc:"Smooth jade pendant — radiates false peace, making targets lower their guard" },

  // ── LIGHTFORGING 100-120% ──────────────────────────────
  { id:"radiant_cleaver", name:"Radiant Cleaver",    slot:"weapon", discipline:"lightforging",  bonus:1.10, tags:[], desc:"Greataxe of solidified light — cleaves through magical barriers like paper" },
  { id:"lumin_shard",     name:"Lumin Shard",        slot:"dagger", discipline:"lightforging",  bonus:1.00, tags:[], desc:"Dagger carved from a dying star's core — stabs leave permanent light wounds" },
  { id:"corona_ring",     name:"Corona Ring",        slot:"ring",   discipline:"lightforging",  bonus:1.10, tags:[], desc:"Ring surrounded by a miniature corona — the wearer's constructs burn on contact" },
  { id:"zenith_pendant",  name:"Zenith Pendant",     slot:"amulet", discipline:"lightforging",  bonus:1.00, tags:[], desc:"Pendant that channels noon sunlight regardless of time — always at peak radiance" },
  { id:"beacon_spire",    name:"Beacon Spire",       slot:"staff",  discipline:"lightforging",  bonus:1.20, tags:[], desc:"Staff that acts as a lighthouse for magic — draws radiant energy from miles away" },
  { id:"luminary_links",  name:"Luminary Links",     slot:"chain",  discipline:"lightforging",  bonus:1.00, tags:[], desc:"Chain of tiny suns — each link stores a day's worth of concentrated light" },

  // ── LIGHTFORGING 160-180% ──────────────────────────────
  { id:"godray",          name:"Godray",             slot:"weapon", discipline:"lightforging",  bonus:1.80, tags:[], desc:"Blade of divine radiance — anything it cuts turns to ash and light" },
  { id:"starfall_fang",   name:"Starfall Fang",      slot:"dagger", discipline:"lightforging",  bonus:1.60, tags:[], desc:"Dagger forged from a meteorite's heart — stabs release miniature supernovae" },
  { id:"eternal_halo",    name:"Eternal Halo",       slot:"ring",   discipline:"lightforging",  bonus:1.70, tags:[], desc:"Ring that crowns the wearer's hand in a permanent halo — constructs become unbreakable" },
  { id:"suns_heart",      name:"Sun's Heart",        slot:"amulet", discipline:"lightforging",  bonus:1.60, tags:[], desc:"Pendant containing a fragment of the actual sun — the wearer becomes a walking furnace of light" },
  { id:"seraph_spire",    name:"Seraph Spire",       slot:"staff",  discipline:"lightforging",  bonus:1.70, tags:[], desc:"Staff of angelic crystal — spells cast through it arrive with blinding detonations" },
  { id:"dawnbreaker_chain", name:"Dawnbreaker Chain", slot:"chain", discipline:"lightforging",  bonus:1.60, tags:[], desc:"Chain that burns with the first light of creation — voidweaving crumbles in its presence" },

  // ── VOIDWEAVING 100-120% ───────────────────────────────
  { id:"oblivion_edge",   name:"Oblivion Edge",      slot:"weapon", discipline:"voidweaving",   bonus:1.00, tags:[], desc:"Sword whose blade is a visible tear in reality — cuts leave wounds in space itself" },
  { id:"deletha",         name:"Deletha",            slot:"dagger", discipline:"voidweaving",   bonus:1.10, tags:[], desc:"Dagger that erases whatever it touches from the present moment — wounds arrive late" },
  { id:"event_horizon",   name:"Event Horizon",      slot:"ring",   discipline:"voidweaving",   bonus:1.20, tags:[], desc:"Ring that bends nearby space — projectiles curve away from the wearer" },
  { id:"hollow_eye",      name:"Hollow Eye",         slot:"amulet", discipline:"voidweaving",   bonus:1.00, tags:[], desc:"Empty eye socket pendant — the wearer can see through magical darkness and silence" },
  { id:"negation_rod",    name:"Negation Rod",       slot:"staff",  discipline:"voidweaving",   bonus:1.10, tags:[], desc:"Staff of antimatter crystal — touching it to a spell unravels the magic instantly" },
  { id:"unlink",          name:"Unlink",             slot:"chain",  discipline:"voidweaving",   bonus:1.00, tags:[], desc:"Chain with missing links that still holds — each gap devours a different type of energy" },

  // ── VOIDWEAVING 160-180% ───────────────────────────────
  { id:"worldender",      name:"Worldender",         slot:"weapon", discipline:"voidweaving",   bonus:1.80, tags:[], desc:"Greatsword that severs the bonds between atoms — cuts cannot be healed by any means" },
  { id:"final_whisper",   name:"Final Whisper",      slot:"dagger", discipline:"voidweaving",   bonus:1.60, tags:[], desc:"Dagger that kills silently and completely — the victim simply ceases, no wound, no sound" },
  { id:"singularity_band", name:"Singularity Band",  slot:"ring",   discipline:"voidweaving",   bonus:1.70, tags:[], desc:"Ring that collapses space around the wearer — nearby magic is crushed into nothing" },
  { id:"dead_gods_eye",   name:"Dead God's Eye",     slot:"amulet", discipline:"voidweaving",   bonus:1.70, tags:[], desc:"Second eye of the god whose first became Oblivion's Eye — together they could end a world" },
  { id:"annihilation_staff", name:"Annihilation Staff", slot:"staff", discipline:"voidweaving", bonus:1.80, tags:[], desc:"Staff that hums at the frequency of unmaking — sustained contact dissolves reality" },
  { id:"severance_chain", name:"Severance Chain",    slot:"chain",  discipline:"voidweaving",   bonus:1.60, tags:[], desc:"Chain that cuts whatever it's draped over from existence — worn as a noose by the fearless" },

  // ── STORMWEAVING 100-120% ──────────────────────────────
  { id:"thundercleaver",  name:"Thundercleaver",     slot:"weapon", discipline:"stormweaving",  bonus:1.10, tags:[], desc:"Axe that summons a thunderclap with every swing — the shockwave hits harder than the blade" },
  { id:"bolt_needle",     name:"Bolt Needle",        slot:"dagger", discipline:"stormweaving",  bonus:1.00, tags:[], desc:"Hair-thin blade of magnetized steel — stabs call down a targeted lightning bolt" },
  { id:"fulgurite_ring",  name:"Fulgurite Ring",     slot:"ring",   discipline:"stormweaving",  bonus:1.10, tags:[], desc:"Ring fused from sand struck by lightning — the wearer's reflexes match the speed of their bolts" },
  { id:"cyclone_heart",   name:"Cyclone Heart",      slot:"amulet", discipline:"stormweaving",  bonus:1.00, tags:[], desc:"Pendant with a trapped cyclone — the wearer can redirect wind at will within a mile" },
  { id:"stormcaller_rod",  name:"Stormcaller Rod",   slot:"staff",  discipline:"stormweaving",  bonus:1.20, tags:[], desc:"Staff topped with a caged ball of lightning — plants thunderstorms wherever it strikes the ground" },
  { id:"conduit_chain",   name:"Conduit Chain",      slot:"chain",  discipline:"stormweaving",  bonus:1.00, tags:[], desc:"Chain that conducts ambient electricity — the wearer charges passively during storms" },

  // ── STORMWEAVING 160-180% ──────────────────────────────
  { id:"heaven_splitter",  name:"Heaven Splitter",   slot:"weapon", discipline:"stormweaving",  bonus:1.80, tags:[], desc:"Sword that splits the sky when drawn — permanent storm follows the wielder" },
  { id:"lightning_fang",   name:"Lightning Fang",    slot:"dagger", discipline:"stormweaving",  bonus:1.60, tags:[], desc:"Dagger that IS a frozen lightning bolt — throws become actual strikes from the sky" },
  { id:"maelstrom_ring",   name:"Maelstrom Ring",    slot:"ring",   discipline:"stormweaving",  bonus:1.70, tags:[], desc:"Ring containing a compressed hurricane — the wearer walks inside the eye of permanent destruction" },
  { id:"wrath_of_skies",   name:"Wrath of Skies",   slot:"amulet", discipline:"stormweaving",  bonus:1.70, tags:[], desc:"Pendant forged from skystone — calls down consecutive lightning strikes without pause" },
  { id:"stormfather_staff", name:"Stormfather Staff", slot:"staff", discipline:"stormweaving",  bonus:1.70, tags:[], desc:"Staff of the original storm god — weather itself answers to the wielder's mood" },
  { id:"tempest_shackle",  name:"Tempest Shackle",   slot:"chain",  discipline:"stormweaving",  bonus:1.60, tags:[], desc:"Chain of living lightning links — wraps the wearer in an electrical field that destroys on touch" },

  // ── NEW CROWNS ─────────────────────────────────────────
  { id:"radiant_aureole", name:"Radiant Aureole",    slot:"crown", discipline:"lightforging",  bonus:2.80, tags:[], desc:"Crown of perpetual dawn — the wearer's light constructs gain physical weight and hit like siege weapons" },
  { id:"crown_of_sol",    name:"Crown of Sol",       slot:"crown", discipline:"lightforging",  bonus:2.20, tags:[], desc:"Ancient solar crown — sunlight bends toward the wearer, leaving enemies in shadow" },
  { id:"crown_of_nothing", name:"Crown of Nothing",  slot:"crown", discipline:"voidweaving",   bonus:2.60, tags:[], desc:"Crown visible only as an absence — the wearer's negation magic becomes area-wide" },
  { id:"hollow_diadem",   name:"Hollow Diadem",      slot:"crown", discipline:"voidweaving",   bonus:2.00, tags:[], desc:"Diadem that eats sound and light around the wearer — spells arrive without warning" },
  { id:"pyralis_crown",   name:"Pyralis Crown",      slot:"crown", discipline:"flamecalling",  bonus:2.40, tags:[], desc:"Crown of white-hot iron that never cools — the wearer's flames ignore all resistance" },
  { id:"tsunamic_crown",  name:"Tsunamic Crown",     slot:"crown", discipline:"tidecalling",   bonus:2.30, tags:[], desc:"Coral crown from the deepest trench — the wearer commands water within a mile radius" },
  { id:"tyrant_diadem",   name:"Tyrant's Diadem",    slot:"crown", discipline:"soulbinding",   bonus:2.50, tags:[], desc:"Iron crown of the last god-emperor — entire cities bend to the wearer's spoken word" },
  { id:"hurricane_crown", name:"Hurricane Crown",     slot:"crown", discipline:"stormweaving",  bonus:2.30, tags:[], desc:"Crown forged from crystallized lightning — storms form overhead the moment it's worn" },

  { id:"pyreclutch",      name:"Pyreclutch",         slot:"dagger", discipline:"flamecalling",  bonus:1.20, tags:[], desc:"Dagger with a grip of living coal — the blade ignites hotter the tighter you squeeze" },
  { id:"inferno_conduit", name:"Inferno Conduit",    slot:"staff",  discipline:"flamecalling",  bonus:1.40, tags:[], desc:"Hollow iron staff that roars like a furnace when channeling — fire exits both ends" },
  { id:"blazelink",       name:"Blazelink",          slot:"chain",  discipline:"flamecalling",  bonus:1.10, tags:[], desc:"Chain of self-igniting links — each spell cast adds another burning ring to the necklace" },
];

function ArtifactsField({ artifacts, onChange, globalEquippedIds }) {
  const getSlot = (key) => (Array.isArray(artifacts) ? artifacts : []).find(a => a?.slot === key) || { slot: key, id: "", name: "", bonus: 0, discipline: "all", equipped: false, energy: 3 };

  function selectArtifact(slotKey, artifactId) {
    if (!artifactId) {
      const updated = ARTIFACT_SLOTS.map(s => {
        if (s.key === slotKey) return { slot: slotKey, id: "", name: "", bonus: 0, discipline: "all", equipped: false, energy: 3 };
        return getSlot(s.key);
      });
      const filled = updated.filter(a => a.name.trim() !== "");
      onChange(filled.length > 0 ? updated : []);
      return;
    }
    const cat = ARTIFACT_CATALOG.find(a => a.id === artifactId);
    if (!cat) return;
    const updated = ARTIFACT_SLOTS.map(s => {
      if (s.key === slotKey) return { slot: slotKey, id: cat.id, name: cat.name, bonus: cat.bonus, discipline: cat.discipline, equipped: false, energy: 3 };
      return getSlot(s.key);
    });
    const filled = updated.filter(a => a.name.trim() !== "");
    onChange(filled.length > 0 ? updated : []);
  }

  function toggleEquip(slotKey) {
    const updated = ARTIFACT_SLOTS.map(s => {
      const slot = getSlot(s.key);
      if (s.key === slotKey) return { ...slot, equipped: !slot.equipped };
      return slot;
    });
    onChange(updated.filter(a => a.name?.trim()));
  }

  function setEnergy(slotKey, val) {
    const updated = ARTIFACT_SLOTS.map(s => {
      const slot = getSlot(s.key);
      if (s.key === slotKey) return { ...slot, energy: Math.max(0, Math.min(3, val)) };
      return slot;
    });
    onChange(updated.filter(a => a.name?.trim()));
  }

  const myIds = ARTIFACT_SLOTS.map(s => getSlot(s.key).id).filter(Boolean);
  const allTaken = globalEquippedIds || [];
  const activeArts = (Array.isArray(artifacts) ? artifacts : []).filter(a => a?.equipped && (a?.energy || 0) > 0);
  const totalBonus = activeArts.reduce((s, a) => s + (a?.bonus || 0), 0);

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
      {ARTIFACT_SLOTS.map(({ key, label }) => {
        const slot = getSlot(key);
        const filled = slot.name && slot.name.trim() !== "";
        const catEntry = filled ? ARTIFACT_CATALOG.find(a => a.id === slot.id) : null;
        const discInfo = slot.discipline && slot.discipline !== "all"
          ? MAGIC_DISCIPLINES.find(d => d.key === slot.discipline) : null;
        const available = ARTIFACT_CATALOG.filter(a => a.slot === key && (a.id === slot.id || (!myIds.includes(a.id) && !allTaken.includes(a.id))));
        const energy = slot.energy ?? 3;
        const isEquipped = slot.equipped && energy > 0;
        const isDepleted = filled && energy <= 0;

        return (
          <div key={key} style={{
            border:`1px solid ${isDepleted ? "#d1d5db" : filled ? (isEquipped ? (discInfo ? discInfo.color + "88" : "#f59e0b") : (discInfo ? discInfo.color + "44" : "#fde68a")) : "#e5e7eb"}`,
            borderRadius:5, padding:"7px 8px",
            background: isDepleted ? "#f3f4f6" : filled ? (isEquipped ? (discInfo ? discInfo.color + "12" : "#fffbeb") : "#f9fafb") : "#f9fafb",
            opacity: isDepleted ? 0.6 : 1,
          }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:5 }}>
              <span style={{ fontSize:10, fontWeight:600, color: filled ? "#92400e" : "#9ca3af", letterSpacing:0.5, textTransform:"uppercase" }}>
                {key === "crown" ? "\u{1F451}" : "\u{1F3FA}"} {label}
              </span>
              {filled && (
                <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                  <div style={{ display:"flex", gap:2 }} title={`Energy: ${energy}/3`}>
                    {[1,2,3].map(i => (
                      <div key={i} onClick={() => setEnergy(key, i === energy ? i - 1 : i)} style={{
                        width:14, height:8, borderRadius:2, cursor:"pointer",
                        background: i <= energy ? (energy === 1 ? "#ef4444" : energy === 2 ? "#f59e0b" : "#22c55e") : "#e5e7eb",
                        border: `1px solid ${i <= energy ? (energy === 1 ? "#dc2626" : energy === 2 ? "#d97706" : "#16a34a") : "#d1d5db"}`,
                      }} />
                    ))}
                  </div>
                  <button
                    onClick={() => toggleEquip(key)}
                    disabled={energy <= 0}
                    style={{
                      fontSize:9, fontWeight:600, padding:"2px 6px", borderRadius:3, cursor: energy > 0 ? "pointer" : "not-allowed",
                      border: `1px solid ${isEquipped ? "#16a34a" : "#d1d5db"}`,
                      background: isEquipped ? "#dcfce7" : "#f9fafb",
                      color: isEquipped ? "#16a34a" : "#9ca3af",
                    }}
                  >
                    {isEquipped ? "EQUIPPED" : energy > 0 ? "EQUIP" : "DEPLETED"}
                  </button>
                </div>
              )}
            </div>
            <select
              value={slot.id || ""}
              onChange={e => selectArtifact(key, e.target.value)}
              style={{ ...selectStyle, fontSize:12 }}
            >
              <option value="">— Empty —</option>
              {available.map(a => {
                const dInfo = a.discipline !== "all" ? MAGIC_DISCIPLINES.find(d => d.key === a.discipline) : null;
                return (
                  <option key={a.id} value={a.id}>
                    {dInfo ? dInfo.icon : "⊕"} {a.name} (+{(a.bonus * 100).toFixed(0)}% {a.discipline === "all" ? "all" : dInfo?.label || a.discipline})
                  </option>
                );
              })}
            </select>
            {filled && catEntry && (
              <div style={{ marginTop:4 }}>
                <div style={{ display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" }}>
                  <span style={{ fontSize:11, fontWeight:600, color: discInfo ? discInfo.color : "#d97706" }}>
                    {discInfo ? `${discInfo.icon} ${discInfo.label}` : "⊕ All Disciplines"} +{(slot.bonus * 100).toFixed(0)}%
                  </span>
                  {!isEquipped && energy > 0 && <span style={{ fontSize:9, color:"#9ca3af" }}>Not equipped</span>}
                  {isDepleted && <span style={{ fontSize:9, color:"#ef4444", fontWeight:600 }}>No energy</span>}
                </div>
                <div style={{ fontSize:10, color:"#9ca3af", marginTop:2, lineHeight:1.4, fontStyle:"italic" }}>{catEntry.desc}</div>
              </div>
            )}
          </div>
        );
      })}
      <div style={{ display:"flex", justifyContent:"space-between", padding:"2px 0" }}>
        <span style={{ fontSize:10, color:"#9ca3af" }}>{activeArts.length} artifact{activeArts.length !== 1 ? "s" : ""} active</span>
        {totalBonus > 0 && (
          <span style={{ fontSize:11, color:"#d97706", fontWeight:600 }}>
            Active bonus: +{(totalBonus * 100).toFixed(0)}%
          </span>
        )}
      </div>
    </div>
  );
}


// Sum of raw discipline levels (for display)
function calcDisciplineLevels(disciplines) {
  if (!disciplines || typeof disciplines !== "object") return 0;
  return MAGIC_DISCIPLINES.reduce((sum, d) => sum + (disciplines[d.key] || 0), 0);
}

// Actual power bonus from disciplines for a given entity type
// artifacts (optional): array of { bonus, discipline } — discipline is a key or "all"
// fatigue: 0-1 (0 = fresh, 1 = fully exhausted). Reduces base discipline power.
function calcDisciplinePowerForType(disciplines, type, artifacts, fatigue) {
  if (!disciplines || typeof disciplines !== "object") return 0;
  const weights = type === "dragon" ? DRAGON_WEIGHTS : MAGE_WEIGHTS;
  const base    = type === "dragon" ? DRAGON_BASE   : MAGE_BASE;
  const fat = Math.max(0, Math.min(1, fatigue || 0));
  const fatigueMultiplier = 1 - fat; // 0% fatigue = full power, 100% = zero power

  // Only count artifacts that are equipped AND have energy remaining
  const arts = Array.isArray(artifacts) ? artifacts.filter(a => a?.name && a?.bonus && a?.equipped && (a?.energy || 0) > 0) : [];

  // Pre-compute per-discipline artifact bonuses and "all" bonus
  const discArtBonus = {};
  let allArtBonus = 0;
  for (const a of arts) {
    const b = a.bonus || 0;
    if (!a.discipline || a.discipline === "all") {
      allArtBonus += b;
    } else {
      discArtBonus[a.discipline] = (discArtBonus[a.discipline] || 0) + b;
    }
  }

  // Find the peak discipline (highest level)
  let peakKey = null, peakLvl = 0;
  for (const d of MAGIC_DISCIPLINES) {
    const lvl = disciplines[d.key] || 0;
    if (lvl > peakLvl) { peakKey = d.key; peakLvl = lvl; }
  }

  let total = 0;
  for (const d of MAGIC_DISCIPLINES) {
    const lvl = disciplines[d.key] || 0;
    if (lvl > 0) {
      let val = (weights[d.key] || 0) * (Math.pow(base, lvl) - 1);
      if (d.key === peakKey) val *= PEAK_MULT;
      // Apply fatigue to base discipline power
      val *= fatigueMultiplier;
      // Additive: targeted bonus + all bonus both add off the base
      val *= (1 + (discArtBonus[d.key] || 0) + allArtBonus);
      total += val;
    }
  }
  return total;
}

// Highest discipline level
function peakDiscipline(disciplines) {
  if (!disciplines || typeof disciplines !== "object") return { key: null, level: 0 };
  let best = { key: null, level: 0 };
  for (const d of MAGIC_DISCIPLINES) {
    const lvl = disciplines[d.key] || 0;
    if (lvl > best.level) best = { key: d.key, level: lvl };
  }
  return best;
}

// Disciplines editor — 6 sliders with labels, icons, and colors
function DisciplinesEditor({ disciplines, onChange, entityType, artifacts }) {
  const disc = disciplines || {};
  const totalLvl = calcDisciplineLevels(disc);
  const basePwr = calcDisciplinePowerForType(disc, entityType || "mage");
  const totalPwr = artifacts ? calcDisciplinePowerForType(disc, entityType || "mage", artifacts) : basePwr;
  const hasArtBoost = totalPwr > basePwr + 0.0001;
  const weights = entityType === "dragon" ? DRAGON_WEIGHTS : MAGE_WEIGHTS;
  // Sort disciplines by weight for this entity type (strongest first)
  const sorted = [...MAGIC_DISCIPLINES].sort((a, b) => (weights[b.key] || 0) - (weights[a.key] || 0));
  // Tier labels
  const tierOf = (key) => {
    const keys = Object.keys(weights).sort((a,b) => weights[b] - weights[a]);
    const idx = keys.indexOf(key);
    return idx <= 1 ? "S" : idx <= 3 ? "A" : "B";
  };
  // Check which disciplines have targeted artifacts
  const arts = Array.isArray(artifacts) ? artifacts.filter(a => a?.name && a?.bonus) : [];
  const artTargets = {};
  for (const a of arts) {
    if (a.discipline && a.discipline !== "all") {
      artTargets[a.discipline] = (artTargets[a.discipline] || 0) + a.bonus;
    }
  }
  const tierColors = { S:"#eab308", A:"#a855f7", B:"#6b7280" };
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
      {sorted.map(({ key, label, icon, color }) => {
        const val = disc[key] || 0;
        const tier = tierOf(key);
        const artBoost = artTargets[key] || 0;
        return (
          <div key={key} style={{
            padding:"5px 7px", borderRadius:5,
            border:`1px solid ${val > 0 ? color + "44" : "#e5e7eb"}`,
            background: val > 0 ? color + "08" : "#f9fafb",
          }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:3 }}>
              <span style={{ display:"flex", alignItems:"center", gap:4 }}>
                <span style={{ fontSize:9, fontWeight:700, color: tierColors[tier], background: tierColors[tier] + "18", padding:"1px 4px", borderRadius:3, lineHeight:1.2 }}>{tier}</span>
                <span style={{ fontSize:11, fontWeight:600, color: val > 0 ? color : "#9ca3af" }}>
                  {icon} {label}
                </span>
                {artBoost > 0 && <span style={{ fontSize:9, color:"#d97706", fontWeight:600 }}>🏺+{(artBoost*100).toFixed(0)}%</span>}
              </span>
              <span style={{ fontSize:10, color: val > 0 ? color : "#d1d5db", fontWeight:600 }}>
                {val > 0 ? `${val} — ${DISCIPLINE_LABELS[val]}` : "—"}
              </span>
            </div>
            <input type="range" min={0} max={12} value={val}
              onChange={e => onChange({ ...disc, [key]: parseInt(e.target.value) })}
              style={{ width:"100%", accentColor: color, height:14 }} />
          </div>
        );
      })}
      <div style={{ display:"flex", justifyContent:"space-between", padding:"3px 2px" }}>
        <span style={{ fontSize:10, color:"#9ca3af" }}>Levels: {totalLvl}/72</span>
        <span style={{ fontSize:11, fontWeight:700, color: totalPwr > 0 ? "#7c3aed" : "#d1d5db" }}>
          Power: +{(totalPwr * 100).toFixed(0)}%
          {hasArtBoost && <span style={{ fontSize:9, color:"#d97706", marginLeft:4 }}>(🏺 boosted)</span>}
        </span>
      </div>
    </div>
  );
}

// Draggable entity row inside city panel
function CityEntityRow({ item, type, onDragOut }) {
  const shapeStyle = type === "army" ? { borderRadius: 2, transform: "rotate(45deg)" }
    : type === "dragon" ? { borderRadius: 2, clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)" }
    : { borderRadius: "50%" };
  return (
    <div style={{ display:"flex", alignItems:"center", gap:6, padding:"4px 6px", background:"#f9fafb", borderRadius:5, border:"1px solid #e5e7eb", marginBottom:3 }}>
      <span style={{
        width:10, height:10, background:item.color, flexShrink:0, display:"inline-block",
        ...shapeStyle,
      }} />
      <span style={{ fontSize:12, color:"#374151", flex:1 }}>{item.name}{item.role ? ` · ${item.role}` : ""}{item.size ? ` (${item.size.toLocaleString()})` : ""}</span>
      <button
        title="Move out to map"
        onClick={() => onDragOut(item.primary_key, type)}
        style={{ background:"none", border:"1px solid #d1d5db", borderRadius:4, cursor:"pointer", fontSize:10, color:"#6b7280", padding:"2px 5px" }}>
        ↗ Map
      </button>
    </div>
  );
}

// ── Name Modal ────────────────────────────────────────────────────────────────
function NameModal({ type, onConfirm, onCancel }) {
  const [value, setValue] = useState("");
  const [size, setSize] = useState("");
  const [role, setRole] = useState("");
  const [school, setSchool] = useState("");
  const [power, setPower] = useState(5);
  const [primaryDiscipline, setPrimaryDiscipline] = useState("");
  const [element, setElement] = useState("");
  const [dragonSize, setDragonSize] = useState("Adult");
  const isArmy = type === "army";
  const isChar = type === "character";
  const isMage = type === "mage";
  const isDragon = type === "dragon";
  

  function handleConfirm() {
    if (!value.trim()) return;
    // Build initial disciplines object if a primary was picked
    let initDisciplines = undefined;
    if ((isMage || isDragon) && primaryDiscipline) {
      initDisciplines = {};
      MAGIC_DISCIPLINES.forEach(d => { initDisciplines[d.key] = 0; });
      initDisciplines[primaryDiscipline] = isMage ? 3 : 2; // mages start a bit higher in their primary
    }
    onConfirm({
      name: value.trim(),
      size: isArmy ? (parseInt(size) || 0) : undefined,
      role: isChar ? role.trim() : undefined,
      school: isMage ? school.trim() : undefined,
      power: isMage ? power : undefined,
      element: isDragon ? element.trim() : undefined,
      dragonSize: isDragon ? dragonSize : undefined,
      disciplines: initDisciplines,
    });
  }

  const titles = { kingdom:"Name this Kingdom", city:"Name this City", character:"New Character", army:"New Army", mage:"New Mage", dragon:"New Dragon" };

  return (
    <div style={{
      position:"fixed", inset:0, background:"#00000055", zIndex:100,
      display:"flex", alignItems:"center", justifyContent:"center",
    }}>
      <div style={{ background:"#fff", borderRadius:10, padding:24, width:300, boxShadow:"0 8px 32px #0003", maxHeight:"85vh", overflowY:"auto" }}>
        <div style={{ fontWeight:600, fontSize:15, color:"#111827", marginBottom:14 }}>{titles[type]}</div>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <Field label="Name">
            <FInput autoFocus value={value} onChange={e => setValue(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") handleConfirm(); if (e.key === "Escape") onCancel(); }}
              placeholder={type === "kingdom" ? "e.g. Kingdom of Valdor" : type === "city" ? "e.g. Ironhold" : type === "character" ? "e.g. Ser Aldric" : type === "mage" ? "e.g. Archmage Veylan" : type === "dragon" ? "e.g. Scorathax" : "e.g. First Legion"} />
          </Field>
          {isChar && (
            <Field label="Role">
              <FInput value={role} onChange={e => setRole(e.target.value)} placeholder="e.g. noble, warrior, merchant..." />
            </Field>
          )}
          {isArmy && (
            <Field label="Size">
              <FInput value={size} onChange={e => setSize(e.target.value)} type="number" placeholder="e.g. 5000" />
            </Field>
          )}
          {isMage && (
            <>
              <Field label="Primary Discipline">
                <select value={primaryDiscipline} onChange={e => setPrimaryDiscipline(e.target.value)} style={selectStyle}>
                  <option value="">— None (set later) —</option>
                  {MAGIC_DISCIPLINES.map(d => <option key={d.key} value={d.key}>{d.icon} {d.label}</option>)}
                </select>
                <span style={{ fontSize:10, color:"#9ca3af" }}>Sets starting level — fine-tune in edit panel</span>
              </Field>
            </>
          )}
          {isDragon && (
            <>
              <Field label="Element / Type">
                <FInput value={element} onChange={e => setElement(e.target.value)} placeholder="e.g. fire, ice, shadow..." />
              </Field>
              <Field label="Size Category">
                <select value={dragonSize} onChange={e => setDragonSize(e.target.value)} style={selectStyle}>
                  {DRAGON_SIZES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </Field>
              <Field label="Primary Discipline">
                <select value={primaryDiscipline} onChange={e => setPrimaryDiscipline(e.target.value)} style={selectStyle}>
                  <option value="">— None (set later) —</option>
                  {MAGIC_DISCIPLINES.map(d => <option key={d.key} value={d.key}>{d.icon} {d.label}</option>)}
                </select>
                <span style={{ fontSize:10, color:"#9ca3af" }}>Dragon+rider magical affinity — fine-tune in panel</span>
              </Field>
            </>
          )}
        </div>
        <div style={{ display:"flex", gap:8, marginTop:16 }}>
          <button onClick={handleConfirm} style={mkBtn("#3b82f6")}>Place</button>
          <button onClick={onCancel} style={mkBtn("#9ca3af")}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ── City Panel ────────────────────────────────────────────────────────────────
function CityPanel({ city, characters, armies, mages, dragons, kingdoms, onUpdate, onClose, onDelete, onMoveOut }) {
  const [name, setName]           = useState(city.name);
  const [allegiance, setAllegiance] = useState(city.allegiance || "");
  const [status, setStatus]       = useState(city.status || "normal");
  const [notes, setNotes]         = useState(city.notes || "");

  // Computed from linked entities
  const cityChars   = characters.filter(c => c.city === city.primary_key);
  const cityArmies  = armies.filter(a => a.city === city.primary_key);
  const cityMages   = mages.filter(m => m.city === city.primary_key);
  const cityDragons = dragons.filter(d => d.city === city.primary_key);
  const garrison    = cityArmies.reduce((sum, a) => sum + (a.size || 0), 0);

  return (
    <Panel title={`● ${city.name}`} onClose={onClose}>
      <Field label="Name"><FInput value={name} onChange={e => setName(e.target.value)} /></Field>
      <Field label="Allegiance">
        <select value={allegiance} onChange={e => setAllegiance(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
        </select>
      </Field>
      <Field label="Status">
        <select value={status} onChange={e => setStatus(e.target.value)} style={selectStyle}>
          {CITY_STATUSES.map(s => <option key={s} value={s}>{STATUS_LABELS[s]}</option>)}
        </select>
      </Field>

      {/* Computed */}
      <Field label="Garrison (computed)">
        <Badge label="Total troops" value={garrison.toLocaleString()} color="#2563eb" />
      </Field>

      <Field label={`Armies here (${cityArmies.length})`}>
        {cityArmies.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : cityArmies.map(a => <CityEntityRow key={a.primary_key} item={a} type="army" onDragOut={onMoveOut} />)
        }
      </Field>

      <Field label={`Characters here (${cityChars.length})`}>
        {cityChars.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : cityChars.sort((a, b) => b.skill - a.skill).map(c => <CityEntityRow key={c.primary_key} item={c} type="character" onDragOut={onMoveOut} />)
        }
      </Field>

      <Field label={`Mages here (${cityMages.length})`}>
        {cityMages.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : cityMages.sort((a, b) => calcDisciplinePowerForType(b.disciplines,"mage") - calcDisciplinePowerForType(a.disciplines,"mage")).map(m => <CityEntityRow key={m.primary_key} item={{...m, role: m.school}} type="mage" onDragOut={onMoveOut} />)
        }
      </Field>

      <Field label={`Dragons here (${cityDragons.length})`}>
        {cityDragons.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : cityDragons.sort((a, b) => calcDisciplinePowerForType(b.disciplines,"dragon") - calcDisciplinePowerForType(a.disciplines,"dragon")).map(d => <CityEntityRow key={d.primary_key} item={{...d, role: d.element}} type="dragon" onDragOut={onMoveOut} />)
        }
      </Field>

      <Field label="Notes">
        <textarea value={notes} onChange={e => setNotes(e.target.value)}
          rows={3} style={{ ...inputStyle, resize:"vertical" }} placeholder="Lore, description..." />
      </Field>
      <div style={{ display:"flex", gap:6, marginTop:4 }}>
        <button onClick={() => onUpdate({ ...city, name, allegiance, status, notes })} style={mkBtn("#3b82f6")}>Save</button>
        <button onClick={onDelete} style={mkBtn("#ef4444")}>Delete</button>
      </div>
    </Panel>
  );
}

// ── Kingdom Panel ─────────────────────────────────────────────────────────────
function KingdomPanel({ kingdom, characters, armies, cities, mages, dragons, onUpdate, onClose, onDelete, onEditBorders }) {
  const [name, setName]   = useState(kingdom.name);
  const [notes, setNotes] = useState(kingdom.notes || "");

  // Computed
  const kCities  = cities.filter(c => c.allegiance === kingdom.primary_key);
  const kArmies  = armies.filter(a => a.allegiance === kingdom.primary_key);
  const totalTroops = kArmies.reduce((sum, a) => sum + (a.size || 0), 0);
  const kChars   = characters.filter(c => c.allegiance === kingdom.primary_key);
  const kMages   = mages.filter(m => m.allegiance === kingdom.primary_key);
  const kDragons = dragons.filter(d => d.allegiance === kingdom.primary_key);

  const totalMagePower = kMages.reduce((sum, m) => sum + calcDisciplinePowerForType(m.disciplines, "mage"), 0);
  const totalDragonPower = kDragons.reduce((sum, d) => sum + calcDisciplinePowerForType(d.disciplines, "dragon"), 0);
  const totalMageDisc = kMages.reduce((sum, m) => sum + calcDisciplineLevels(m.disciplines), 0);
  const totalDragonDisc = kDragons.reduce((sum, d) => sum + calcDisciplineLevels(d.disciplines), 0);

  return (
    <Panel title={`▨ ${kingdom.name}`} onClose={onClose}>
      <Field label="Kingdom Name"><FInput value={name} onChange={e => setName(e.target.value)} /></Field>

      <Field label="Summary">
        <Badge label="Cities" value={kCities.length} />
        <div style={{ height:4 }} />
        <Badge label="Armies" value={kArmies.length} color="#dc2626" />
        <div style={{ height:4 }} />
        <Badge label="Total Troops" value={totalTroops.toLocaleString()} color="#dc2626" />
        <div style={{ height:4 }} />
        <Badge label="Characters" value={kChars.length} color="#7c3aed" />
        <div style={{ height:4 }} />
        <Badge label="Mages" value={kMages.length} color="#6d28d9" />
        <div style={{ height:4 }} />
        <Badge label="Mage Power" value={`+${(totalMagePower * 100).toFixed(0)}%`} color="#6d28d9" />
        <div style={{ height:4 }} />
        <Badge label="Mage Discipline Levels" value={`🔮 ${totalMageDisc}`} color="#7c3aed" />
        <div style={{ height:4 }} />
        <Badge label="Dragons" value={kDragons.length} color="#b91c1c" />
        <div style={{ height:4 }} />
        <Badge label="Dragon Power" value={`+${(totalDragonPower * 100).toFixed(0)}%`} color="#b91c1c" />
        <div style={{ height:4 }} />
        <Badge label="Dragon Discipline Levels" value={`🔮 ${totalDragonDisc}`} color="#ea580c" />
      </Field>

      <Field label={`Cities (${kCities.length})`}>
        {kCities.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : kCities.map(c => (
            <div key={c.primary_key} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, color:"#374151", marginBottom:3 }}>
              <span style={{ width:8, height:8, borderRadius:"50%", background: STATUS_COLORS[c.status] || "#9ca3af", display:"inline-block" }} />
              {c.name} <span style={{ fontSize:11, color:"#9ca3af" }}>({STATUS_LABELS[c.status]})</span>
            </div>
          ))
        }
      </Field>

      <Field label={`Armies (${kArmies.length})`}>
        {kArmies.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : kArmies.map(a => (
            <div key={a.primary_key} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, color:"#374151", marginBottom:3 }}>
              <span style={{ width:10, height:10, background:a.color, display:"inline-block", borderRadius:2, transform:"rotate(45deg)", flexShrink:0 }} />
              {a.name}{a.size ? ` — ${a.size.toLocaleString()}` : ""}
            </div>
          ))
        }
      </Field>

      <Field label={`Characters (${kChars.length})`}>
        {kChars.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : kChars.sort((a, b) => b.skill - a.skill).map(c => (
            <div key={c.primary_key} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, color:"#374151", marginBottom:3 }}>
              <span style={{ width:10, height:10, borderRadius:"50%", background:c.color, display:"inline-block", flexShrink:0 }} />
              {c.name}{c.role ? ` · ${c.role}` : ""}
            </div>
          ))
        }
      </Field>

      <Field label={`Mages (${kMages.length})`}>
        {kMages.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : kMages.sort((a, b) => b.skill - a.skill).map(m => (
            <div key={m.primary_key} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, color:"#374151", marginBottom:3 }}>
              <span style={{ width:10, height:10, borderRadius:"50%", background:m.color, display:"inline-block", flexShrink:0 }} />
              {m.name}{m.school ? ` · ${m.school}` : ""}
            </div>
          ))
        }
      </Field>

      <Field label={`Dragons (${kDragons.length})`}>
        {kDragons.sort((a, b) => b.skill - a.skill).length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : kDragons.map(d => (
            <div key={d.primary_key} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, color:"#374151", marginBottom:3 }}>
              <span style={{ width:0, height:0, borderLeft:"5px solid transparent", borderRight:"5px solid transparent", borderBottom:`10px solid ${d.color}`, display:"inline-block", flexShrink:0 }} />
              {d.name}{d.element ? ` · ${d.element}` : ""}
            </div>
          ))
        }
      </Field>

      <Field label="Notes">
        <textarea value={notes} onChange={e => setNotes(e.target.value)}
          rows={3} style={{ ...inputStyle, resize:"vertical" }} placeholder="History, lore..." />
      </Field>
      <div style={{ display:"flex", gap:6, marginTop:4 }}>
        <button onClick={() => onUpdate({ ...kingdom, name, notes })} style={mkBtn("#3b82f6")}>Save</button>
        <button onClick={onDelete} style={mkBtn("#ef4444")}>Delete</button>
      </div>
      <button onClick={() => onEditBorders(kingdom)}
        style={{ background:"#7c3aed", color:"#fff", border:"none", borderRadius:5, padding:"6px 12px", cursor:"pointer", fontSize:13, fontWeight:500, width:"100%", marginTop:4 }}>
        ✏ Edit Borders
      </button>
    </Panel>
  );
}

// ── Character Panel ───────────────────────────────────────────────────────────
function CharacterPanel({ character, cities, kingdoms, armies, onUpdate, onClose, onDelete }) {
  const [name, setName]           = useState(character.name);
  const [role, setRole]           = useState(character.role || "");
  const [allegiance, setAllegiance] = useState(character.allegiance || "");
  const [army, setArmy]           = useState(character.army || "");
  const [skill, setSkill]         = useState(character.skill || 5);
  const [notes, setNotes]         = useState(character.notes || "");
  const [color, setColor]         = useState(character.color || CHAR_COLORS[0]);
  const [cityVal, setCityVal]     = useState(character.city || "");

  // location display
  const locationDesc = character.city
    ? `In ${cities.find(c => c.primary_key === character.city)?.name || character.city}`
    : character.coordinates ? `Map (${character.coordinates})` : "Unknown";

  return (
    <Panel title={`👤 ${character.name}`} onClose={onClose}>
      <Field label="Name"><FInput value={name} onChange={e => setName(e.target.value)} /></Field>
      <Field label="Role"><FInput value={role} onChange={e => setRole(e.target.value)} placeholder="e.g. noble, warrior..." /></Field>
      <Field label="Allegiance">
        <select value={allegiance} onChange={e => setAllegiance(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
        </select>
      </Field>
      <Field label="Army (if general)">
        <select value={army} onChange={e => setArmy(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {armies.map(a => <option key={a.primary_key} value={a.primary_key}>{a.name}</option>)}
        </select>
      </Field>
      <Field label="City">
        <select value={cityVal} onChange={e => setCityVal(e.target.value)} style={selectStyle}>
          <option value="">— On map —</option>
          {cities.map(c => <option key={c.primary_key} value={c.primary_key}>{c.name}</option>)}
        </select>
      </Field>
      <Field label="Current Location">
        <Badge label="Location" value={locationDesc} />
      </Field>
      <Field label={`Skill (${skill} — ${SKILL_LABELS[skill]})`}>
        <input type="range" min={1} max={12} value={skill} onChange={e => setSkill(parseInt(e.target.value))} style={{ width:"100%" }} />
      </Field>
      <Field label="Color">
        <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
          {CHAR_COLORS.map(c => (
            <div key={c} onClick={() => setColor(c)} style={{
              width:20, height:20, borderRadius:"50%", background:c, cursor:"pointer",
              border: color === c ? "2px solid #111" : "2px solid transparent",
            }} />
          ))}
        </div>
      </Field>
      <Field label="Notes">
        <textarea value={notes} onChange={e => setNotes(e.target.value)}
          rows={3} style={{ ...inputStyle, resize:"vertical" }} placeholder="Background, goals..." />
      </Field>
      <div style={{ display:"flex", gap:6, marginTop:4 }}>
        <button onClick={() => onUpdate({ ...character, name, role, allegiance, army, skill, notes, color, city: cityVal })} style={mkBtn("#3b82f6")}>Save</button>
        <button onClick={onDelete} style={mkBtn("#ef4444")}>Delete</button>
      </div>
    </Panel>
  );
}

// ── Army Panel ────────────────────────────────────────────────────────────────
function ArmyPanel({ army, characters, cities, kingdoms, mages, dragons, onUpdate, onClose, onDelete, onMoveOut }) {
  const [name, setName]           = useState(army.name);
  const [allegiance, setAllegiance] = useState(army.allegiance || "");
  const [general, setGeneral]     = useState(army.general || "");
  const [size, setSize]           = useState(army.size || 0);
  const [bonus, setBonus]         = useState(army.bonus || 0);
  const [notes, setNotes]         = useState(army.notes || "");
  const [color, setColor]         = useState(army.color || ARMY_COLORS[0]);
  const [cityVal, setCityVal]     = useState(army.city || "");

  const locationDesc = army.city
    ? `In ${cities.find(c => c.primary_key === army.city)?.name || army.city}`
    : army.coordinates ? `Map (${army.coordinates})` : "Unknown";

  const armyChars = characters.filter(c => c.army === army.primary_key);
  const armyMages = mages.filter(m => m.army === army.primary_key);
  const armyDragons = dragons.filter(d => d.army === army.primary_key);

  return (
    <Panel title={`⚔ ${army.name}`} onClose={onClose}>
      <Field label="Army Name"><FInput value={name} onChange={e => setName(e.target.value)} /></Field>
      <Field label="Size">
        <FInput value={size} onChange={e => setSize(parseInt(e.target.value) || 0)} type="number" />
      </Field>
      <Field label="Army Bonus (%)">
        <FInput
          value={Math.round((bonus || 0) * 100)}
          onChange={e => setBonus((parseFloat(e.target.value) || 0) / 100)}
          type="number" min="0" placeholder="e.g. 20 for +20%" />
      </Field>
      <Field label="Allegiance">
        <select value={allegiance} onChange={e => setAllegiance(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
        </select>
      </Field>
      <Field label="General">
        <select value={general} onChange={e => setGeneral(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {characters.map(c => <option key={c.primary_key} value={c.primary_key}>{c.name}</option>)}
        </select>
      </Field>
      <Field label="City">
        <select value={cityVal} onChange={e => setCityVal(e.target.value)} style={selectStyle}>
          <option value="">— On map —</option>
          {cities.map(c => <option key={c.primary_key} value={c.primary_key}>{c.name}</option>)}
        </select>
      </Field>
      <Field label="Current Location">
        <Badge label="Location" value={locationDesc} />
      </Field>
      <Field label="Token Color">
        <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
          {ARMY_COLORS.map(c => (
            <div key={c} onClick={() => setColor(c)} style={{
              width:20, height:20, borderRadius:3, background:c, cursor:"pointer",
              border: color === c ? "2px solid #111" : "2px solid transparent",
            }} />
          ))}
        </div>
      </Field>
      <Field label={`Characters (${armyChars.length})`}>
        {armyChars.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None enlisted</span>
          : armyChars.sort((a, b) => b.skill - a.skill).map(c => <CityEntityRow key={c.primary_key} item={c} type="character" onDragOut={(id) => onMoveOut(id, "fromArmy")} />)
        }
      </Field>
      <Field label={`Mages (${armyMages.length})`}>
        {armyMages.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : armyMages.sort((a, b) => calcDisciplinePowerForType(b.disciplines,"mage") - calcDisciplinePowerForType(a.disciplines,"mage")).map(m => <CityEntityRow key={m.primary_key} item={{...m, role: m.school}} type="mage" onDragOut={(id) => onMoveOut(id, "fromArmyMage")} />)
        }
      </Field>
      <Field label={`Dragons (${armyDragons.length})`}>
        {armyDragons.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>None</span>
          : armyDragons.sort((a, b) => calcDisciplinePowerForType(b.disciplines,"dragon") - calcDisciplinePowerForType(a.disciplines,"dragon")).map(d => <CityEntityRow key={d.primary_key} item={{...d, role: d.element}} type="dragon" onDragOut={(id) => onMoveOut(id, "fromArmyDragon")} />)
        }
      </Field>
      <Field label="Notes">
        <textarea value={notes} onChange={e => setNotes(e.target.value)}
          rows={3} style={{ ...inputStyle, resize:"vertical" }} placeholder="Composition, notes..." />
      </Field>
      <div style={{ display:"flex", gap:6, marginTop:4 }}>
        <button onClick={() => onUpdate({ ...army, name, allegiance, general, size, notes, color, city: cityVal, bonus: bonus || undefined })} style={mkBtn("#3b82f6")}>Save</button>
        <button onClick={onDelete} style={mkBtn("#ef4444")}>Delete</button>
      </div>
    </Panel>
  );
}

// ── Mage Panel ─────────────────────────────────────────────────────────────
function MagePanel({ mage, cities, kingdoms, armies, allMages, allDragons, onUpdate, onClose, onDelete }) {
  const [name, setName]           = useState(mage.name);
  const [allegiance, setAllegiance] = useState(mage.allegiance || "");
  const [army, setArmy]           = useState(mage.army || "");
  const [cityVal, setCityVal]     = useState(mage.city || "");
  const [notes, setNotes]         = useState(mage.notes || "");
  const [color, setColor]         = useState(mage.color || MAGE_COLORS[0]);
  const [artifacts, setArtifacts] = useState(mage.artifacts || []);
  const [disciplines, setDisciplines] = useState(mage.disciplines || {});
  const [fatigue, setFatigue]     = useState(mage.fatigue || 0);

  const locationDesc = mage.city
    ? `In ${cities.find(c => c.primary_key === mage.city)?.name || mage.city}`
    : mage.army ? `In ${armies.find(a => a.primary_key === mage.army)?.name || mage.army}`
    : mage.coordinates ? `Map (${mage.coordinates})` : "Unknown";

  const totalPower = calcDisciplinePowerForType(disciplines, "mage", artifacts, fatigue);
  const basePower = calcDisciplinePowerForType(disciplines, "mage");
  const peak = peakDiscipline(disciplines);

  const globalEquippedIds = [
    ...(allMages || []).filter(m => m.primary_key !== mage.primary_key),
    ...(allDragons || []),
  ].flatMap(e => (Array.isArray(e.artifacts) ? e.artifacts : []).map(a => a?.id).filter(Boolean));

  const fatigueColor = fatigue <= 0.3 ? "#22c55e" : fatigue <= 0.6 ? "#f59e0b" : "#ef4444";

  return (
    <Panel title={`✦ ${mage.name}`} onClose={onClose}>
      <Field label="Name"><FInput value={name} onChange={e => setName(e.target.value)} /></Field>

      <Badge label="Total Power" value={`+${(totalPower * 100).toFixed(0)}%`} color="#7c3aed" />
      {fatigue > 0 && basePower > 0 && (
        <Badge label="Base (unfatigued)" value={`+${(basePower * 100).toFixed(0)}%`} color="#9ca3af" />
      )}

      <Field label={`Fatigue (${Math.round(fatigue * 100)}%)`}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <input type="range" min={0} max={100} value={Math.round(fatigue * 100)}
            onChange={e => setFatigue(parseInt(e.target.value) / 100)}
            style={{ flex:1, accentColor: fatigueColor }} />
          <span style={{ fontSize:12, fontWeight:600, color: fatigueColor, minWidth:36, textAlign:"right" }}>{Math.round(fatigue * 100)}%</span>
        </div>
        <div style={{ fontSize:10, color:"#9ca3af", marginTop:2 }}>
          {fatigue <= 0 ? "Fresh — full power" : fatigue >= 1 ? "Exhausted — no power" : `Power reduced to ${Math.round((1 - fatigue) * 100)}%`}
        </div>
      </Field>

      {peak.key && (
        <Badge label="Primary Affinity" value={`${MAGIC_DISCIPLINES.find(d=>d.key===peak.key)?.icon || ""} ${MAGIC_DISCIPLINES.find(d=>d.key===peak.key)?.label || peak.key} (${peak.level})`} color="#7c3aed" />
      )}

      <Field label="Magic Disciplines">
        <DisciplinesEditor disciplines={disciplines} onChange={setDisciplines} entityType="mage" artifacts={artifacts} />
      </Field>

      <Field label="Allegiance">
        <select value={allegiance} onChange={e => setAllegiance(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
        </select>
      </Field>
      <Field label="Army">
        <select value={army} onChange={e => setArmy(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {armies.map(a => <option key={a.primary_key} value={a.primary_key}>{a.name}</option>)}
        </select>
      </Field>
      <Field label="City">
        <select value={cityVal} onChange={e => setCityVal(e.target.value)} style={selectStyle}>
          <option value="">— On map —</option>
          {cities.map(c => <option key={c.primary_key} value={c.primary_key}>{c.name}</option>)}
        </select>
      </Field>
      <Field label="Current Location">
        <Badge label="Location" value={locationDesc} />
      </Field>
      <Field label="Color">
        <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
          {MAGE_COLORS.map(c => (
            <div key={c} onClick={() => setColor(c)} style={{
              width:20, height:20, borderRadius:"50%", background:c, cursor:"pointer",
              border: color === c ? "2px solid #111" : "2px solid transparent",
            }} />
          ))}
        </div>
      </Field>
      <Field label="Artifacts">
        <ArtifactsField artifacts={artifacts} onChange={setArtifacts} globalEquippedIds={globalEquippedIds} />
      </Field>
      <Field label="Notes">
        <textarea value={notes} onChange={e => setNotes(e.target.value)}
          rows={3} style={{ ...inputStyle, resize:"vertical" }} placeholder="Spells, background..." />
      </Field>
      <div style={{ display:"flex", gap:6, marginTop:4 }}>
        <button onClick={() => onUpdate({ ...mage, name, allegiance, army, notes, color, city: cityVal, artifacts: (artifacts && artifacts?.length > 0) ? artifacts : undefined, disciplines, fatigue })} style={mkBtn("#3b82f6")}>Save</button>
        <button onClick={onDelete} style={mkBtn("#ef4444")}>Delete</button>
      </div>
    </Panel>
  );
}

// ── Dragon Panel ───────────────────────────────────────────────────────────
function DragonPanel({ dragon, cities, kingdoms, armies, characters, mages, allDragons, onUpdate, onClose, onDelete }) {
  const [name, setName]           = useState(dragon.name);
  const [element, setElement]     = useState(dragon.element || "");
  const [dragonSize, setDragonSize] = useState(dragon.dragonSize || "Adult");
  const [allegiance, setAllegiance] = useState(dragon.allegiance || "");
  const [rider, setRider]         = useState(dragon.rider || "");
  const [army, setArmy]           = useState(dragon.army || "");
  const [cityVal, setCityVal]     = useState(dragon.city || "");
  const [notes, setNotes]         = useState(dragon.notes || "");
  const [color, setColor]         = useState(dragon.color || DRAGON_COLORS[0]);
  const [artifacts, setArtifacts] = useState(dragon.artifacts || []);
  const [disciplines, setDisciplines] = useState(dragon.disciplines || {});
  const [fatigue, setFatigue]     = useState(dragon.fatigue || 0);

  const locationDesc = dragon.city
    ? `In ${cities.find(c => c.primary_key === dragon.city)?.name || dragon.city}`
    : dragon.army ? `In ${armies.find(a => a.primary_key === dragon.army)?.name || dragon.army}`
    : dragon.coordinates ? `Map (${dragon.coordinates})` : "Unknown";

  // Riders can be characters or mages
  const riderOptions = [...characters, ...mages];

  const totalPower = calcDisciplinePowerForType(disciplines, "dragon", artifacts, fatigue);
  const basePower = calcDisciplinePowerForType(disciplines, "dragon");
  const peak = peakDiscipline(disciplines);

  // Collect all artifact IDs equipped by OTHER entities
  const globalEquippedIds = [
    ...(mages || []),
    ...(allDragons || []).filter(d => d.primary_key !== dragon.primary_key),
  ].flatMap(e => (Array.isArray(e.artifacts) ? e.artifacts : []).map(a => a?.id).filter(Boolean));

  return (
    <Panel title={`🐉 ${dragon.name}`} onClose={onClose}>
      <Field label="Name"><FInput value={name} onChange={e => setName(e.target.value)} /></Field>
      <Field label="Element / Type">
        <FInput value={element} onChange={e => setElement(e.target.value)} placeholder="e.g. fire, ice, shadow..." />
      </Field>
      <Field label="Size Category">
        <select value={dragonSize} onChange={e => setDragonSize(e.target.value)} style={selectStyle}>
          {DRAGON_SIZES.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </Field>

      <Badge label="Total Power" value={`+${(totalPower * 100).toFixed(0)}%`} color="#ea580c" />
      {fatigue > 0 && basePower > 0 && (
        <Badge label="Base (unfatigued)" value={`+${(basePower * 100).toFixed(0)}%`} color="#9ca3af" />
      )}

      <Field label={`Fatigue (${Math.round(fatigue * 100)}%)`}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <input type="range" min={0} max={100} value={Math.round(fatigue * 100)}
            onChange={e => setFatigue(parseInt(e.target.value) / 100)}
            style={{ flex:1, accentColor: fatigue <= 0.3 ? "#22c55e" : fatigue <= 0.6 ? "#f59e0b" : "#ef4444" }} />
          <span style={{ fontSize:12, fontWeight:600, color: fatigue <= 0.3 ? "#22c55e" : fatigue <= 0.6 ? "#f59e0b" : "#ef4444", minWidth:36, textAlign:"right" }}>{Math.round(fatigue * 100)}%</span>
        </div>
        <div style={{ fontSize:10, color:"#9ca3af", marginTop:2 }}>
          {fatigue <= 0 ? "Fresh — full power" : fatigue >= 1 ? "Exhausted — no power" : `Power reduced to ${Math.round((1 - fatigue) * 100)}%`}
        </div>
      </Field>

      {peak.key && (
        <Badge label="Primary Affinity" value={`${MAGIC_DISCIPLINES.find(d=>d.key===peak.key)?.icon || ""} ${MAGIC_DISCIPLINES.find(d=>d.key===peak.key)?.label || peak.key} (${peak.level})`} color="#ea580c" />
      )}

      <Field label="Magic Disciplines">
        <DisciplinesEditor disciplines={disciplines} onChange={setDisciplines} entityType="dragon" artifacts={artifacts} />
      </Field>

      <Field label="Allegiance">
        <select value={allegiance} onChange={e => setAllegiance(e.target.value)} style={selectStyle}>
          <option value="">— Wild —</option>
          {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
        </select>
      </Field>
      <Field label="Rider">
        <select value={rider} onChange={e => setRider(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {riderOptions.map(r => <option key={r.primary_key} value={r.primary_key}>{r.name}{r.sort_key === "Mage" ? " (Mage)" : ""}</option>)}
        </select>
      </Field>
      <Field label="Army">
        <select value={army} onChange={e => setArmy(e.target.value)} style={selectStyle}>
          <option value="">— None —</option>
          {armies.map(a => <option key={a.primary_key} value={a.primary_key}>{a.name}</option>)}
        </select>
      </Field>
      <Field label="City">
        <select value={cityVal} onChange={e => setCityVal(e.target.value)} style={selectStyle}>
          <option value="">— On map —</option>
          {cities.map(c => <option key={c.primary_key} value={c.primary_key}>{c.name}</option>)}
        </select>
      </Field>
      <Field label="Current Location">
        <Badge label="Location" value={locationDesc} />
      </Field>
      <Field label="Token Color">
        <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
          {DRAGON_COLORS.map(c => (
            <div key={c} onClick={() => setColor(c)} style={{
              width:20, height:20, borderRadius:4, background:c, cursor:"pointer",
              border: color === c ? "2px solid #111" : "2px solid transparent",
            }} />
          ))}
        </div>
      </Field>
      <Field label="Artifacts">
        <ArtifactsField artifacts={artifacts} onChange={setArtifacts} globalEquippedIds={globalEquippedIds} />
      </Field>
      <Field label="Notes">
        <textarea value={notes} onChange={e => setNotes(e.target.value)}
          rows={3} style={{ ...inputStyle, resize:"vertical" }} placeholder="Lore, abilities..." />
      </Field>
      <div style={{ display:"flex", gap:6, marginTop:4 }}>
        <button onClick={() => onUpdate({ ...dragon, name, element, dragonSize, allegiance, rider, army, notes, color, city: cityVal, artifacts: (artifacts && artifacts?.length > 0) ? artifacts : undefined, disciplines, fatigue })} style={mkBtn("#3b82f6")}>Save</button>
        <button onClick={onDelete} style={mkBtn("#ef4444")}>Delete</button>
      </div>
    </Panel>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────
export default function T2() {
  const svgRef = useRef(null);
  const containerRef = useRef(null);
  const [containerSize, setContainerSize] = useState({ w: 800, h: 600 });
  const [tool, setTool]           = useState("select");
  const [selectedColor, setSelectedColor] = useState(KINGDOM_COLORS[2]);

  // Schema-aligned state
  // Kingdom:   { primary_key, sort_key:"Kingdom", name, color, points:[[x,y],...], notes }
  // City:      { primary_key, sort_key:"City", name, allegiance, status, coordinates:"x,y", notes, color(ui) }
  // Character: { primary_key, sort_key:"Character", name, role, allegiance, army, city, coordinates, notes, color }
  // Army:      { primary_key, sort_key:"army#generalName", name, allegiance, city, coordinates, size, general, notes, color }
  const [kingdoms,   setKingdoms]   = useState([]);
  const [cities,     setCities]     = useState([]);
  const [characters, setCharacters] = useState([]);
  const [armies,     setArmies]     = useState([]);
  const [mages,      setMages]      = useState([]);
  const [dragons,    setDragons]    = useState([]);

  const [drawingPoints, setDrawingPoints] = useState([]);
  const [panel, setPanel]           = useState(null); // { type, id }

  // API state
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showBattle, setShowBattle] = useState(false);
  const [showPowerRankings, setShowPowerRankings] = useState(false);
  const [showFatigueManager, setShowFatigueManager] = useState(false);
  const [showGearModal, setShowGearModal] = useState(false);
  const [showReadiness, setShowReadiness] = useState(false);
  const [sidebarSearch, setSidebarSearch] = useState("");

  // ── Initial data load ─────────────────────────────────────────────────────
  useEffect(() => {
    apiGet()
      .then(data => {
        setKingdoms(data.kingdoms   || []);
        setCities(data.cities       || []);
        setCharacters(data.characters || []);
        setArmies(data.armies       || []);
        setMages(data.mages         || []);
        setDragons(data.dragons     || []);
      })
      .catch(err => setApiError(err.message))
      .finally(() => setLoading(false));
  }, []);

  // Modal state: pending placement
  const [modal, setModal] = useState(null); // { type, x, y } — position queued, waiting for name

  // dragging tokens
  const [dragging, setDragging]     = useState(null); // { type:"character"|"army"|"mage"|"dragon", id }
  const [dragPos,  setDragPos]      = useState(null);

  // kingdom border editing
  const [editingKingdom, setEditingKingdom] = useState(null); // { id, points: [[x,y],...] }
  const [draggingVertex, setDraggingVertex] = useState(null); // index into editingKingdom.points

  // context menu
  const [contextMenu, setContextMenu] = useState(null); // { x, y, wx, wy, entity? }

  const [pan,  setPan]  = useState({ x:0, y:0 });
  const [zoom, setZoom] = useState(1);
  const isPanning  = useRef(false);
  const panStart   = useRef(null);
  const panOrigin  = useRef(null);
  const didPan     = useRef(false);

  const getSVGPoint = useCallback((e) => {
    const rect = svgRef.current.getBoundingClientRect();
    return [(e.clientX - rect.left - pan.x) / zoom, (e.clientY - rect.top - pan.y) / zoom];
  }, [pan, zoom]);

  // Which army token is at map coords (wx,wy)?
  const armyAt = useCallback((wx, wy) => {
    for (const army of armies)
      if (army.coordinates) {
        const { x, y } = parseCoord(army.coordinates);
        if (Math.abs(wx - x) < 16 && Math.abs(wy - y) < 16) return army;
      }
    return null;
  }, [armies]);

  // Which mage is at map coords?
  const mageAt = useCallback((wx, wy) => {
    for (const m of mages)
      if (m.coordinates) {
        const { x, y } = parseCoord(m.coordinates);
        if (Math.abs(wx - x) < 14 && Math.abs(wy - y) < 14) return m;
      }
    return null;
  }, [mages]);

  // Which dragon is at map coords?
  const dragonAt = useCallback((wx, wy) => {
    for (const d of dragons)
      if (d.coordinates) {
        const { x, y } = parseCoord(d.coordinates);
        if (Math.abs(wx - x) < 14 && Math.abs(wy - y) < 14) return d;
      }
    return null;
  }, [dragons]);

  // Which city is at map coords (wx,wy)?
  const cityAt = useCallback((wx, wy) => {
    for (const city of cities)
      if (city.coordinates) {
        const { x, y } = parseCoord(city.coordinates);
        if (Math.abs(wx - x) < 20 && Math.abs(wy - y) < 20) return city;
      }
    return null;
  }, [cities]);

  // Which kingdom polygon contains (wx,wy)?
  const kingdomAt = useCallback((wx, wy) => {
    for (let i = kingdoms.length - 1; i >= 0; i--)
      if (kingdoms[i].points && pointInPolygon(wx, wy, kingdoms[i].points)) return kingdoms[i];
    return null;
  }, [kingdoms]);

  // ── Pan / zoom ────────────────────────────────────────────────────────────
  const handleMouseDown = useCallback((e) => {
    setContextMenu(null); // close context menu on any click
    if (e.button === 1 || (e.button === 0 && tool === "pan")) {
      isPanning.current = true; didPan.current = false;
      panStart.current  = { x:e.clientX, y:e.clientY };
      panOrigin.current = { ...pan };
      e.preventDefault();
    }
  }, [tool, pan]);

  const handleMouseMove = useCallback((e) => {
    if (isPanning.current) {
      const dx = e.clientX - panStart.current.x, dy = e.clientY - panStart.current.y;
      if (Math.abs(dx) > 2 || Math.abs(dy) > 2) didPan.current = true;
      setPan({ x:panOrigin.current.x + dx, y:panOrigin.current.y + dy });
    }
    if (draggingVertex !== null && editingKingdom) {
      const [wx, wy] = getSVGPoint(e);
      const [gx, gy] = snapToGrid(wx, wy);
      setEditingKingdom(ek => {
        const pts = [...ek.points];
        pts[draggingVertex] = [gx, gy];
        return { ...ek, points: pts };
      });
    }
    if (dragging) setDragPos(getSVGPoint(e));
  }, [dragging, draggingVertex, editingKingdom, getSVGPoint]);

  const handleMouseUp = useCallback(async (e) => {
    // Always reset panning state first
    const wasPanning = isPanning.current;
    isPanning.current = false;

    if (draggingVertex !== null) { setDraggingVertex(null); }

    if (dragging) {
      const [wx, wy] = getSVGPoint(e);
      const [gx, gy] = snapToGrid(wx, wy);
      const nearCity  = cityAt(wx, wy);
      let updated = null;

      const nearArmy = (dragging.type === "character" || dragging.type === "mage" || dragging.type === "dragon") ? armyAt(wx, wy) : null;

      if (dragging.type === "character") {
        setCharacters(cs => cs.map(c => {
          if (c.primary_key !== dragging.id) return c;
          if (nearArmy && nearArmy.primary_key !== dragging.id) {
            updated = { ...c, army: nearArmy.primary_key, coordinates: null };
          } else if (nearCity) {
            updated = { ...c, city: nearCity.primary_key, coordinates: null };
          } else {
            updated = { ...c, city: null, army: null, coordinates: coordStr(gx, gy) };
          }
          return updated;
        }));
      } else if (dragging.type === "mage") {
        setMages(ms => ms.map(m => {
          if (m.primary_key !== dragging.id) return m;
          if (nearArmy) {
            updated = { ...m, army: nearArmy.primary_key, city: null, coordinates: null };
          } else if (nearCity) {
            updated = { ...m, city: nearCity.primary_key, army: null, coordinates: null };
          } else {
            updated = { ...m, city: null, army: null, coordinates: coordStr(gx, gy) };
          }
          return updated;
        }));
      } else if (dragging.type === "dragon") {
        setDragons(ds => ds.map(d => {
          if (d.primary_key !== dragging.id) return d;
          if (nearArmy) {
            updated = { ...d, army: nearArmy.primary_key, city: null, coordinates: null };
          } else if (nearCity) {
            updated = { ...d, city: nearCity.primary_key, army: null, coordinates: null };
          } else {
            updated = { ...d, city: null, army: null, coordinates: coordStr(gx, gy) };
          }
          return updated;
        }));
      } else {
        setArmies(as => as.map(a => {
          if (a.primary_key !== dragging.id) return a;
          updated = nearCity
            ? { ...a, city: nearCity.primary_key, coordinates: null }
            : { ...a, city: null, coordinates: coordStr(gx, gy) };
          return updated;
        }));
      }
      setDragging(null); setDragPos(null);
      if (updated) {
        setPanel(null); // Close panel to prevent stale data after drag
        try { await apiPut(updated); } catch (e) { console.error("Failed to save position:", e); }
      }
    }
  }, [dragging, draggingVertex, getSVGPoint, cityAt, armyAt]);

  const handleWheel = useCallback((e) => {
    e.preventDefault();
    const rect = svgRef.current.getBoundingClientRect();
    const cx = e.clientX - rect.left, cy = e.clientY - rect.top;
    const factor = e.deltaY < 0 ? 1.1 : 0.9;
    const nz = Math.min(4, Math.max(0.3, zoom * factor));
    setZoom(nz);
    setPan({ x:cx - (cx - pan.x) * (nz / zoom), y:cy - (cy - pan.y) * (nz / zoom) });
  }, [zoom, pan]);

  useEffect(() => {
    const el = svgRef.current;
    if (!el) return;
    el.addEventListener("wheel", handleWheel, { passive:false });
    return () => el.removeEventListener("wheel", handleWheel);
  }, [handleWheel]);

  // Track container size for scrollbars
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(entries => {
      const { width, height } = entries[0].contentRect;
      setContainerSize({ w: width, h: height });
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  // Release vertex drag on window mouseup so it fires even if mouse leaves SVG
  useEffect(() => {
    const onUp = () => { if (draggingVertex !== null) setDraggingVertex(null); };
    window.addEventListener("mouseup", onUp);
    return () => window.removeEventListener("mouseup", onUp);
  }, [draggingVertex]);

  // ── Click → open modal or draw ────────────────────────────────────────────
  const handleSVGClick = useCallback((e) => {
    if (tool === "pan" || modal) return;
    if (didPan.current) { didPan.current = false; return; }
    setContextMenu(null);
    const [wx, wy] = getSVGPoint(e);
    const [gx, gy] = snapToGrid(wx, wy);

    // In edit mode — check for click near an edge to insert a new point
    // if (editingKingdom) {
    //   const pts = editingKingdom.points;
    //   let minDist = Infinity, minIdx = -1;
    //   for (let i = 0; i < pts.length; i++) {
    //     const a = pts[i];
    //     const b = pts[(i + 1) % pts.length];
    //     const dist = distToSegment(wx, wy, a, b);
    //     if (dist < minDist) { minDist = dist; minIdx = i; }
    //   }
    //   if (minDist < 20 / zoom) {
    //     const newPts = [...pts];
    //     newPts.splice(minIdx + 1, 0, [gx, gy]);
    //     setEditingKingdom(ek => ({ ...ek, points: newPts }));
    //   }
    //   return;
    // }

    if (tool === "draw") {
      if (e.detail === 2 && drawingPoints.length >= 3) {
        setModal({ type:"kingdom", points: drawingPoints.slice(0, -1), color: selectedColor });
        setDrawingPoints([]);
      } else if (e.detail === 1) {
        setDrawingPoints(p => [...p, [gx, gy]]);
      }
      return;
    }
    if (["city","character","army","mage","dragon"].includes(tool)) {
      setModal({ type:tool, x:gx, y:gy });
      return;
    }
    if (tool === "select") {
      // hit-test: dragons > mages > armies > characters > cities > kingdoms
      for (const d of dragons) {
        if (!d.coordinates) continue;
        const { x, y } = parseCoord(d.coordinates);
        if (Math.abs(wx - x) < 14 && Math.abs(wy - y) < 14) { setPanel({ type:"dragon", id:d.primary_key }); return; }
      }
      for (const m of mages) {
        if (!m.coordinates) continue;
        const { x, y } = parseCoord(m.coordinates);
        if (Math.abs(wx - x) < 14 && Math.abs(wy - y) < 14) { setPanel({ type:"mage", id:m.primary_key }); return; }
      }
      for (const a of armies) {
        if (!a.coordinates) continue;
        const { x, y } = parseCoord(a.coordinates);
        if (Math.abs(wx - x) < 14 && Math.abs(wy - y) < 14) { setPanel({ type:"army", id:a.primary_key }); return; }
      }
      for (const ch of characters) {
        if (!ch.coordinates) continue;
        const { x, y } = parseCoord(ch.coordinates);
        if (Math.abs(wx - x) < 14 && Math.abs(wy - y) < 14) { setPanel({ type:"character", id:ch.primary_key }); return; }
      }
      for (const city of cities) {
        if (!city.coordinates) continue;
        const { x, y } = parseCoord(city.coordinates);
        if (Math.abs(wx - x) < 14 && Math.abs(wy - y) < 14) { setPanel({ type:"city", id:city.primary_key }); return; }
      }
      const k = kingdomAt(wx, wy);
      if (k) { setPanel({ type:"kingdom", id:k.primary_key }); return; }
      setPanel(null);
    }
  }, [tool, getSVGPoint, drawingPoints, selectedColor, armies, characters, cities, mages, dragons, kingdomAt, modal, editingKingdom, zoom]);

  // ── Modal confirm ─────────────────────────────────────────────────────────
  const handleModalConfirm = useCallback(async ({ name, size, role, school, power, element, dragonSize, disciplines }) => {
    const primary_key = `${modal.type}_${Date.now()}`;
    let newItem = null;

    if (modal.type === "kingdom") {
      newItem = { primary_key, sort_key:"Kingdom", name, color: modal.color, points: modal.points, notes:"" };
      setKingdoms(ks => [...ks, newItem]);
    } else if (modal.type === "city") {
      newItem = { primary_key, sort_key:"City", name, allegiance:"", status:"normal", coordinates: coordStr(modal.x, modal.y), notes:"" };
      setCities(cs => [...cs, newItem]);
    } else if (modal.type === "character") {
      const colorIdx = characters.length % CHAR_COLORS.length;
      newItem = { primary_key, sort_key:"Character", name, role: role || "", allegiance:"", army:"", coordinates: coordStr(modal.x, modal.y), notes:"", color: CHAR_COLORS[colorIdx], skill: 5 };
      setCharacters(cs => [...cs, newItem]);
    } else if (modal.type === "army") {
      const colorIdx = armies.length % ARMY_COLORS.length;
      newItem = { primary_key, sort_key:`army#`, name, allegiance:"", general:"", coordinates: coordStr(modal.x, modal.y), size: size || 0, notes:"", color: ARMY_COLORS[colorIdx] };
      setArmies(as => [...as, newItem]);
    } else if (modal.type === "mage") {
      const colorIdx = mages.length % MAGE_COLORS.length;
      const initDisc = disciplines || {};
      newItem = { primary_key, sort_key:"Mage", name, school: school || "", power: power || 5, skill: 5, allegiance:"", army:"", city:"", coordinates: coordStr(modal.x, modal.y), notes:"", color: MAGE_COLORS[colorIdx], disciplines: initDisc };
      setMages(ms => [...ms, newItem]);
    } else if (modal.type === "dragon") {
      const colorIdx = dragons.length % DRAGON_COLORS.length;
      const initDisc = disciplines || {};
      newItem = { primary_key, sort_key:"Dragon", name, element: element || "", dragonSize: dragonSize || "Adult", skill: 5, allegiance:"", rider:"", army:"", city:"", coordinates: coordStr(modal.x, modal.y), notes:"", color: DRAGON_COLORS[colorIdx], disciplines: initDisc };
      setDragons(ds => [...ds, newItem]);
    }

    setModal(null);

    if (newItem) {
      try { await apiPut(newItem); }
      catch (err) { console.error("Failed to save new item:", err); }
    }
  }, [modal, characters.length, armies.length, mages.length, dragons.length]);

  // ── Token drag start ──────────────────────────────────────────────────────
  const handleTokenMouseDown = useCallback((e, type, id) => {
    if (tool !== "select") return;
    e.stopPropagation();
    setDragging({ type, id });
    setDragPos(getSVGPoint(e));
  }, [tool, getSVGPoint]);

  // ── Move entity out of city back to map ───────────────────────────────────
  const handleMoveOut = useCallback(async (id, type) => {
    let updated = null;
    if (type === "character") {
      setCharacters(cs => cs.map(c => {
        if (c.primary_key !== id) return c;
        const city = cities.find(ci => ci.primary_key === c.city);
        const base = city?.coordinates ? parseCoord(city.coordinates) : { x:400, y:400 };
        updated = { ...c, city: null, coordinates: coordStr(base.x + 30, base.y + 30) };
        return updated;
      }));
    } else if (type === "mage") {
      setMages(ms => ms.map(m => {
        if (m.primary_key !== id) return m;
        const city = cities.find(ci => ci.primary_key === m.city);
        const army = armies.find(a => a.primary_key === m.army);
        const base = city?.coordinates ? parseCoord(city.coordinates) : army?.coordinates ? parseCoord(army.coordinates) : { x:400, y:400 };
        updated = { ...m, city: null, army: null, coordinates: coordStr(base.x + 30, base.y - 30) };
        return updated;
      }));
    } else if (type === "dragon") {
      setDragons(ds => ds.map(d => {
        if (d.primary_key !== id) return d;
        const city = cities.find(ci => ci.primary_key === d.city);
        const army = armies.find(a => a.primary_key === d.army);
        const base = city?.coordinates ? parseCoord(city.coordinates) : army?.coordinates ? parseCoord(army.coordinates) : { x:400, y:400 };
        updated = { ...d, city: null, army: null, coordinates: coordStr(base.x - 30, base.y - 30) };
        return updated;
      }));
    } else if (type === "fromArmy") {
      // Moving a character out of an army back to map
      setCharacters(cs => cs.map(c => {
        if (c.primary_key !== id) return c;
        const army = armies.find(a => a.primary_key === c.army);
        const base = army?.coordinates ? parseCoord(army.coordinates) : { x:400, y:400 };
        updated = { ...c, army: null, coordinates: coordStr(base.x + 30, base.y + 30) };
        return updated;
      }));
    } else if (type === "fromArmyMage") {
      setMages(ms => ms.map(m => {
        if (m.primary_key !== id) return m;
        const army = armies.find(a => a.primary_key === m.army);
        const base = army?.coordinates ? parseCoord(army.coordinates) : { x:400, y:400 };
        updated = { ...m, army: null, coordinates: coordStr(base.x + 30, base.y - 30) };
        return updated;
      }));
    } else if (type === "fromArmyDragon") {
      setDragons(ds => ds.map(d => {
        if (d.primary_key !== id) return d;
        const army = armies.find(a => a.primary_key === d.army);
        const base = army?.coordinates ? parseCoord(army.coordinates) : { x:400, y:400 };
        updated = { ...d, army: null, coordinates: coordStr(base.x - 30, base.y - 30) };
        return updated;
      }));
    } else {
      // Moving an army out of a city
      setArmies(as => as.map(a => {
        if (a.primary_key !== id) return a;
        const city = cities.find(ci => ci.primary_key === a.city);
        const base = city?.coordinates ? parseCoord(city.coordinates) : { x:400, y:400 };
        updated = { ...a, city: null, coordinates: coordStr(base.x - 30, base.y + 30) };
        return updated;
      }));
    }
    if (updated) {
      try { await apiPut(updated); } catch (e) { console.error("Failed to move out:", e); }
    }
  }, [cities, armies]);

  // ── Finish kingdom from sidebar button ────────────────────────────────────
  const finishKingdom = useCallback(() => {
    if (drawingPoints.length >= 3)
      setModal({ type:"kingdom", points: drawingPoints, color: selectedColor });
      setDrawingPoints([]);
  }, [drawingPoints, selectedColor]);

  // ── CRUD ──────────────────────────────────────────────────────────────────
  const updateKingdom = useCallback(async (u) => {
    setKingdoms(ks => ks.map(k => k.primary_key === u.primary_key ? u : k));
    try { setSaving(true); await apiPut(u); } catch (e) { console.error(e); } finally { setSaving(false); }
  }, []);
  const updateCity = useCallback(async (u) => {
    setCities(cs => cs.map(c => c.primary_key === u.primary_key ? u : c));
    try { setSaving(true); await apiPut(u); } catch (e) { console.error(e); } finally { setSaving(false); }
  }, []);
  const updateCharacter = useCallback(async (u) => {
    setCharacters(cs => cs.map(c => c.primary_key === u.primary_key ? u : c));
    try { setSaving(true); await apiPut(u); } catch (e) { console.error(e); } finally { setSaving(false); }
  }, []);
  const updateArmy = useCallback(async (u) => {
    setArmies(as => as.map(a => a.primary_key === u.primary_key ? u : a));
    try { setSaving(true); await apiPut(u); } catch (e) { console.error(e); } finally { setSaving(false); }
  }, []);
  const deleteKingdom = useCallback(async (id) => {
    setKingdoms(ks => ks.filter(k => k.primary_key !== id)); setPanel(null);
    try { await apiDelete(id, "Kingdom"); } catch (e) { console.error(e); }
  }, []);
  const deleteCity = useCallback(async (id) => {
    setCities(cs => cs.filter(c => c.primary_key !== id)); setPanel(null);
    try { await apiDelete(id, "City"); } catch (e) { console.error(e); }
  }, []);
  const deleteCharacter = useCallback(async (id) => {
    setCharacters(cs => cs.filter(c => c.primary_key !== id)); setPanel(null);
    try { await apiDelete(id, "Character"); } catch (e) { console.error(e); }
  }, []);
  const deleteArmy = useCallback(async (id, sort_key) => {
    setArmies(as => as.filter(a => a.primary_key !== id)); setPanel(null);
    try { await apiDelete(id, sort_key || "army#"); } catch (e) { console.error(e); }
  }, []);
  const updateMage = useCallback(async (u) => {
    setMages(ms => ms.map(m => m.primary_key === u.primary_key ? u : m));
    try { setSaving(true); await apiPut(u); } catch (e) { console.error(e); } finally { setSaving(false); }
  }, []);
  const deleteMage = useCallback(async (id) => {
    setMages(ms => ms.filter(m => m.primary_key !== id)); setPanel(null);
    try { await apiDelete(id, "Mage"); } catch (e) { console.error(e); }
  }, []);
  const updateDragon = useCallback(async (u) => {
    setDragons(ds => ds.map(d => d.primary_key === u.primary_key ? u : d));
    try { setSaving(true); await apiPut(u); } catch (e) { console.error(e); } finally { setSaving(false); }
  }, []);
  const deleteDragon = useCallback(async (id) => {
    setDragons(ds => ds.filter(d => d.primary_key !== id)); setPanel(null);
    try { await apiDelete(id, "Dragon"); } catch (e) { console.error(e); }
  }, []);

  // ── Kingdom border edit ──────────────────────────────────────────────────────
  const startEditingKingdom = useCallback((kingdom) => {
    setEditingKingdom({ id: kingdom.primary_key, points: kingdom.points.map(p => [...p]) });
    setPanel(null); // close panel while editing
  }, []);

  const confirmKingdomEdit = useCallback(async () => {
    if (!editingKingdom) return;
    setKingdoms(ks => ks.map(k =>
      k.primary_key === editingKingdom.id ? { ...k, points: editingKingdom.points } : k
    ));
    const updated = kingdoms.find(k => k.primary_key === editingKingdom.id);
    const saved = { ...updated, points: editingKingdom.points };
    setEditingKingdom(null);
    try { setSaving(true); await apiPut(saved); } catch (e) { console.error(e); } finally { setSaving(false); }
  }, [editingKingdom, kingdoms]);

  const cancelKingdomEdit = useCallback(() => {
    setEditingKingdom(null);
    setDraggingVertex(null);
  }, []);

  // ── Grid ──────────────────────────────────────────────────────────────────
  const gridLines = [];
  for (let x = 0; x <= CANVAS_W; x += GRID_SIZE)
    gridLines.push(<line key={`v${x}`} x1={x} y1={0} x2={x} y2={CANVAS_H} stroke="#d0d4d8" strokeWidth="0.7" />);
  for (let y = 0; y <= CANVAS_H; y += GRID_SIZE)
    gridLines.push(<line key={`h${y}`} x1={0} y1={y} x2={CANVAS_W} y2={y} stroke="#d0d4d8" strokeWidth="0.7" />);

  const cursorStyle = editingKingdom ? (draggingVertex !== null ? "grabbing" : "crosshair")
    : tool === "pan" ? "grab" : tool === "draw" ? "crosshair"
    : ["city","character","army","mage","dragon"].includes(tool) ? "cell"
    : dragging ? "grabbing" : "default";

  const panelKingdom = panel?.type === "kingdom"   ? kingdoms.find(k   => k.primary_key === panel.id) : null;
  const panelCity    = panel?.type === "city"      ? cities.find(c     => c.primary_key === panel.id) : null;
  const panelChar    = panel?.type === "character" ? characters.find(c => c.primary_key === panel.id) : null;
  const panelArmy    = panel?.type === "army"      ? armies.find(a     => a.primary_key === panel.id) : null;
  const panelMage    = panel?.type === "mage"      ? mages.find(m      => m.primary_key === panel.id) : null;
  const panelDragon  = panel?.type === "dragon"    ? dragons.find(d    => d.primary_key === panel.id) : null;

  // ── Scrollbar calculations ───────────────────────────────────────────────────
  const SCROLL_W = 12; // scrollbar track width
  const scaledW = CANVAS_W * zoom;
  const scaledH = CANVAS_H * zoom;
  // Thumb size as fraction of visible area vs total canvas
  const hThumbRatio = Math.min(1, containerSize.w / scaledW);
  const vThumbRatio = Math.min(1, containerSize.h / scaledH);
  // Clamp pan so thumb doesn't go out of track
  const maxPanX = 0;
  const minPanX = containerSize.w - scaledW;
  const maxPanY = 0;
  const minPanY = containerSize.h - scaledH;
  // Thumb position: how far into the scrollable range are we
  const hScrollRange = scaledW - containerSize.w;
  const vScrollRange = scaledH - containerSize.h;
  const hThumbX = hScrollRange > 0 ? ((-pan.x) / hScrollRange) * (containerSize.w - SCROLL_W) * (1 - hThumbRatio) : 0;
  const vThumbY = vScrollRange > 0 ? ((-pan.y) / vScrollRange) * (containerSize.h - SCROLL_W) * (1 - vThumbRatio) : 0;
  const hThumbW = (containerSize.w - SCROLL_W) * hThumbRatio;
  const vThumbH = (containerSize.h - SCROLL_W) * vThumbRatio;
  const showHScroll = hThumbRatio < 1;
  const showVScroll = vThumbRatio < 1;

  const scrollDrag = useRef(null); // { axis, startMouse, startPan }

  const handleScrollMouseDown = useCallback((e, axis) => {
    e.preventDefault();
    e.stopPropagation();
    scrollDrag.current = { axis, startMouse: axis === "h" ? e.clientX : e.clientY, startPan: { ...pan } };
    const onMove = (me) => {
      if (!scrollDrag.current) return;
      const { axis, startMouse, startPan } = scrollDrag.current;
      if (axis === "h") {
        const trackW = containerSize.w - SCROLL_W;
        const delta = (me.clientX - startMouse) / (trackW * (1 - hThumbRatio));
        const newPanX = Math.min(0, Math.max(minPanX, startPan.x - delta * hScrollRange));
        setPan(p => ({ ...p, x: newPanX }));
      } else {
        const trackH = containerSize.h - SCROLL_W;
        const delta = (me.clientY - startMouse) / (trackH * (1 - vThumbRatio));
        const newPanY = Math.min(0, Math.max(minPanY, startPan.y - delta * vScrollRange));
        setPan(p => ({ ...p, y: newPanY }));
      }
    };
    const onUp = () => { scrollDrag.current = null; window.removeEventListener("mousemove", onMove); window.removeEventListener("mouseup", onUp); };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  }, [pan, hThumbRatio, vThumbRatio, hScrollRange, vScrollRange, minPanX, minPanY, containerSize]);

  // Only show tokens for entities NOT in a city or army
  const mapCharacters = characters.filter(c => !c.city && !c.army && c.coordinates);
  const mapArmies     = armies.filter(a => !a.city && a.coordinates);
  const mapMages      = mages.filter(m => !m.city && !m.army && m.coordinates);
  const mapDragons    = dragons.filter(d => !d.city && !d.army && d.coordinates);

  function tokenXY(entity) {
    if (dragging?.id === entity.primary_key && dragPos) return { x:dragPos[0], y:dragPos[1] };
    const { x, y } = parseCoord(entity.coordinates);
    return { x, y };
  }

  // ── Fit to content ─────────────────────────────────────────────────────────
  const fitToContent = useCallback(() => {
    const allCoords = [];
    cities.forEach(c => { if (c.coordinates) { const p = parseCoord(c.coordinates); allCoords.push(p); } });
    mapCharacters.forEach(c => { const p = parseCoord(c.coordinates); allCoords.push(p); });
    mapArmies.forEach(a => { const p = parseCoord(a.coordinates); allCoords.push(p); });
    mapMages.forEach(m => { const p = parseCoord(m.coordinates); allCoords.push(p); });
    mapDragons.forEach(d => { const p = parseCoord(d.coordinates); allCoords.push(p); });
    kingdoms.forEach(k => { if (k.points) k.points.forEach(([x, y]) => allCoords.push({ x, y })); });
    if (allCoords.length === 0) { setPan({ x: 0, y: 0 }); setZoom(1); return; }
    const minX = Math.min(...allCoords.map(p => p.x));
    const maxX = Math.max(...allCoords.map(p => p.x));
    const minY = Math.min(...allCoords.map(p => p.y));
    const maxY = Math.max(...allCoords.map(p => p.y));
    const contentW = maxX - minX || 200;
    const contentH = maxY - minY || 200;
    const pad = 60;
    const scaleX = containerSize.w / (contentW + pad * 2);
    const scaleY = containerSize.h / (contentH + pad * 2);
    const newZoom = Math.min(4, Math.max(0.3, Math.min(scaleX, scaleY)));
    const cx = (minX + maxX) / 2;
    const cy = (minY + maxY) / 2;
    setPan({ x: containerSize.w / 2 - cx * newZoom, y: containerSize.h / 2 - cy * newZoom });
    setZoom(newZoom);
  }, [cities, mapCharacters, mapArmies, mapMages, mapDragons, kingdoms, containerSize]);

  // ── Context menu ──────────────────────────────────────────────────────────
  const handleContextMenu = useCallback((e) => {
    e.preventDefault();
    const [wx, wy] = getSVGPoint(e);
    const [gx, gy] = snapToGrid(wx, wy);
    // Check if right-clicking on an entity
    let entity = null;
    for (const d of dragons) { if (d.coordinates) { const p = parseCoord(d.coordinates); if (Math.abs(wx - p.x) < 14 && Math.abs(wy - p.y) < 14) { entity = { type:"dragon", id:d.primary_key }; break; } } }
    if (!entity) for (const m of mages) { if (m.coordinates) { const p = parseCoord(m.coordinates); if (Math.abs(wx - p.x) < 14 && Math.abs(wy - p.y) < 14) { entity = { type:"mage", id:m.primary_key }; break; } } }
    if (!entity) for (const a of armies) { if (a.coordinates) { const p = parseCoord(a.coordinates); if (Math.abs(wx - p.x) < 14 && Math.abs(wy - p.y) < 14) { entity = { type:"army", id:a.primary_key }; break; } } }
    if (!entity) for (const ch of characters) { if (ch.coordinates) { const p = parseCoord(ch.coordinates); if (Math.abs(wx - p.x) < 14 && Math.abs(wy - p.y) < 14) { entity = { type:"character", id:ch.primary_key }; break; } } }
    if (!entity) for (const c of cities) { if (c.coordinates) { const p = parseCoord(c.coordinates); if (Math.abs(wx - p.x) < 14 && Math.abs(wy - p.y) < 14) { entity = { type:"city", id:c.primary_key }; break; } } }
    const rect = svgRef.current.getBoundingClientRect();
    setContextMenu({ screenX: e.clientX - rect.left, screenY: e.clientY - rect.top, wx: gx, wy: gy, entity });
  }, [getSVGPoint, dragons, mages, armies, characters, cities]);

  if (loading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", fontFamily:"'Segoe UI', system-ui, sans-serif", flexDirection:"column", gap:12 }}>
      <div style={{ fontSize:28 }}>🗺</div>
      <div style={{ fontSize:14, color:"#6b7280" }}>Loading map data...</div>
    </div>
  );

  if (apiError) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", fontFamily:"'Segoe UI', system-ui, sans-serif", flexDirection:"column", gap:12 }}>
      <div style={{ fontSize:28 }}>⚠️</div>
      <div style={{ fontSize:14, color:"#ef4444", fontWeight:600 }}>Failed to load map data</div>
      <div style={{ fontSize:12, color:"#9ca3af" }}>{apiError}</div>
      <button onClick={() => window.location.reload()} style={{ marginTop:8, padding:"8px 16px", background:"#3b82f6", color:"#fff", border:"none", borderRadius:6, cursor:"pointer", fontSize:13 }}>Retry</button>
    </div>
  );

  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh", width:"100vw", fontFamily:"'Segoe UI', system-ui, sans-serif", overflow:"hidden" }}>
      {/* Header */}
      <div style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 18px", background:"#fff", borderBottom:"1px solid #d1d5db", boxShadow:"0 1px 4px #0001", zIndex:30, flexShrink:0 }}>
        <span style={{ fontSize:16, fontWeight:600, color:"#374151" }}>🗺 Map Editor</span>
        <div style={{ flex:1 }} />
        {saving && <span style={{ fontSize:11, color:"#3b82f6" }}>💾 Saving...</span>}
        <button onClick={() => setShowBattle(true)} style={{
          background: showBattle ? "#1f2937" : "#f9fafb",
          color: showBattle ? "#fff" : "#374151",
          border:"1px solid #d1d5db", borderRadius:6,
          padding:"5px 12px", fontSize:12, fontWeight:500, cursor:"pointer",
        }}>⚔ Battle</button>
        <button onClick={() => setShowPowerRankings(true)} style={{
          background:"#f9fafb", color:"#374151",
          border:"1px solid #d1d5db", borderRadius:6,
          padding:"5px 12px", fontSize:12, fontWeight:500, cursor:"pointer",
        }}>✦ Power Rankings</button>
        <button onClick={() => setShowFatigueManager(true)} style={{
          background:"#f9fafb", color:"#374151",
          border:"1px solid #d1d5db", borderRadius:6,
          padding:"5px 12px", fontSize:12, fontWeight:500, cursor:"pointer",
        }}>😓 Fatigue</button>
        <button onClick={() => setShowGearModal(true)} style={{
          background:"#f9fafb", color:"#374151",
          border:"1px solid #d1d5db", borderRadius:6,
          padding:"5px 12px", fontSize:12, fontWeight:500, cursor:"pointer",
        }}>🏺 Gear</button>
        <button onClick={() => setShowReadiness(true)} style={{
          background:"#f9fafb", color:"#374151",
          border:"1px solid #d1d5db", borderRadius:6,
          padding:"5px 12px", fontSize:12, fontWeight:500, cursor:"pointer",
        }}>🛡 Readiness</button>
        <span style={{ fontSize:11, color:"#9ca3af" }}>Scroll to zoom · Middle-click to pan · Right-click for quick menu · Draw: click then <b>Finish</b> · Drag tokens to move</span>
      </div>
 
      <div style={{ display:"flex", flex:1, overflow:"hidden" }}>
        {/* Sidebar */}
        <div style={{ width:205, background:"#fff", borderRight:"1px solid #e5e7eb", display:"flex", flexDirection:"column", padding:12, gap:10, overflowY:"auto", flexShrink:0 }}>
          <ToolSection label="TOOLS">
            {[
              { id:"select",    icon:"↖", label:"Select / Move" },
              { id:"draw",      icon:"✏", label:"Draw Kingdom" },
              { id:"city",      icon:"●", label:"Place City" },
              { id:"character", icon:"👤", label:"Add Character" },
              { id:"army",      icon:"⚔", label:"Add Army" },
              { id:"mage",      icon:"✦", label:"Add Mage" },
              { id:"dragon",    icon:"🐉", label:"Add Dragon" },
              { id:"pan",       icon:"✋", label:"Pan" },
            ].map(t => (
              <ToolBtn key={t.id} active={tool === t.id} onClick={() => { setTool(t.id); setDrawingPoints([]); }}>
                <span style={{ width:16, textAlign:"center" }}>{t.icon}</span> {t.label}
              </ToolBtn>
            ))}
          </ToolSection>
 
          {tool === "draw" && (
            <ToolSection label="KINGDOM COLOR">
              <div style={{ display:"flex", flexWrap:"wrap", gap:5 }}>
                {KINGDOM_COLORS.map(c => (
                  <div key={c} onClick={() => setSelectedColor(c)} style={{
                    width:22, height:22, borderRadius:4, background:c, cursor:"pointer",
                    border: selectedColor === c ? "2px solid #374151" : "2px solid transparent",
                  }} />
                ))}
              </div>
              <div style={{ fontSize:11, color:"#6b7280", marginTop:4 }}>{drawingPoints.length} point{drawingPoints.length !== 1 ? "s" : ""} placed</div>
              {drawingPoints.length >= 3 && <button onClick={finishKingdom} style={{ ...mkBtn("#22c55e"), marginTop:4 }}>✓ Finish Kingdom</button>}
              {drawingPoints.length > 0  && <button onClick={() => setDrawingPoints([])} style={{ ...mkBtn("#9ca3af"), marginTop:4 }}>✕ Cancel</button>}
            </ToolSection>
          )}
 
          <ToolSection label="MAP">
            <ToolBtn onClick={() => { setPan({ x:0, y:0 }); setZoom(1); }}>⊞ Reset View</ToolBtn>
            <ToolBtn onClick={fitToContent}>⊡ Fit to Content</ToolBtn>
            <div style={{ fontSize:11, color:"#9ca3af", marginTop:2, lineHeight:1.8 }}>
              {kingdoms.length} kingdoms · {cities.length} cities<br />{characters.length} chars · {armies.length} armies<br />{mages.length} mages · {dragons.length} dragons
            </div>
          </ToolSection>
 
          <div style={{ position:"relative" }}>
            <input
              value={sidebarSearch}
              onChange={e => setSidebarSearch(e.target.value)}
              placeholder="Search entities..."
              style={{ ...inputStyle, fontSize:12, paddingLeft:26 }}
            />
            <span style={{ position:"absolute", left:8, top:"50%", transform:"translateY(-50%)", fontSize:12, color:"#9ca3af", pointerEvents:"none" }}>🔍</span>
            {sidebarSearch && (
              <button onClick={() => setSidebarSearch("")} style={{ position:"absolute", right:4, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:11, color:"#9ca3af", padding:2 }}>✕</button>
            )}
          </div>
 
          {(() => {
            const q = sidebarSearch.toLowerCase().trim();
            const matchName = (item) => !q || item.name?.toLowerCase().includes(q);
            const filteredChars = characters.filter(matchName);
            const filteredArmies = armies.filter(matchName);
            const filteredMages = mages.filter(matchName);
            const filteredDragons = dragons.filter(matchName);
 
            return (
              <>
                {filteredChars.length > 0 && (
                  <ToolSection label={`CHARACTERS${q ? ` (${filteredChars.length})` : ""}`}>
                    {filteredChars.sort((a, b) => b.skill - a.skill).map(c => (
                      <SidebarItem key={c.primary_key} color={c.color} label={c.name} shape="circle"
                        sub={c.city ? `In ${cities.find(ci => ci.primary_key === c.city)?.name || "city"}` : c.army ? `In ${armies.find(a => a.primary_key === c.army)?.name || "army"}` : null}
                        active={panel?.id === c.primary_key}
                        onClick={() => setPanel({ type:"character", id:c.primary_key })} />
                    ))}
                  </ToolSection>
                )}
 
                {filteredArmies.length > 0 && (
                  <ToolSection label={`ARMIES${q ? ` (${filteredArmies.length})` : ""}`}>
                    {filteredArmies.map(a => (
                      <SidebarItem key={a.primary_key} color={a.color} label={a.name} shape="diamond"
                        sub={a.city ? `In ${cities.find(ci => ci.primary_key === a.city)?.name || "city"}` : a.size ? `${a.size.toLocaleString()} troops` : null}
                        active={panel?.id === a.primary_key}
                        onClick={() => setPanel({ type:"army", id:a.primary_key })} />
                    ))}
                  </ToolSection>
                )}
 
                {filteredMages.length > 0 && (
                  <ToolSection label={`MAGES${q ? ` (${filteredMages.length})` : ""}`}>
                    {filteredMages.sort((a, b) => calcDisciplinePowerForType(b.disciplines,"mage") - calcDisciplinePowerForType(a.disciplines,"mage")).map(m => (
                      <SidebarItem key={m.primary_key} color={m.color} label={m.name} shape="circle"
                        sub={m.city ? `In ${cities.find(ci => ci.primary_key === m.city)?.name || "city"}` : m.army ? `In ${armies.find(a => a.primary_key === m.army)?.name || "army"}` : m.school || null}
                        active={panel?.id === m.primary_key}
                        onClick={() => setPanel({ type:"mage", id:m.primary_key })} />
                    ))}
                  </ToolSection>
                )}
 
                {filteredDragons.length > 0 && (
                  <ToolSection label={`DRAGONS${q ? ` (${filteredDragons.length})` : ""}`}>
                    {filteredDragons.sort((a, b) => calcDisciplinePowerForType(b.disciplines,"dragon") - calcDisciplinePowerForType(a.disciplines,"dragon")).map(d => (
                      <SidebarItem key={d.primary_key} color={d.color} label={d.name} shape="diamond"
                        sub={d.city ? `In ${cities.find(ci => ci.primary_key === d.city)?.name || "city"}` : d.army ? `In ${armies.find(a => a.primary_key === d.army)?.name || "army"}` : d.element || null}
                        active={panel?.id === d.primary_key}
                        onClick={() => setPanel({ type:"dragon", id:d.primary_key })} />
                    ))}
                  </ToolSection>
                )}
 
                {q && filteredChars.length === 0 && filteredArmies.length === 0 && filteredMages.length === 0 && filteredDragons.length === 0 && (
                  <div style={{ fontSize:12, color:"#9ca3af", textAlign:"center", padding:12 }}>No results for "{sidebarSearch}"</div>
                )}
              </>
            );
          })()}
        </div>
 
        {/* Canvas */}
        <div ref={containerRef} style={{ flex:1, overflow:"hidden", position:"relative" }}>
          <svg ref={svgRef} width="100%" height="100%"
            style={{ cursor:cursorStyle, display:"block", background:"#f0f2f5" }}
            onMouseDown={handleMouseDown} onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp} onClick={handleSVGClick} onContextMenu={handleContextMenu}>
            <g transform={`translate(${pan.x},${pan.y}) scale(${zoom})`}>
              <rect x={0} y={0} width={CANVAS_W} height={CANVAS_H} fill="#f8f9fb" />
              {gridLines}
              <rect x={0} y={0} width={CANVAS_W} height={CANVAS_H} fill="none" stroke="#c9cdd4" strokeWidth="1.5" />
 
              {/* Kingdoms */}
              {kingdoms.map(k => {
                if (!k.points?.length) return null;
                const isEditing = editingKingdom?.id === k.primary_key;
                const displayPoints = isEditing ? editingKingdom.points : k.points;
                const pts = displayPoints.map(p => p.join(",")).join(" ");
                const isSel = panel?.type === "kingdom" && panel?.id === k.primary_key;
                const cx = displayPoints.reduce((a, p) => a + p[0], 0) / displayPoints.length;
                const cy = displayPoints.reduce((a, p) => a + p[1], 0) / displayPoints.length;
                return (
                  <g key={k.primary_key} style={{ cursor: isEditing ? "default" : "pointer" }}>
                    <polygon points={pts}
                      fill={k.color} fillOpacity={isEditing ? 0.15 : isSel ? 0.38 : 0.2}
                      stroke={k.color} strokeWidth={isEditing ? 2 : isSel ? 2.5 : 1.5}
                      strokeOpacity={isEditing ? 1 : isSel ? 1 : 0.6}
                      strokeDasharray={isEditing ? "6 3" : "none"}
                      style={{ filter: isSel && !isEditing ? `drop-shadow(0 0 5px ${k.color}88)` : "none" }} />
                    <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle"
                      fill="#1f2937" fontSize={14} fontWeight={600} style={{ pointerEvents:"none" }}
                      paintOrder="stroke" stroke="#f8f9fb" strokeWidth={3}>{k.name}</text>
                    {/* Vertex handles when editing */}
                    {isEditing && displayPoints.map((p, i) => (
                      <circle key={i} cx={p[0]} cy={p[1]} r={7}
                        fill={draggingVertex === i ? k.color : "#fff"}
                        stroke={k.color} strokeWidth={2}
                        style={{ cursor:"grab" }}
                        onMouseDown={e => { e.preventDefault(); e.stopPropagation(); setDraggingVertex(i); }} />
                    ))}
                  </g>
                );
              })}
 
              {/* In-progress drawing */}
              {drawingPoints.length > 0 && (
                <g>
                  {drawingPoints.length >= 2 && (
                    <polygon points={drawingPoints.map(p => p.join(",")).join(" ")}
                      fill={selectedColor} fillOpacity={0.1} stroke={selectedColor} strokeWidth={1.5} strokeDasharray="5 4" strokeOpacity={0.8} />
                  )}
                  {drawingPoints.map((p, i) => (
                    <circle key={i} cx={p[0]} cy={p[1]} r={4}
                      fill={i === 0 ? "#fff" : selectedColor} stroke={selectedColor} strokeWidth={1.5} />
                  ))}
                </g>
              )}
 
              {/* Cities */}
              {cities.map(c => {
                if (!c.coordinates) return null;
                const { x, y } = parseCoord(c.coordinates);
                const isSel = panel?.type === "city" && panel?.id === c.primary_key;
                const statusColor = STATUS_COLORS[c.status] || "#22c55e";
                const kColor = kingdoms.find(k => k.primary_key === c.allegiance)?.color;
                // Count chars/armies inside
                const inCount = characters.filter(ch => ch.city === c.primary_key).length
                              + armies.filter(a => a.city === c.primary_key).length
                              + mages.filter(m => m.city === c.primary_key).length
                              + dragons.filter(d => d.city === c.primary_key).length;
                return (
                  <g key={c.primary_key} style={{ cursor:"pointer" }}>
                    {isSel && <circle cx={x} cy={y} r={14} fill="none" stroke="#374151" strokeWidth={1.5} strokeDasharray="3 2" opacity={0.6} />}
                    <circle cx={x} cy={y} r={7} fill={isSel ? "#111827" : "#374151"} stroke={kColor || "#f8f9fb"} strokeWidth={2} />
                    <circle cx={x+6} cy={y-6} r={3.5} fill={statusColor} stroke="#fff" strokeWidth={1} />
                    {inCount > 0 && (
                      <text x={x-8} y={y-7} textAnchor="middle" fill="#374151" fontSize={9} fontWeight={700} style={{ pointerEvents:"none" }}>{inCount}</text>
                    )}
                    <text x={x} y={y+18} textAnchor="middle" fill="#1f2937" fontSize={11} fontWeight={500}
                      style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={3}>{c.name}</text>
                  </g>
                );
              })}
 
              {/* Army tokens (map only — not in city) */}
              {mapArmies.map(a => {
                const isSel = panel?.type === "army" && panel?.id === a.primary_key;
                const isDrag = dragging?.id === a.primary_key && dragging?.type === "army";
                const { x, y } = tokenXY(a);
                const d = 12;
                const pts = `${x},${y-d} ${x+d},${y} ${x},${y+d} ${x-d},${y}`;
                // Check for magical support
                const armyMages = mages.filter(m => m.army === a.primary_key);
                const armyDragons = dragons.filter(dr => dr.army === a.primary_key);
                const armyChars = characters.filter(c => c.army === a.primary_key);
                const magicCount = armyMages.length + armyDragons.length;
                const entityCount = magicCount + armyChars.length;
                return (
                  <g key={a.primary_key} onMouseDown={e => handleTokenMouseDown(e, "army", a.primary_key)}
                    style={{ cursor: tool === "select" ? "grab" : "default" }}>
                    {/* Magic support glow */}
                    {magicCount > 0 && (
                      <polygon points={`${x},${y-d-6} ${x+d+6},${y} ${x},${y+d+6} ${x-d-6},${y}`}
                        fill="none" stroke="#8b5cf6" strokeWidth={2} opacity={0.5} strokeDasharray="4 2">
                        <animate attributeName="opacity" values="0.3;0.7;0.3" dur="2s" repeatCount="indefinite" />
                      </polygon>
                    )}
                    {isSel && <polygon points={`${x},${y-d-4} ${x+d+4},${y} ${x},${y+d+4} ${x-d-4},${y}`}
                      fill="none" stroke={a.color} strokeWidth={1.5} strokeDasharray="3 2" />}
                    <polygon points={pts} fill={a.color} stroke="#fff" strokeWidth={2} opacity={isDrag ? 0.7 : 1} />
                    <text x={x} y={y+1} textAnchor="middle" dominantBaseline="middle"
                      fill="#fff" fontSize={9} fontWeight={700} style={{ pointerEvents:"none" }}>⚔</text>
                    {/* Name + size */}
                    <text x={x} y={y+20} textAnchor="middle" fill="#1f2937" fontSize={10} fontWeight={600}
                      style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={3}>{a.name}</text>
                    {a.size > 0 && <text x={x} y={y+30} textAnchor="middle" fill="#6b7280" fontSize={9}
                      style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={2}>{a.size.toLocaleString()}</text>}
                    {/* Entity count badge */}
                    {entityCount > 0 && (
                      <g>
                        <circle cx={x+d+3} cy={y-d-3} r={7} fill={magicCount > 0 ? "#7c3aed" : "#6b7280"} stroke="#fff" strokeWidth={1.5} />
                        <text x={x+d+3} y={y-d-2} textAnchor="middle" dominantBaseline="middle"
                          fill="#fff" fontSize={7} fontWeight={700} style={{ pointerEvents:"none" }}>{entityCount}</text>
                      </g>
                    )}
                  </g>
                );
              })}
 
              {/* Character tokens (map only) */}
              {mapCharacters.map(c => {
                const isSel = panel?.type === "character" && panel?.id === c.primary_key;
                const isDrag = dragging?.id === c.primary_key && dragging?.type === "character";
                const { x, y } = tokenXY(c);
                return (
                  <g key={c.primary_key} onMouseDown={e => handleTokenMouseDown(e, "character", c.primary_key)}
                    style={{ cursor: tool === "select" ? "grab" : "default" }}>
                    {isSel && <circle cx={x} cy={y} r={14} fill="none" stroke={c.color} strokeWidth={1.5} strokeDasharray="3 2" />}
                    <circle cx={x} cy={y} r={9} fill={c.color} stroke="#fff" strokeWidth={2} opacity={isDrag ? 0.7 : 1} />
                    <text x={x} y={y+1} textAnchor="middle" dominantBaseline="middle"
                      fill="#fff" fontSize={10} fontWeight={700} style={{ pointerEvents:"none" }}>
                      {c.name.charAt(0).toUpperCase()}
                    </text>
                    <text x={x} y={y+18} textAnchor="middle" fill="#1f2937" fontSize={10} fontWeight={500}
                      style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={3}>{c.name}</text>
                  </g>
                );
              })}
 
              {/* Mage tokens (map only) */}
              {mapMages.map(m => {
                const isSel = panel?.type === "mage" && panel?.id === m.primary_key;
                const isDrag = dragging?.id === m.primary_key && dragging?.type === "mage";
                const { x, y } = tokenXY(m);
                const peak = peakDiscipline(m.disciplines);
                const peakInfo = peak.key ? MAGIC_DISCIPLINES.find(dd => dd.key === peak.key) : null;
                const peakColor = peakInfo?.color || m.color;
                const fat = m.fatigue || 0;
                const equippedCount = (Array.isArray(m.artifacts) ? m.artifacts : []).filter(a => a?.equipped && (a?.energy || 0) > 0).length;
                const power = calcDisciplinePowerForType(m.disciplines, "mage", m.artifacts, fat);
                return (
                  <g key={m.primary_key} onMouseDown={e => handleTokenMouseDown(e, "mage", m.primary_key)}
                    style={{ cursor: tool === "select" ? "grab" : "default" }}>
                    {/* Outer discipline ring */}
                    <circle cx={x} cy={y} r={13} fill="none" stroke={peakColor} strokeWidth={2.5} opacity={isDrag ? 0.5 : 0.8} />
                    {isSel && <circle cx={x} cy={y} r={16} fill="none" stroke={peakColor} strokeWidth={1.5} strokeDasharray="3 2" />}
                    {/* Main circle */}
                    <circle cx={x} cy={y} r={10} fill={m.color} stroke="#fff" strokeWidth={2} opacity={isDrag ? 0.7 : 1} />
                    <text x={x} y={y+1} textAnchor="middle" dominantBaseline="middle"
                      fill="#fff" fontSize={11} fontWeight={700} style={{ pointerEvents:"none" }}>✦</text>
                    {/* Name */}
                    <text x={x} y={y+22} textAnchor="middle" fill="#1f2937" fontSize={10} fontWeight={600}
                      style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={3}>{m.name}</text>
                    {/* Peak discipline icon */}
                    {peakInfo && (
                      <g>
                        <circle cx={x+11} cy={y-11} r={6} fill={peakColor} stroke="#fff" strokeWidth={1} />
                        <text x={x+11} y={y-10} textAnchor="middle" dominantBaseline="middle"
                          fill="#fff" fontSize={7} style={{ pointerEvents:"none" }}>{peakInfo.icon}</text>
                      </g>
                    )}
                    {/* Artifact count badge */}
                    {equippedCount > 0 && (
                      <g>
                        <circle cx={x-11} cy={y-11} r={5} fill="#d97706" stroke="#fff" strokeWidth={1} />
                        <text x={x-11} y={y-10} textAnchor="middle" dominantBaseline="middle"
                          fill="#fff" fontSize={6} fontWeight={700} style={{ pointerEvents:"none" }}>{equippedCount}</text>
                      </g>
                    )}
                    {/* Fatigue indicator */}
                    {fat > 0.3 && (
                      <text x={x} y={y+31} textAnchor="middle" fill={fat > 0.6 ? "#ef4444" : "#f59e0b"} fontSize={8}
                        style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={2}>
                        {fat > 0.6 ? "😓" : "💤"} {Math.round(fat*100)}%
                      </text>
                    )}
                  </g>
                );
              })}
 
              {/* Dragon tokens (map only) */}
              {mapDragons.map(d => {
                const isSel = panel?.type === "dragon" && panel?.id === d.primary_key;
                const isDrag = dragging?.id === d.primary_key && dragging?.type === "dragon";
                const { x, y } = tokenXY(d);
                const s = 12;
                const triPts = `${x},${y-s} ${x+s},${y+s} ${x-s},${y+s}`;
                const peak = peakDiscipline(d.disciplines);
                const peakInfo = peak.key ? MAGIC_DISCIPLINES.find(dd => dd.key === peak.key) : null;
                const peakColor = peakInfo?.color || d.color;
                const fat = d.fatigue || 0;
                const equippedCount = (Array.isArray(d.artifacts) ? d.artifacts : []).filter(a => a?.equipped && (a?.energy || 0) > 0).length;
                // Size-based scaling
                const sizeScale = d.dragonSize === "Ancient" ? 1.3 : d.dragonSize === "Adult" ? 1.1 : d.dragonSize === "Young" ? 0.95 : 0.8;
                const ss = Math.round(s * sizeScale);
                const scaledPts = `${x},${y-ss} ${x+ss},${y+ss} ${x-ss},${y+ss}`;
                return (
                  <g key={d.primary_key} onMouseDown={e => handleTokenMouseDown(e, "dragon", d.primary_key)}
                    style={{ cursor: tool === "select" ? "grab" : "default" }}>
                    {/* Outer discipline glow */}
                    <polygon points={`${x},${y-ss-5} ${x+ss+5},${y+ss+5} ${x-ss-5},${y+ss+5}`}
                      fill="none" stroke={peakColor} strokeWidth={2.5} opacity={isDrag ? 0.4 : 0.7} />
                    {isSel && <polygon points={`${x},${y-ss-8} ${x+ss+8},${y+ss+8} ${x-ss-8},${y+ss+8}`}
                      fill="none" stroke={peakColor} strokeWidth={1.5} strokeDasharray="3 2" />}
                    {/* Main triangle */}
                    <polygon points={scaledPts} fill={d.color} stroke="#fff" strokeWidth={2} opacity={isDrag ? 0.7 : 1} />
                    <text x={x} y={y+Math.round(ss*0.4)} textAnchor="middle" dominantBaseline="middle"
                      fill="#fff" fontSize={Math.round(9*sizeScale)} fontWeight={700} style={{ pointerEvents:"none" }}>🐉</text>
                    {/* Name + element */}
                    <text x={x} y={y+ss+14} textAnchor="middle" fill="#1f2937" fontSize={10} fontWeight={600}
                      style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={3}>{d.name}</text>
                    {d.element && <text x={x} y={y+ss+24} textAnchor="middle" fill="#6b7280" fontSize={9}
                      style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={2}>{d.element}</text>}
                    {/* Peak discipline badge */}
                    {peakInfo && (
                      <g>
                        <circle cx={x+ss+2} cy={y-ss+2} r={6} fill={peakColor} stroke="#fff" strokeWidth={1} />
                        <text x={x+ss+2} y={y-ss+3} textAnchor="middle" dominantBaseline="middle"
                          fill="#fff" fontSize={7} style={{ pointerEvents:"none" }}>{peakInfo.icon}</text>
                      </g>
                    )}
                    {/* Artifact badge */}
                    {equippedCount > 0 && (
                      <g>
                        <circle cx={x-ss-2} cy={y-ss+2} r={5} fill="#d97706" stroke="#fff" strokeWidth={1} />
                        <text x={x-ss-2} y={y-ss+3} textAnchor="middle" dominantBaseline="middle"
                          fill="#fff" fontSize={6} fontWeight={700} style={{ pointerEvents:"none" }}>{equippedCount}</text>
                      </g>
                    )}
                    {/* Fatigue */}
                    {fat > 0.3 && (
                      <text x={x} y={y+ss+(d.element ? 33 : 24)} textAnchor="middle" fill={fat > 0.6 ? "#ef4444" : "#f59e0b"} fontSize={8}
                        style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={2}>
                        {fat > 0.6 ? "😓" : "💤"} {Math.round(fat*100)}%
                      </text>
                    )}
                    {/* Size label for Ancient/Wyrmling */}
                    {(d.dragonSize === "Ancient" || d.dragonSize === "Wyrmling") && (
                      <text x={x} y={y-ss-5} textAnchor="middle" fill={d.dragonSize === "Ancient" ? "#7c3aed" : "#9ca3af"} fontSize={7} fontWeight={600}
                        style={{ pointerEvents:"none" }} paintOrder="stroke" stroke="#f8f9fb" strokeWidth={2}>{d.dragonSize}</text>
                    )}
                  </g>
                );
              })}
 
              {/* Drag trail */}
              {dragging && dragPos && (() => {
                const src = dragging.type === "character"
                  ? characters.find(c => c.primary_key === dragging.id)
                  : dragging.type === "mage"
                  ? mages.find(m => m.primary_key === dragging.id)
                  : dragging.type === "dragon"
                  ? dragons.find(d => d.primary_key === dragging.id)
                  : armies.find(a => a.primary_key === dragging.id);
                if (!src?.coordinates) return null;
                const { x, y } = parseCoord(src.coordinates);
                return <line x1={x} y1={y} x2={dragPos[0]} y2={dragPos[1]}
                  stroke={src.color} strokeWidth={1} strokeDasharray="4 3" opacity={0.4} />;
              })()}
            </g>
          </svg>
 
          {/* Kingdom border edit overlay */}
          {editingKingdom && (
            <div style={{
              position:"absolute", top:12, left:"50%", transform:"translateX(-50%)",
              background:"#1e1b4b", borderRadius:10, padding:"10px 18px",
              display:"flex", alignItems:"center", gap:12, boxShadow:"0 4px 20px #0004", zIndex:25,
            }}>
              <span style={{ color:"#a5b4fc", fontSize:13 }}>✏ Drag vertices to move · Click edge to add point</span>
              <button onClick={confirmKingdomEdit}
                style={{ background:"#22c55e", color:"#fff", border:"none", borderRadius:6, padding:"5px 14px", cursor:"pointer", fontSize:13, fontWeight:600 }}>
                ✓ Confirm
              </button>
              <button onClick={cancelKingdomEdit}
                style={{ background:"#6b7280", color:"#fff", border:"none", borderRadius:6, padding:"5px 14px", cursor:"pointer", fontSize:13 }}>
                ✕ Cancel
              </button>
            </div>
          )}
 
          {/* Horizontal scrollbar */}
          {showHScroll && (
            <div style={{
              position:"absolute", bottom:0, left:0,
              width: showVScroll ? `calc(100% - ${SCROLL_W}px)` : "100%",
              height:SCROLL_W, background:"#e5e7eb", zIndex:15,
            }}>
              <div
                onMouseDown={e => handleScrollMouseDown(e, "h")}
                style={{
                  position:"absolute", top:2, height:SCROLL_W - 4, borderRadius:4,
                  left: hThumbX, width: hThumbW,
                  background:"#9ca3af", cursor:"pointer",
                  transition: scrollDrag.current ? "none" : "background 0.1s",
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#6b7280"}
                onMouseLeave={e => e.currentTarget.style.background = "#9ca3af"}
              />
            </div>
          )}
 
          {/* Vertical scrollbar */}
          {showVScroll && (
            <div style={{
              position:"absolute", top:0, right:0,
              height: showHScroll ? `calc(100% - ${SCROLL_W}px)` : "100%",
              width:SCROLL_W, background:"#e5e7eb", zIndex:15,
            }}>
              <div
                onMouseDown={e => handleScrollMouseDown(e, "v")}
                style={{
                  position:"absolute", left:2, width:SCROLL_W - 4, borderRadius:4,
                  top: vThumbY, height: vThumbH,
                  background:"#9ca3af", cursor:"pointer",
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#6b7280"}
                onMouseLeave={e => e.currentTarget.style.background = "#9ca3af"}
              />
            </div>
          )}
 
          {/* Corner fill when both scrollbars visible */}
          {showHScroll && showVScroll && (
            <div style={{ position:"absolute", bottom:0, right:0, width:SCROLL_W, height:SCROLL_W, background:"#e5e7eb", zIndex:16 }} />
          )}
 
          {/* Zoom indicator */}
          <div style={{ position:"absolute", bottom: showHScroll ? SCROLL_W + 8 : 12, right: panel ? 316 + (showVScroll ? SCROLL_W : 0) : showVScroll ? SCROLL_W + 8 : 12, background:"#ffffffcc", border:"1px solid #e5e7eb", borderRadius:6, padding:"3px 10px", fontSize:12, color:"#6b7280" }}>
            {Math.round(zoom * 100)}%
          </div>
 
          {/* Context menu */}
          {contextMenu && (() => {
            const ent = contextMenu.entity;
            // Find the actual entity object for quick-assign
            const entityObj = ent ? (
              ent.type === "character" ? characters.find(c => c.primary_key === ent.id) :
              ent.type === "mage" ? mages.find(m => m.primary_key === ent.id) :
              ent.type === "dragon" ? dragons.find(d => d.primary_key === ent.id) :
              ent.type === "army" ? armies.find(a => a.primary_key === ent.id) :
              ent.type === "city" ? cities.find(c => c.primary_key === ent.id) : null
            ) : null;
            const canAssign = ent && ["character","mage","dragon"].includes(ent.type);
            const canAssignArmy = ent && ent.type === "army";

            async function quickAssignToArmy(armyKey) {
              if (!entityObj) return;
              const updated = { ...entityObj, army: armyKey || null, city: null, coordinates: armyKey ? null : entityObj.coordinates };
              if (!armyKey) { const base = entityObj.coordinates ? parseCoord(entityObj.coordinates) : { x:400, y:400 }; updated.coordinates = coordStr(base.x, base.y); updated.army = null; }
              if (ent.type === "character") { setCharacters(cs => cs.map(c => c.primary_key === ent.id ? updated : c)); }
              else if (ent.type === "mage") { setMages(ms => ms.map(m => m.primary_key === ent.id ? updated : m)); }
              else if (ent.type === "dragon") { setDragons(ds => ds.map(d => d.primary_key === ent.id ? updated : d)); }
              setContextMenu(null); setPanel(null);
              try { await apiPut(updated); } catch(e) { console.error(e); }
            }

            async function quickAssignToCity(cityKey) {
              if (!entityObj) return;
              const updated = { ...entityObj, city: cityKey || null, army: null, coordinates: cityKey ? null : entityObj.coordinates };
              if (!cityKey) { updated.coordinates = coordStr(contextMenu.wx, contextMenu.wy); updated.city = null; }
              if (ent.type === "character") { setCharacters(cs => cs.map(c => c.primary_key === ent.id ? updated : c)); }
              else if (ent.type === "mage") { setMages(ms => ms.map(m => m.primary_key === ent.id ? updated : m)); }
              else if (ent.type === "dragon") { setDragons(ds => ds.map(d => d.primary_key === ent.id ? updated : d)); }
              else if (ent.type === "army") { setArmies(as => as.map(a => a.primary_key === ent.id ? updated : a)); }
              setContextMenu(null); setPanel(null);
              try { await apiPut(updated); } catch(e) { console.error(e); }
            }

            const menuItemStyle = { padding:"7px 14px", fontSize:12, color:"#374151", cursor:"pointer", display:"flex", alignItems:"center", gap:8 };
            const hoverIn = e => e.currentTarget.style.background="#f3f4f6";
            const hoverOut = e => e.currentTarget.style.background="transparent";

            return (
              <div style={{
                position:"absolute", left:contextMenu.screenX, top:contextMenu.screenY,
                background:"#fff", border:"1px solid #e5e7eb", borderRadius:8,
                boxShadow:"0 4px 16px #0002", zIndex:50, minWidth:180, maxHeight:400, overflow:"auto",
              }}>
                {ent ? (
                  <>
                    {/* Edit */}
                    <div onClick={() => { setPanel(ent); setContextMenu(null); }}
                      style={menuItemStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                      ✏️ Edit {ent.type.charAt(0).toUpperCase() + ent.type.slice(1)}
                    </div>

                    {/* Quick assign to army */}
                    {canAssign && (
                      <>
                        <div style={{ padding:"4px 14px", fontSize:9, color:"#9ca3af", fontWeight:600, letterSpacing:1, textTransform:"uppercase", borderTop:"1px solid #f3f4f6" }}>Assign to Army</div>
                        {entityObj?.army && (
                          <div onClick={() => quickAssignToArmy(null)} style={menuItemStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                            <span style={{ width:16, textAlign:"center", fontSize:10 }}>↗</span> Remove from Army
                          </div>
                        )}
                        {armies.filter(a => a.primary_key !== entityObj?.army).slice(0, 8).map(a => (
                          <div key={a.primary_key} onClick={() => quickAssignToArmy(a.primary_key)}
                            style={menuItemStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                            <span style={{ width:10, height:10, background:a.color, borderRadius:2, transform:"rotate(45deg)", flexShrink:0 }} />
                            <span style={{ fontSize:11 }}>{a.name}</span>
                            {a.size > 0 && <span style={{ fontSize:9, color:"#9ca3af", marginLeft:"auto" }}>{a.size.toLocaleString()}</span>}
                          </div>
                        ))}
                      </>
                    )}

                    {/* Quick assign to city */}
                    {(canAssign || canAssignArmy) && (
                      <>
                        <div style={{ padding:"4px 14px", fontSize:9, color:"#9ca3af", fontWeight:600, letterSpacing:1, textTransform:"uppercase", borderTop:"1px solid #f3f4f6" }}>Assign to City</div>
                        {entityObj?.city && (
                          <div onClick={() => quickAssignToCity(null)} style={menuItemStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                            <span style={{ width:16, textAlign:"center", fontSize:10 }}>↗</span> Remove from City
                          </div>
                        )}
                        {cities.filter(c => c.primary_key !== entityObj?.city).slice(0, 8).map(c => (
                          <div key={c.primary_key} onClick={() => quickAssignToCity(c.primary_key)}
                            style={menuItemStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                            <span style={{ width:8, height:8, borderRadius:"50%", background: STATUS_COLORS[c.status] || "#22c55e", flexShrink:0 }} />
                            <span style={{ fontSize:11 }}>{c.name}</span>
                          </div>
                        ))}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div style={{ padding:"5px 14px", fontSize:10, color:"#9ca3af", fontWeight:600, letterSpacing:1, textTransform:"uppercase" }}>Place at this location</div>
                    {[
                      { type:"city",      icon:"●",  label:"City" },
                      { type:"character", icon:"👤", label:"Character" },
                      { type:"army",      icon:"⚔",  label:"Army" },
                      { type:"mage",      icon:"✦",  label:"Mage" },
                      { type:"dragon",    icon:"🐉", label:"Dragon" },
                    ].map(item => (
                      <div key={item.type}
                        onClick={() => { setModal({ type:item.type, x:contextMenu.wx, y:contextMenu.wy }); setContextMenu(null); }}
                        style={menuItemStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
                        <span style={{ width:16, textAlign:"center" }}>{item.icon}</span> {item.label}
                      </div>
                    ))}
                  </>
                )}
              </div>
            );
          })()}
 
          {/* Detail panels */}
          {panelKingdom && <KingdomPanel key={panelKingdom.primary_key} kingdom={panelKingdom} characters={characters} armies={armies} cities={cities} mages={mages} dragons={dragons}
            onUpdate={updateKingdom} onClose={() => setPanel(null)} onDelete={() => deleteKingdom(panelKingdom.primary_key)} onEditBorders={startEditingKingdom} />}
          {panelCity && <CityPanel key={panelCity.primary_key} city={panelCity} characters={characters} armies={armies} mages={mages} dragons={dragons} kingdoms={kingdoms}
            onUpdate={updateCity} onClose={() => setPanel(null)} onDelete={() => deleteCity(panelCity.primary_key)} onMoveOut={handleMoveOut} />}
          {panelChar && <CharacterPanel key={panelChar.primary_key} character={panelChar} cities={cities} kingdoms={kingdoms} armies={armies}
            onUpdate={updateCharacter} onClose={() => setPanel(null)} onDelete={() => deleteCharacter(panelChar.primary_key)} />}
          {panelArmy && <ArmyPanel key={panelArmy.primary_key} army={panelArmy} characters={characters} cities={cities} kingdoms={kingdoms} mages={mages} dragons={dragons}
            onUpdate={updateArmy} onClose={() => setPanel(null)} onDelete={() => deleteArmy(panelArmy.primary_key)} onMoveOut={handleMoveOut} />}
          {panelMage && <MagePanel key={panelMage.primary_key} mage={panelMage} cities={cities} kingdoms={kingdoms} armies={armies} allMages={mages} allDragons={dragons}
            onUpdate={updateMage} onClose={() => setPanel(null)} onDelete={() => deleteMage(panelMage.primary_key)} />}
          {panelDragon && <DragonPanel key={panelDragon.primary_key} dragon={panelDragon} cities={cities} kingdoms={kingdoms} armies={armies} characters={characters} mages={mages} allDragons={dragons}
            onUpdate={updateDragon} onClose={() => setPanel(null)} onDelete={() => deleteDragon(panelDragon.primary_key)} />}
        </div>
      </div>
 
      {/* Name modal */}
      {modal && <NameModal type={modal.type} onConfirm={handleModalConfirm} onCancel={() => { setModal(null); setDrawingPoints([]); }} />}

      {/* Power Rankings modal */}
      {showPowerRankings && <PowerRankingsModal mages={mages} dragons={dragons} kingdoms={kingdoms} onClose={() => setShowPowerRankings(false)} />}

      {/* Fatigue Manager modal */}
      {showFatigueManager && <FatigueManagerModal mages={mages} dragons={dragons} kingdoms={kingdoms} onUpdateMage={updateMage} onUpdateDragon={updateDragon} onClose={() => setShowFatigueManager(false)} />}

      {/* Gear modal */}
      {showGearModal && <GearModal mages={mages} dragons={dragons} kingdoms={kingdoms} onClose={() => setShowGearModal(false)} />}

      {/* Battle Readiness modal */}
      {showReadiness && <ReadinessModal armies={armies} characters={characters} mages={mages} dragons={dragons} kingdoms={kingdoms} cities={cities} onClose={() => setShowReadiness(false)} />}
 
      {/* Battle modal */}
      {showBattle && <BattleModal
        armies={armies} characters={characters} mages={mages} dragons={dragons}
        onUpdateMage={updateMage} onUpdateDragon={updateDragon}
        onClose={() => setShowBattle(false)}
        onConfirmBattle={async (idA, survA, idB, survB, entsA, entsB) => {
          const updA = { ...armies.find(a => a.primary_key === idA), size: survA };
          const updB = { ...armies.find(a => a.primary_key === idB), size: survB };
          setArmies(as => as.map(a => a.primary_key === idA ? updA : a.primary_key === idB ? updB : a));
          setSaving(true);
          try {
            await apiPut(updA); await apiPut(updB);
            const allEnts = [...(entsA || []), ...(entsB || [])];
            for (const ent of allEnts) {
              if (ent.type !== "mage" && ent.type !== "dragon") continue;
              const fatigueIncrease = 0.03 + Math.random() * 0.03;
              const newFatigue = Math.min(1, (ent.fatigue || 0) + fatigueIncrease);
              const newArts = Array.isArray(ent.artifacts) ? ent.artifacts.map(a => {
                if (a?.equipped && (a?.energy || 0) > 0) return { ...a, energy: a.energy - 1 };
                return a;
              }) : [];
              const updated = { ...ent, fatigue: newFatigue, artifacts: newArts.length > 0 ? newArts : undefined };
              const { type: _, ...saveData } = updated;
              if (ent.type === "mage") { setMages(ms => ms.map(m => m.primary_key === ent.primary_key ? saveData : m)); }
              else { setDragons(ds => ds.map(d => d.primary_key === ent.primary_key ? saveData : d)); }
              await apiPut(saveData);
            }
          } catch(e) { console.error(e); } finally { setSaving(false); }
        }}
      />}
    </div>
  );
}
 
 
// ── Power Rankings ────────────────────────────────────────────────────────────
function calcEntityPower(e) {
  const basePower = calcDisciplinePowerForType(e.disciplines, e.type);
  const total = calcDisciplinePowerForType(e.disciplines, e.type, e.artifacts, e.fatigue || 0);
  const artifactBonus = total - basePower;
  return { basePower, artifactBonus, total, fatigue: e.fatigue || 0 };
}

function PowerRankingsModal({ mages, dragons, kingdoms, onClose }) {
  const [filterDisc, setFilterDisc] = useState("");
  const [filterAllegiance, setFilterAllegiance] = useState("");

  const allMages = [...mages]
    .map(m => ({ ...m, type: "mage", ...calcEntityPower({ ...m, type: "mage" }) }));
  const allDragons = [...dragons]
    .map(d => ({ ...d, type: "dragon", ...calcEntityPower({ ...d, type: "dragon" }) }));

  // Filter by discipline (peak discipline matches)
  const discFilter = (entity) => {
    if (!filterDisc) return true;
    const disc = entity.disciplines || {};
    return (disc[filterDisc] || 0) > 0;
  };

  // Filter by allegiance
  const allegianceFilter = (entity) => {
    if (!filterAllegiance) return true;
    if (filterAllegiance === "__none__") return !entity.allegiance;
    return entity.allegiance === filterAllegiance;
  };

  const rankedMages = allMages.filter(discFilter).filter(allegianceFilter).sort((a, b) => b.total - a.total);
  const rankedDragons = allDragons.filter(discFilter).filter(allegianceFilter).sort((a, b) => b.total - a.total);

  const maxMage   = rankedMages[0]?.total   || 1;
  const maxDragon = rankedDragons[0]?.total || 1;

  // Sort options for discipline: by highest level in that discipline
  const sortByDisc = filterDisc
    ? (a, b) => ((b.disciplines || {})[filterDisc] || 0) - ((a.disciplines || {})[filterDisc] || 0) || b.total - a.total
    : (a, b) => b.total - a.total;

  const sortedMages = rankedMages.sort(sortByDisc);
  const sortedDragons = rankedDragons.sort(sortByDisc);

  function RankRow({ entity, rank, max }) {
    const icon = entity.type === "mage" ? "✦" : "🐉";
    const filledArtifacts = Array.isArray(entity.artifacts) ? entity.artifacts.filter(a => a?.name) : [];
    const barW = Math.max(4, (entity.total / max) * 100);
    const disc = entity.disciplines || {};
    const totalDisc = calcDisciplineLevels(disc);
    const peak = peakDiscipline(disc);
    const peakInfo = peak.key ? MAGIC_DISCIPLINES.find(d => d.key === peak.key) : null;
    const fat = entity.fatigue || 0;
    const kingdom = kingdoms.find(k => k.primary_key === entity.allegiance);
    return (
      <div style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 0", borderBottom:"1px solid #f3f4f6" }}>
        <span style={{ fontSize:11, fontWeight:700, color:"#9ca3af", width:18, textAlign:"right", flexShrink:0 }}>#{rank}</span>
        <span style={{ fontSize:13 }}>{icon}</span>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:3, flexWrap:"wrap" }}>
            <span style={{ fontSize:13, fontWeight:600, color:"#111827", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{entity.name}</span>
            {kingdom && (
              <span style={{ fontSize:9, color: kingdom.color || "#6b7280", background: (kingdom.color || "#6b7280") + "18", padding:"1px 5px", borderRadius:3, flexShrink:0 }}>{kingdom.name}</span>
            )}
            {totalDisc > 0 && (
              <span style={{ fontSize:10, color:"#7c3aed", flexShrink:0 }}>🔮{totalDisc}</span>
            )}
            {peakInfo && (
              <span style={{ fontSize:9, color: peakInfo.color, flexShrink:0, background: peakInfo.color + "15", padding:"1px 4px", borderRadius:3 }}>{peakInfo.icon}{peak.level}</span>
            )}
            {filterDisc && (disc[filterDisc] || 0) > 0 && (
              <span style={{ fontSize:9, color: MAGIC_DISCIPLINES.find(d=>d.key===filterDisc)?.color || "#7c3aed", flexShrink:0 }}>
                {MAGIC_DISCIPLINES.find(d=>d.key===filterDisc)?.icon}{disc[filterDisc]}
              </span>
            )}
            {filledArtifacts.length > 0 && (
              <span style={{ fontSize:10, color:"#d97706", flexShrink:0 }}>🏺×{filledArtifacts.length}</span>
            )}
            {fat > 0.1 && (
              <span style={{ fontSize:9, color: fat > 0.6 ? "#ef4444" : "#f59e0b", flexShrink:0 }}>😓{Math.round(fat*100)}%</span>
            )}
          </div>
          {/* Discipline mini-bars */}
          {totalDisc > 0 && (
            <div style={{ display:"flex", gap:2, marginBottom:3 }}>
              {MAGIC_DISCIPLINES.map(d => {
                const lvl = disc[d.key] || 0;
                const isHighlighted = filterDisc === d.key;
                return (
                  <div key={d.key} title={`${d.label}: ${lvl}`} style={{
                    flex:1, height: isHighlighted ? 5 : 3, borderRadius:2, background:"#f3f4f6", overflow:"hidden",
                    border: isHighlighted ? `1px solid ${d.color}44` : "none",
                  }}>
                    <div style={{ height:"100%", width:`${(lvl/12)*100}%`, background: d.color, borderRadius:2 }} />
                  </div>
                );
              })}
            </div>
          )}
          <div style={{ height:6, background:"#f3f4f6", borderRadius:3, overflow:"hidden" }}>
            <div style={{
              height:"100%", borderRadius:3,
              width:`${barW}%`,
              background: entity.type === "dragon"
                ? "linear-gradient(90deg,#f97316,#ef4444)"
                : "linear-gradient(90deg,#8b5cf6,#6366f1)",
            }} />
          </div>
        </div>
        <div style={{ textAlign:"right", flexShrink:0 }}>
          <div style={{ fontSize:13, fontWeight:700, color: entity.type === "dragon" ? "#ea580c" : "#7c3aed" }}>
            +{(entity.total * 100).toFixed(0)}%
          </div>
          {entity.artifactBonus > 0 && (
            <div style={{ fontSize:10, color:"#d97706" }}>+{(entity.artifactBonus * 100).toFixed(0)}% artifacts</div>
          )}
        </div>
      </div>
    );
  }

  function Column({ title, icon, entities, max, emptyMsg }) {
    return (
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ fontSize:12, fontWeight:700, color:"#374151", marginBottom:10, display:"flex", alignItems:"center", gap:6 }}>
          <span>{icon}</span>{title}
          <span style={{ fontSize:11, fontWeight:400, color:"#9ca3af", marginLeft:"auto" }}>{entities.length} total</span>
        </div>
        {entities.length === 0
          ? <span style={{ fontSize:12, color:"#9ca3af" }}>{emptyMsg}</span>
          : entities.map((e, i) => <RankRow key={e.primary_key} entity={e} rank={i + 1} max={max} />)
        }
      </div>
    );
  }

  const activeDiscInfo = filterDisc ? MAGIC_DISCIPLINES.find(d => d.key === filterDisc) : null;
  const activeKingdom = filterAllegiance ? kingdoms.find(k => k.primary_key === filterAllegiance) : null;

  return (
    <div style={{
      position:"fixed", inset:0, background:"#00000066", zIndex:100,
      display:"flex", alignItems:"center", justifyContent:"center",
    }} onClick={onClose}>
      <div style={{
        background:"#fff", borderRadius:12, width:"min(900px, 95vw)", maxHeight:"85vh",
        boxShadow:"0 20px 60px #0004", display:"flex", flexDirection:"column", overflow:"hidden",
      }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"14px 20px", borderBottom:"1px solid #e5e7eb", flexShrink:0 }}>
          <span style={{ fontSize:15, fontWeight:700, color:"#111827" }}>✦ Power Rankings</span>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:16, color:"#9ca3af" }}>✕</button>
        </div>

        {/* Filters */}
        <div style={{ display:"flex", gap:12, padding:"10px 20px", borderBottom:"1px solid #f3f4f6", flexShrink:0, flexWrap:"wrap", alignItems:"center" }}>
          <span style={{ fontSize:11, fontWeight:600, color:"#9ca3af", letterSpacing:0.5, textTransform:"uppercase" }}>Filters</span>

          {/* Discipline filter — pill buttons */}
          <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
            <button onClick={() => setFilterDisc("")} style={{
              fontSize:10, fontWeight:600, padding:"3px 8px", borderRadius:10, cursor:"pointer",
              border: `1px solid ${!filterDisc ? "#374151" : "#e5e7eb"}`,
              background: !filterDisc ? "#374151" : "#f9fafb",
              color: !filterDisc ? "#fff" : "#6b7280",
            }}>All</button>
            {MAGIC_DISCIPLINES.map(d => (
              <button key={d.key} onClick={() => setFilterDisc(filterDisc === d.key ? "" : d.key)} style={{
                fontSize:10, fontWeight:600, padding:"3px 8px", borderRadius:10, cursor:"pointer",
                border: `1px solid ${filterDisc === d.key ? d.color : "#e5e7eb"}`,
                background: filterDisc === d.key ? d.color + "18" : "#f9fafb",
                color: filterDisc === d.key ? d.color : "#6b7280",
              }}>{d.icon} {d.label}</button>
            ))}
          </div>

          <div style={{ width:1, height:20, background:"#e5e7eb" }} />

          {/* Allegiance filter */}
          <select value={filterAllegiance} onChange={e => setFilterAllegiance(e.target.value)}
            style={{ fontSize:11, padding:"3px 8px", borderRadius:5, border:"1px solid #e5e7eb", background: filterAllegiance ? "#f0fdf4" : "#f9fafb", color:"#374151", cursor:"pointer" }}>
            <option value="">All Allegiances</option>
            {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
            <option value="__none__">Unaligned</option>
          </select>

          {(filterDisc || filterAllegiance) && (
            <button onClick={() => { setFilterDisc(""); setFilterAllegiance(""); }}
              style={{ fontSize:10, color:"#9ca3af", background:"none", border:"none", cursor:"pointer", textDecoration:"underline" }}>
              Clear all
            </button>
          )}
        </div>

        {/* Active filter summary */}
        {(filterDisc || filterAllegiance) && (
          <div style={{ padding:"6px 20px", background:"#f9fafb", borderBottom:"1px solid #f3f4f6", fontSize:11, color:"#6b7280", display:"flex", gap:8, alignItems:"center", flexShrink:0 }}>
            <span>Showing:</span>
            {activeDiscInfo && <span style={{ color: activeDiscInfo.color, fontWeight:600 }}>{activeDiscInfo.icon} {activeDiscInfo.label} practitioners</span>}
            {activeDiscInfo && activeKingdom && <span>in</span>}
            {activeKingdom && <span style={{ color: activeKingdom.color || "#374151", fontWeight:600 }}>▨ {activeKingdom.name}</span>}
            {filterAllegiance === "__none__" && <span style={{ fontWeight:600 }}>Unaligned</span>}
            <span style={{ color:"#9ca3af" }}>— {sortedMages.length} mages, {sortedDragons.length} dragons</span>
          </div>
        )}

        {/* Body */}
        <div style={{ display:"flex", gap:0, overflow:"auto", flex:1 }}>
          <div style={{ flex:1, padding:"16px 20px", borderRight:"1px solid #f3f4f6", overflow:"auto" }}>
            <Column title="Mages" icon="✦" entities={sortedMages} max={maxMage} emptyMsg={filterDisc || filterAllegiance ? "No mages match filters" : "No mages yet"} />
          </div>
          <div style={{ flex:1, padding:"16px 20px", overflow:"auto" }}>
            <Column title="Dragons" icon="🐉" entities={sortedDragons} max={maxDragon} emptyMsg={filterDisc || filterAllegiance ? "No dragons match filters" : "No dragons yet"} />
          </div>
        </div>
      </div>
    </div>
  );
}


// ── Battle Readiness Modal ────────────────────────────────────────────────────
function ReadinessModal({ armies, characters, mages, dragons, kingdoms, cities, onClose }) {
  const [search, setSearch] = useState("");
  const [filterKingdom, setFilterKingdom] = useState("");
  const [expandedArmy, setExpandedArmy] = useState(null);
  const [sortBy, setSortBy] = useState("power"); // power, troops, name, readiness

  const q = search.toLowerCase().trim();

  // Compute army data
  const armyData = armies.map(a => {
    const armyChars = characters.filter(c => c.army === a.primary_key);
    const armyMages = mages.filter(m => m.army === a.primary_key);
    const armyDragons = dragons.filter(d => d.army === a.primary_key);
    const kingdom = kingdoms.find(k => k.primary_key === a.allegiance);
    const location = a.city ? cities.find(c => c.primary_key === a.city)?.name || "In city" : a.coordinates ? "On map" : "Unknown";

    // Compute total entity power
    let entityPower = 0;
    for (const c of armyChars) { const sk = c.skill || 5; entityPower += 0.04 * (Math.pow(1.37, sk) - 1); }
    for (const m of armyMages) entityPower += calcDisciplinePowerForType(m.disciplines, "mage", m.artifacts, m.fatigue || 0);
    for (const d of armyDragons) entityPower += calcDisciplinePowerForType(d.disciplines, "dragon", d.artifacts, d.fatigue || 0);

    // Readiness: average inverse fatigue of magical entities, weighted by whether artifacts are equipped
    const magicEnts = [...armyMages, ...armyDragons];
    let readiness = 1;
    if (magicEnts.length > 0) {
      const avgFatigue = magicEnts.reduce((s, e) => s + (e.fatigue || 0), 0) / magicEnts.length;
      const totalArtSlots = magicEnts.reduce((s, e) => s + (Array.isArray(e.artifacts) ? e.artifacts : []).filter(aa => aa?.name).length, 0);
      const equippedArts = magicEnts.reduce((s, e) => s + (Array.isArray(e.artifacts) ? e.artifacts : []).filter(aa => aa?.equipped && (aa?.energy || 0) > 0).length, 0);
      const artRatio = totalArtSlots > 0 ? equippedArts / totalArtSlots : 1;
      readiness = ((1 - avgFatigue) * 0.6 + artRatio * 0.4);
    }

    const totalPower = Math.pow(a.size || 0, 0.7) * (1 + (a.bonus || 0) + entityPower);

    return {
      ...a, kingdom, location, armyChars, armyMages, armyDragons,
      entityPower, totalPower, readiness,
      magicCount: armyMages.length + armyDragons.length,
      entityCount: armyChars.length + armyMages.length + armyDragons.length,
    };
  }).filter(a => {
    if (q && !a.name.toLowerCase().includes(q)) return false;
    if (filterKingdom === "__none__" && a.allegiance) return false;
    if (filterKingdom && filterKingdom !== "__none__" && a.allegiance !== filterKingdom) return false;
    return true;
  }).sort((a, b) => {
    if (sortBy === "power") return b.totalPower - a.totalPower;
    if (sortBy === "troops") return (b.size || 0) - (a.size || 0);
    if (sortBy === "readiness") return b.readiness - a.readiness;
    return a.name.localeCompare(b.name);
  });

  const totalTroops = armyData.reduce((s, a) => s + (a.size || 0), 0);
  const totalMagic = armyData.reduce((s, a) => s + a.magicCount, 0);

  function readinessColor(r) { return r >= 0.8 ? "#22c55e" : r >= 0.5 ? "#f59e0b" : "#ef4444"; }
  function readinessLabel(r) { return r >= 0.8 ? "Ready" : r >= 0.5 ? "Tired" : "Exhausted"; }

  function EntityMini({ entity, type }) {
    const fat = entity.fatigue || 0;
    const arts = (Array.isArray(entity.artifacts) ? entity.artifacts : []).filter(a => a?.name);
    const equipped = arts.filter(a => a?.equipped && (a?.energy || 0) > 0).length;
    const totalEnergy = arts.reduce((s, a) => s + (a?.energy || 0), 0);
    const maxEnergy = arts.length * 3;
    const peak = peakDiscipline(entity.disciplines);
    const peakInfo = peak.key ? MAGIC_DISCIPLINES.find(d => d.key === peak.key) : null;
    const power = type === "character"
      ? 0.04 * (Math.pow(1.37, entity.skill || 5) - 1)
      : calcDisciplinePowerForType(entity.disciplines, type, entity.artifacts, fat);

    return (
      <div style={{
        display:"flex", alignItems:"center", gap:6, padding:"6px 8px", borderRadius:5,
        background: fat > 0.6 ? "#fef2f2" : fat > 0.3 ? "#fffbeb" : "#f0fdf4",
        border: `1px solid ${fat > 0.6 ? "#fecaca" : fat > 0.3 ? "#fde68a" : "#bbf7d0"}`,
        marginBottom:3,
      }}>
        <span style={{ fontSize:12 }}>{type === "mage" ? "✦" : type === "dragon" ? "🐉" : "👤"}</span>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ display:"flex", alignItems:"center", gap:4, flexWrap:"wrap" }}>
            <span style={{ fontSize:11, fontWeight:600, color:"#111827" }}>{entity.name}</span>
            {peakInfo && <span style={{ fontSize:8, color: peakInfo.color, background: peakInfo.color + "15", padding:"0px 4px", borderRadius:3 }}>{peakInfo.icon}{peak.level}</span>}
          </div>
        </div>
        {/* Fatigue bar */}
        {type !== "character" && (
          <div style={{ width:40, display:"flex", flexDirection:"column", alignItems:"center", gap:1 }}>
            <div style={{ width:"100%", height:4, borderRadius:2, background:"#e5e7eb", overflow:"hidden" }}>
              <div style={{ height:"100%", width:`${(1-fat)*100}%`, borderRadius:2, background: fat <= 0.3 ? "#22c55e" : fat <= 0.6 ? "#f59e0b" : "#ef4444" }} />
            </div>
            <span style={{ fontSize:7, color:"#9ca3af" }}>{Math.round((1-fat)*100)}%</span>
          </div>
        )}
        {/* Artifacts */}
        {arts.length > 0 && (
          <div style={{ display:"flex", alignItems:"center", gap:3 }}>
            <span style={{ fontSize:9, color: equipped > 0 ? "#d97706" : "#d1d5db" }}>🏺{equipped}/{arts.length}</span>
            {maxEnergy > 0 && (
              <div style={{ display:"flex", gap:1 }}>
                {[...Array(Math.min(arts.length * 3, 9))].map((_, i) => (
                  <div key={i} style={{ width:3, height:6, borderRadius:1, background: i < totalEnergy ? "#22c55e" : "#e5e7eb" }} />
                ))}
              </div>
            )}
          </div>
        )}
        <span style={{ fontSize:9, color:"#6b7280", fontWeight:600, minWidth:40, textAlign:"right" }}>+{(power * 100).toFixed(0)}%</span>
      </div>
    );
  }

  function ArmyRow({ army }) {
    const isExpanded = expandedArmy === army.primary_key;
    const rColor = readinessColor(army.readiness);

    return (
      <div style={{ borderBottom:"1px solid #e5e7eb" }}>
        {/* Main row */}
        <div onClick={() => setExpandedArmy(isExpanded ? null : army.primary_key)}
          style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 16px", cursor:"pointer", background: isExpanded ? "#f8fafc" : "#fff" }}>
          {/* Color + name */}
          <div style={{ display:"flex", alignItems:"center", gap:8, flex:1, minWidth:0 }}>
            <div style={{ width:12, height:12, borderRadius:2, background: army.color, transform:"rotate(45deg)", flexShrink:0 }} />
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:"#111827" }}>{army.name}</div>
              <div style={{ display:"flex", gap:4, alignItems:"center", marginTop:2 }}>
                {army.kingdom && <span style={{ fontSize:9, color: army.kingdom.color || "#6b7280", background: (army.kingdom.color || "#6b7280") + "18", padding:"1px 4px", borderRadius:3 }}>{army.kingdom.name}</span>}
                <span style={{ fontSize:9, color:"#9ca3af" }}>{army.location}</span>
              </div>
            </div>
          </div>

          {/* Troops */}
          <div style={{ textAlign:"center", minWidth:70 }}>
            <div style={{ fontSize:14, fontWeight:700, color:"#111827" }}>{(army.size || 0).toLocaleString()}</div>
            <div style={{ fontSize:8, color:"#9ca3af", textTransform:"uppercase", letterSpacing:0.5 }}>Troops</div>
          </div>

          {/* Entities */}
          <div style={{ textAlign:"center", minWidth:50 }}>
            <div style={{ display:"flex", justifyContent:"center", gap:3, alignItems:"center" }}>
              {army.armyMages.length > 0 && <span style={{ fontSize:10, color:"#7c3aed" }}>✦{army.armyMages.length}</span>}
              {army.armyDragons.length > 0 && <span style={{ fontSize:10, color:"#ea580c" }}>🐉{army.armyDragons.length}</span>}
              {army.armyChars.length > 0 && <span style={{ fontSize:10, color:"#6b7280" }}>👤{army.armyChars.length}</span>}
              {army.entityCount === 0 && <span style={{ fontSize:10, color:"#d1d5db" }}>—</span>}
            </div>
            <div style={{ fontSize:8, color:"#9ca3af", textTransform:"uppercase", letterSpacing:0.5 }}>Entities</div>
          </div>

          {/* Entity power */}
          <div style={{ textAlign:"center", minWidth:60 }}>
            <div style={{ fontSize:12, fontWeight:700, color: army.entityPower > 0 ? "#7c3aed" : "#d1d5db" }}>+{(army.entityPower * 100).toFixed(0)}%</div>
            <div style={{ fontSize:8, color:"#9ca3af", textTransform:"uppercase", letterSpacing:0.5 }}>Magic</div>
          </div>

          {/* Total power */}
          <div style={{ textAlign:"center", minWidth:70 }}>
            <div style={{ fontSize:12, fontWeight:700, color:"#111827" }}>{army.totalPower.toFixed(0)}</div>
            <div style={{ fontSize:8, color:"#9ca3af", textTransform:"uppercase", letterSpacing:0.5 }}>Power</div>
          </div>

          {/* Readiness */}
          <div style={{ textAlign:"center", minWidth:65 }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:4 }}>
              <div style={{ width:32, height:6, borderRadius:3, background:"#e5e7eb", overflow:"hidden" }}>
                <div style={{ height:"100%", width:`${army.readiness*100}%`, borderRadius:3, background: rColor }} />
              </div>
              <span style={{ fontSize:10, fontWeight:700, color: rColor }}>{Math.round(army.readiness*100)}%</span>
            </div>
            <div style={{ fontSize:8, color: rColor, fontWeight:600 }}>{readinessLabel(army.readiness)}</div>
          </div>

          <span style={{ fontSize:10, color:"#9ca3af" }}>{isExpanded ? "▲" : "▼"}</span>
        </div>

        {/* Expanded detail */}
        {isExpanded && (
          <div style={{ padding:"8px 16px 12px 40px", background:"#f8fafc", borderTop:"1px solid #f3f4f6" }}>
            {army.entityCount === 0 ? (
              <div style={{ fontSize:11, color:"#9ca3af", padding:8 }}>No entities attached to this army</div>
            ) : (
              <>
                {army.armyMages.length > 0 && (
                  <div style={{ marginBottom:6 }}>
                    <div style={{ fontSize:9, fontWeight:700, color:"#7c3aed", letterSpacing:0.5, textTransform:"uppercase", marginBottom:4 }}>Mages ({army.armyMages.length})</div>
                    {army.armyMages.map(m => <EntityMini key={m.primary_key} entity={m} type="mage" />)}
                  </div>
                )}
                {army.armyDragons.length > 0 && (
                  <div style={{ marginBottom:6 }}>
                    <div style={{ fontSize:9, fontWeight:700, color:"#ea580c", letterSpacing:0.5, textTransform:"uppercase", marginBottom:4 }}>Dragons ({army.armyDragons.length})</div>
                    {army.armyDragons.map(d => <EntityMini key={d.primary_key} entity={d} type="dragon" />)}
                  </div>
                )}
                {army.armyChars.length > 0 && (
                  <div>
                    <div style={{ fontSize:9, fontWeight:700, color:"#6b7280", letterSpacing:0.5, textTransform:"uppercase", marginBottom:4 }}>Characters ({army.armyChars.length})</div>
                    {army.armyChars.map(c => <EntityMini key={c.primary_key} entity={c} type="character" />)}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{
      position:"fixed", inset:0, background:"#00000066", zIndex:100,
      display:"flex", alignItems:"center", justifyContent:"center",
    }} onClick={onClose}>
      <div style={{
        background:"#fff", borderRadius:12, width:"min(950px, 96vw)", maxHeight:"88vh",
        boxShadow:"0 20px 60px #0004", display:"flex", flexDirection:"column", overflow:"hidden",
      }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"14px 20px", borderBottom:"1px solid #e5e7eb", flexShrink:0 }}>
          <span style={{ fontSize:15, fontWeight:700, color:"#111827" }}>🛡 Battle Readiness</span>
          <div style={{ display:"flex", gap:12, alignItems:"center" }}>
            <span style={{ fontSize:11, color:"#6b7280" }}>{armyData.length} armies</span>
            <span style={{ fontSize:11, color:"#374151", fontWeight:600 }}>{totalTroops.toLocaleString()} troops</span>
            <span style={{ fontSize:11, color:"#7c3aed" }}>{totalMagic} magical entities</span>
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:16, color:"#9ca3af" }}>✕</button>
        </div>

        {/* Filters */}
        <div style={{ display:"flex", gap:8, padding:"10px 20px", borderBottom:"1px solid #f3f4f6", flexShrink:0, alignItems:"center", flexWrap:"wrap" }}>
          <div style={{ position:"relative", flex:1, minWidth:140 }}>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search armies..."
              style={{ ...inputStyle, fontSize:11, paddingLeft:24, width:"100%" }} />
            <span style={{ position:"absolute", left:7, top:"50%", transform:"translateY(-50%)", fontSize:11, color:"#9ca3af", pointerEvents:"none" }}>🔍</span>
            {search && <button onClick={() => setSearch("")} style={{ position:"absolute", right:4, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:10, color:"#9ca3af" }}>✕</button>}
          </div>
          <select value={filterKingdom} onChange={e => setFilterKingdom(e.target.value)}
            style={{ fontSize:10, padding:"4px 8px", borderRadius:5, border:"1px solid #e5e7eb", background:"#f9fafb", cursor:"pointer" }}>
            <option value="">All Kingdoms</option>
            {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
            <option value="__none__">Unaligned</option>
          </select>
          <div style={{ display:"flex", gap:2 }}>
            {[
              { key:"power", label:"Power" },
              { key:"troops", label:"Troops" },
              { key:"readiness", label:"Readiness" },
              { key:"name", label:"Name" },
            ].map(s => (
              <button key={s.key} onClick={() => setSortBy(s.key)} style={{
                fontSize:9, fontWeight:600, padding:"3px 8px", borderRadius:4, cursor:"pointer",
                border: `1px solid ${sortBy === s.key ? "#374151" : "#e5e7eb"}`,
                background: sortBy === s.key ? "#374151" : "#f9fafb",
                color: sortBy === s.key ? "#fff" : "#6b7280",
              }}>{s.label}</button>
            ))}
          </div>
        </div>

        {/* Column headers */}
        <div style={{ display:"flex", alignItems:"center", gap:10, padding:"6px 16px", background:"#f9fafb", borderBottom:"1px solid #e5e7eb", flexShrink:0 }}>
          <span style={{ flex:1, fontSize:9, color:"#9ca3af", fontWeight:600 }}>ARMY</span>
          <span style={{ fontSize:9, color:"#9ca3af", fontWeight:600, minWidth:70, textAlign:"center" }}>TROOPS</span>
          <span style={{ fontSize:9, color:"#9ca3af", fontWeight:600, minWidth:50, textAlign:"center" }}>ENTITIES</span>
          <span style={{ fontSize:9, color:"#9ca3af", fontWeight:600, minWidth:60, textAlign:"center" }}>MAGIC</span>
          <span style={{ fontSize:9, color:"#9ca3af", fontWeight:600, minWidth:70, textAlign:"center" }}>POWER</span>
          <span style={{ fontSize:9, color:"#9ca3af", fontWeight:600, minWidth:65, textAlign:"center" }}>READINESS</span>
          <span style={{ width:14 }}></span>
        </div>

        {/* Army list */}
        <div style={{ overflow:"auto", flex:1 }}>
          {armyData.length === 0 ? (
            <div style={{ padding:32, textAlign:"center", color:"#9ca3af", fontSize:13 }}>
              {search || filterKingdom ? "No armies match your filters" : "No armies yet"}
            </div>
          ) : (
            armyData.map(a => <ArmyRow key={a.primary_key} army={a} />)
          )}
        </div>
      </div>
    </div>
  );
}

// ── Gear Modal ────────────────────────────────────────────────────────────────
function GearModal({ mages, dragons, kingdoms, onClose }) {
  const [search, setSearch] = useState("");
  const [filterSlot, setFilterSlot] = useState("");
  const [filterDisc, setFilterDisc] = useState("");
  const [filterPossessor, setFilterPossessor] = useState(""); // "unowned", entity primary_key, or ""
  const [filterKingdom, setFilterKingdom] = useState("");
  const [filterTag, setFilterTag] = useState("");
  const [tagInput, setTagInput] = useState("");
  const [editingTagId, setEditingTagId] = useState(null);

  // Build possessor lookup: artifact id -> entity
  const allEntities = [
    ...mages.map(m => ({ ...m, _type: "mage" })),
    ...dragons.map(d => ({ ...d, _type: "dragon" })),
  ];
  const possessorMap = {};
  for (const ent of allEntities) {
    const arts = Array.isArray(ent.artifacts) ? ent.artifacts : [];
    for (const a of arts) {
      if (a?.id) possessorMap[a.id] = ent;
    }
  }

  // Collect all tags used across the catalog for the filter dropdown
  const allTags = [...new Set(ARTIFACT_CATALOG.flatMap(a => a.tags || []))].sort();

  const q = search.toLowerCase().trim();

  const filtered = ARTIFACT_CATALOG.filter(a => {
    if (q && !a.name.toLowerCase().includes(q) && !a.desc.toLowerCase().includes(q)) return false;
    if (filterSlot && a.slot !== filterSlot) return false;
    if (filterDisc && a.discipline !== filterDisc) return false;
    if (filterTag && !(a.tags || []).includes(filterTag)) return false;
    const owner = possessorMap[a.id];
    if (filterPossessor === "__unowned__" && owner) return false;
    if (filterPossessor === "__owned__" && !owner) return false;
    if (filterPossessor && filterPossessor !== "__unowned__" && filterPossessor !== "__owned__" && owner?.primary_key !== filterPossessor) return false;
    if (filterKingdom === "__none__" && owner?.allegiance) return false;
    if (filterKingdom && filterKingdom !== "__none__" && owner?.allegiance !== filterKingdom) return false;
    return true;
  }).sort((a, b) => b.bonus - a.bonus);

  function addTag(artifactId, tag) {
    const trimmed = tag.trim().toLowerCase();
    if (!trimmed) return;
    const cat = ARTIFACT_CATALOG.find(a => a.id === artifactId);
    if (!cat) return;
    if (!cat.tags) cat.tags = [];
    if (!cat.tags.includes(trimmed)) cat.tags.push(trimmed);
    setTagInput("");
    setEditingTagId(null);
  }

  function removeTag(artifactId, tag) {
    const cat = ARTIFACT_CATALOG.find(a => a.id === artifactId);
    if (!cat || !cat.tags) return;
    cat.tags = cat.tags.filter(t => t !== tag);
  }

  const slotIcons = { crown:"👑", weapon:"⚔", dagger:"🗡", ring:"💍", amulet:"📿", staff:"🪄", chain:"⛓" };

  function GearRow({ artifact }) {
    const owner = possessorMap[artifact.id];
    const ownerKingdom = owner ? kingdoms.find(k => k.primary_key === owner.allegiance) : null;
    const discInfo = artifact.discipline !== "all" ? MAGIC_DISCIPLINES.find(d => d.key === artifact.discipline) : null;
    const tags = artifact.tags || [];
    const isEditing = editingTagId === artifact.id;

    // Get equipped/energy state from owner's artifact data
    const ownerArt = owner ? (Array.isArray(owner.artifacts) ? owner.artifacts : []).find(a => a?.id === artifact.id) : null;
    const energy = ownerArt?.energy ?? 3;
    const isEquipped = ownerArt?.equipped && energy > 0;

    return (
      <div style={{ padding:"8px 12px", borderBottom:"1px solid #f3f4f6", display:"flex", gap:8, alignItems:"flex-start" }}>
        {/* Icon + name */}
        <div style={{ minWidth:0, flex:1 }}>
          <div style={{ display:"flex", alignItems:"center", gap:6, flexWrap:"wrap", marginBottom:3 }}>
            <span style={{ fontSize:12 }}>{slotIcons[artifact.slot] || "🏺"}</span>
            <span style={{ fontSize:13, fontWeight:600, color:"#111827" }}>{artifact.name}</span>
            <span style={{ fontSize:10, color: discInfo ? discInfo.color : "#d97706", fontWeight:600 }}>
              {discInfo ? `${discInfo.icon} ${discInfo.label}` : "⊕ All"} +{(artifact.bonus * 100).toFixed(0)}%
            </span>
            <span style={{ fontSize:9, color:"#9ca3af", background:"#f3f4f6", padding:"1px 5px", borderRadius:3 }}>{artifact.slot}</span>
          </div>
          <div style={{ fontSize:10, color:"#9ca3af", lineHeight:1.4, fontStyle:"italic", marginBottom:4 }}>{artifact.desc}</div>
          {/* Tags */}
          <div style={{ display:"flex", gap:3, flexWrap:"wrap", alignItems:"center" }}>
            {tags.map(t => (
              <span key={t} style={{ fontSize:9, background:"#e0e7ff", color:"#4338ca", padding:"1px 6px", borderRadius:8, display:"flex", alignItems:"center", gap:3 }}>
                {t}
                <span onClick={() => removeTag(artifact.id, t)} style={{ cursor:"pointer", fontSize:8, color:"#6366f1", fontWeight:700 }}>✕</span>
              </span>
            ))}
            {isEditing ? (
              <div style={{ display:"flex", gap:2, alignItems:"center" }}>
                <input
                  autoFocus
                  value={tagInput}
                  onChange={e => setTagInput(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === "Enter") addTag(artifact.id, tagInput);
                    if (e.key === "Escape") { setEditingTagId(null); setTagInput(""); }
                  }}
                  placeholder="tag name..."
                  style={{ fontSize:9, padding:"1px 4px", border:"1px solid #c7d2fe", borderRadius:4, width:70, outline:"none" }}
                />
                <button onClick={() => addTag(artifact.id, tagInput)}
                  style={{ fontSize:8, padding:"1px 4px", borderRadius:3, border:"1px solid #c7d2fe", background:"#e0e7ff", color:"#4338ca", cursor:"pointer" }}>+</button>
                <button onClick={() => { setEditingTagId(null); setTagInput(""); }}
                  style={{ fontSize:8, padding:"1px 4px", borderRadius:3, border:"1px solid #d1d5db", background:"#f9fafb", color:"#9ca3af", cursor:"pointer" }}>✕</button>
              </div>
            ) : (
              <span onClick={() => { setEditingTagId(artifact.id); setTagInput(""); }}
                style={{ fontSize:9, color:"#9ca3af", cursor:"pointer", padding:"1px 4px", border:"1px dashed #d1d5db", borderRadius:4 }}>+ tag</span>
            )}
          </div>
        </div>

        {/* Owner info */}
        <div style={{ minWidth:120, textAlign:"right", flexShrink:0 }}>
          {owner ? (
            <div>
              <div style={{ fontSize:11, fontWeight:600, color:"#374151" }}>
                {owner._type === "mage" ? "✦" : "🐉"} {owner.name}
              </div>
              {ownerKingdom && (
                <div style={{ fontSize:9, color: ownerKingdom.color || "#6b7280" }}>{ownerKingdom.name}</div>
              )}
              <div style={{ display:"flex", gap:3, justifyContent:"flex-end", marginTop:3, alignItems:"center" }}>
                {/* Energy pips */}
                {[1,2,3].map(i => (
                  <div key={i} style={{
                    width:10, height:6, borderRadius:1,
                    background: i <= energy ? (energy === 1 ? "#ef4444" : energy === 2 ? "#f59e0b" : "#22c55e") : "#e5e7eb",
                  }} />
                ))}
                <span style={{ fontSize:8, fontWeight:600, color: isEquipped ? "#16a34a" : "#9ca3af", marginLeft:2 }}>
                  {isEquipped ? "ON" : energy > 0 ? "OFF" : "—"}
                </span>
              </div>
            </div>
          ) : (
            <span style={{ fontSize:10, color:"#d1d5db" }}>Unowned</span>
          )}
        </div>
      </div>
    );
  }

  // Entities that own artifacts for possessor filter
  const ownersWithArts = allEntities.filter(e => (Array.isArray(e.artifacts) ? e.artifacts : []).some(a => a?.id));

  return (
    <div style={{
      position:"fixed", inset:0, background:"#00000066", zIndex:100,
      display:"flex", alignItems:"center", justifyContent:"center",
    }} onClick={onClose}>
      <div style={{
        background:"#fff", borderRadius:12, width:"min(900px, 95vw)", maxHeight:"85vh",
        boxShadow:"0 20px 60px #0004", display:"flex", flexDirection:"column", overflow:"hidden",
      }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"14px 20px", borderBottom:"1px solid #e5e7eb", flexShrink:0 }}>
          <span style={{ fontSize:15, fontWeight:700, color:"#111827" }}>🏺 Gear Catalog</span>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <span style={{ fontSize:11, color:"#9ca3af" }}>{filtered.length}/{ARTIFACT_CATALOG.length} shown</span>
            {allTags.length > 0 && <span style={{ fontSize:11, color:"#6366f1" }}>{allTags.length} tags</span>}
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:16, color:"#9ca3af" }}>✕</button>
        </div>

        {/* Filters */}
        <div style={{ display:"flex", gap:6, padding:"10px 20px", borderBottom:"1px solid #f3f4f6", flexShrink:0, flexWrap:"wrap", alignItems:"center" }}>
          {/* Search */}
          <div style={{ position:"relative", flex:1, minWidth:140 }}>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search name or description..."
              style={{ ...inputStyle, fontSize:11, paddingLeft:24, width:"100%" }} />
            <span style={{ position:"absolute", left:7, top:"50%", transform:"translateY(-50%)", fontSize:11, color:"#9ca3af", pointerEvents:"none" }}>🔍</span>
            {search && <button onClick={() => setSearch("")} style={{ position:"absolute", right:4, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:10, color:"#9ca3af" }}>✕</button>}
          </div>

          {/* Slot */}
          <select value={filterSlot} onChange={e => setFilterSlot(e.target.value)}
            style={{ fontSize:10, padding:"4px 6px", borderRadius:4, border:"1px solid #e5e7eb", background:"#f9fafb", cursor:"pointer" }}>
            <option value="">All Slots</option>
            {ARTIFACT_SLOTS.map(s => <option key={s.key} value={s.key}>{slotIcons[s.key] || "🏺"} {s.label}</option>)}
          </select>

          {/* Discipline */}
          <select value={filterDisc} onChange={e => setFilterDisc(e.target.value)}
            style={{ fontSize:10, padding:"4px 6px", borderRadius:4, border:"1px solid #e5e7eb", background:"#f9fafb", cursor:"pointer" }}>
            <option value="">All Disciplines</option>
            {MAGIC_DISCIPLINES.map(d => <option key={d.key} value={d.key}>{d.icon} {d.label}</option>)}
            <option value="all">⊕ All (universal)</option>
          </select>

          {/* Tag */}
          <select value={filterTag} onChange={e => setFilterTag(e.target.value)}
            style={{ fontSize:10, padding:"4px 6px", borderRadius:4, border:`1px solid ${filterTag ? "#c7d2fe" : "#e5e7eb"}`, background: filterTag ? "#e0e7ff" : "#f9fafb", color: filterTag ? "#4338ca" : "#374151", cursor:"pointer" }}>
            <option value="">All Tags</option>
            {allTags.map(t => <option key={t} value={t}>🏷 {t}</option>)}
          </select>

          {/* Possessor */}
          <select value={filterPossessor} onChange={e => setFilterPossessor(e.target.value)}
            style={{ fontSize:10, padding:"4px 6px", borderRadius:4, border:"1px solid #e5e7eb", background:"#f9fafb", cursor:"pointer" }}>
            <option value="">All Possessors</option>
            <option value="__owned__">Owned</option>
            <option value="__unowned__">Unowned</option>
            {ownersWithArts.map(e => <option key={e.primary_key} value={e.primary_key}>{e._type === "mage" ? "✦" : "🐉"} {e.name}</option>)}
          </select>

          {/* Kingdom */}
          <select value={filterKingdom} onChange={e => setFilterKingdom(e.target.value)}
            style={{ fontSize:10, padding:"4px 6px", borderRadius:4, border:"1px solid #e5e7eb", background:"#f9fafb", cursor:"pointer" }}>
            <option value="">All Kingdoms</option>
            {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
            <option value="__none__">Unaligned owners</option>
          </select>

          {(search || filterSlot || filterDisc || filterTag || filterPossessor || filterKingdom) && (
            <button onClick={() => { setSearch(""); setFilterSlot(""); setFilterDisc(""); setFilterTag(""); setFilterPossessor(""); setFilterKingdom(""); }}
              style={{ fontSize:9, color:"#9ca3af", background:"none", border:"none", cursor:"pointer", textDecoration:"underline" }}>Clear all</button>
          )}
        </div>

        {/* List */}
        <div style={{ overflow:"auto", flex:1 }}>
          {filtered.length === 0 ? (
            <div style={{ padding:32, textAlign:"center", color:"#9ca3af", fontSize:13 }}>No artifacts match your filters</div>
          ) : (
            filtered.map(a => <GearRow key={a.id} artifact={a} />)
          )}
        </div>
      </div>
    </div>
  );
}

// ── Fatigue Manager Modal ─────────────────────────────────────────────────────
function FatigueManagerModal({ mages, dragons, kingdoms, onUpdateMage, onUpdateDragon, onClose }) {
  const [search, setSearch] = useState("");
  const [filterAllegiance, setFilterAllegiance] = useState("");
  const [expandedId, setExpandedId] = useState(null);

  const q = search.toLowerCase().trim();

  const allEntities = [
    ...mages.map(m => ({ ...m, _type: "mage" })),
    ...dragons.map(d => ({ ...d, _type: "dragon" })),
  ].filter(e => {
    if (q && !e.name?.toLowerCase().includes(q)) return false;
    if (filterAllegiance === "__none__" && e.allegiance) return false;
    if (filterAllegiance && filterAllegiance !== "__none__" && e.allegiance !== filterAllegiance) return false;
    return true;
  }).sort((a, b) => (b.fatigue || 0) - (a.fatigue || 0));

  async function saveEntity(entity, changes) {
    const updated = { ...entity, ...changes };
    delete updated._type;
    if (entity._type === "mage") await onUpdateMage(updated);
    else await onUpdateDragon(updated);
  }

  async function resetAllFatigue() {
    for (const e of allEntities) {
      if ((e.fatigue || 0) > 0) await saveEntity(e, { fatigue: 0 });
    }
  }

  async function rechargeAllArtifacts() {
    for (const e of allEntities) {
      const arts = Array.isArray(e.artifacts) ? e.artifacts : [];
      const needsRecharge = arts.some(a => a?.name && (a?.energy || 0) < 3);
      if (needsRecharge) {
        const recharged = arts.map(a => a?.name ? { ...a, energy: 3 } : a);
        await saveEntity(e, { artifacts: recharged });
      }
    }
  }

  async function setArtifactEnergy(entity, slotKey, newEnergy) {
    const arts = (Array.isArray(entity.artifacts) ? entity.artifacts : []).map(a => {
      if (a?.slot === slotKey) return { ...a, energy: Math.max(0, Math.min(3, newEnergy)) };
      return a;
    });
    await saveEntity(entity, { artifacts: arts });
  }

  async function toggleArtifactEquip(entity, slotKey) {
    const arts = (Array.isArray(entity.artifacts) ? entity.artifacts : []).map(a => {
      if (a?.slot === slotKey) return { ...a, equipped: !a.equipped };
      return a;
    });
    await saveEntity(entity, { artifacts: arts });
  }

  async function rechargeEntityArtifacts(entity) {
    const arts = (Array.isArray(entity.artifacts) ? entity.artifacts : []).map(a => {
      if (a?.name) return { ...a, energy: 3 };
      return a;
    });
    await saveEntity(entity, { artifacts: arts });
  }

  function FatigueRow({ entity }) {
    const fat = entity.fatigue || 0;
    const fatColor = fat <= 0.3 ? "#22c55e" : fat <= 0.6 ? "#f59e0b" : "#ef4444";
    const icon = entity._type === "mage" ? "✦" : "🐉";
    const kingdom = kingdoms.find(k => k.primary_key === entity.allegiance);
    const peak = peakDiscipline(entity.disciplines);
    const peakInfo = peak.key ? MAGIC_DISCIPLINES.find(d => d.key === peak.key) : null;
    const power = calcDisciplinePowerForType(entity.disciplines, entity._type, entity.artifacts, fat);
    const filledArts = (Array.isArray(entity.artifacts) ? entity.artifacts : []).filter(a => a?.name);
    const totalEnergy = filledArts.reduce((s, a) => s + (a?.energy || 0), 0);
    const maxEnergy = filledArts.length * 3;
    const isExpanded = expandedId === entity.primary_key;

    return (
      <div style={{ borderBottom:"1px solid #f3f4f6" }}>
        {/* Main row */}
        <div style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 10px", cursor: filledArts.length > 0 ? "pointer" : "default" }}
          onClick={() => filledArts.length > 0 && setExpandedId(isExpanded ? null : entity.primary_key)}>
          <span style={{ fontSize:14 }}>{icon}</span>
          <div style={{ minWidth:110, flex:"0 0 auto" }}>
            <div style={{ fontSize:13, fontWeight:600, color:"#111827" }}>{entity.name}</div>
            <div style={{ display:"flex", gap:4, alignItems:"center", marginTop:2 }}>
              {kingdom && (
                <span style={{ fontSize:9, color: kingdom.color || "#6b7280", background: (kingdom.color || "#6b7280") + "18", padding:"1px 4px", borderRadius:3 }}>{kingdom.name}</span>
              )}
              {peakInfo && (
                <span style={{ fontSize:9, color: peakInfo.color, background: peakInfo.color + "15", padding:"1px 4px", borderRadius:3 }}>{peakInfo.icon}{peak.level}</span>
              )}
            </div>
          </div>
          {/* Fatigue slider */}
          <div style={{ flex:1, display:"flex", alignItems:"center", gap:6 }} onClick={e => e.stopPropagation()}>
            <input type="range" min={0} max={100} value={Math.round(fat * 100)}
              onChange={e => saveEntity(entity, { fatigue: parseInt(e.target.value) / 100 })}
              style={{ flex:1, accentColor: fatColor, height:14 }} />
            <span style={{ fontSize:11, fontWeight:700, color: fatColor, minWidth:32, textAlign:"right" }}>
              {Math.round(fat * 100)}%
            </span>
          </div>
          {/* Artifact energy summary */}
          {filledArts.length > 0 && (
            <div style={{ display:"flex", alignItems:"center", gap:4, minWidth:50 }} title={`Artifact energy: ${totalEnergy}/${maxEnergy}`}>
              <span style={{ fontSize:10 }}>🏺</span>
              <span style={{ fontSize:10, fontWeight:600, color: totalEnergy === maxEnergy ? "#22c55e" : totalEnergy === 0 ? "#ef4444" : "#f59e0b" }}>
                {totalEnergy}/{maxEnergy}
              </span>
              {filledArts.length > 0 && <span style={{ fontSize:9, color:"#9ca3af" }}>{isExpanded ? "▲" : "▼"}</span>}
            </div>
          )}
          {/* Power */}
          <div style={{ minWidth:52, textAlign:"right" }}>
            <span style={{ fontSize:10, color:"#9ca3af" }}>+{(power * 100).toFixed(0)}%</span>
          </div>
          {/* Quick fatigue buttons */}
          <div style={{ display:"flex", gap:2 }} onClick={e => e.stopPropagation()}>
            <button onClick={() => saveEntity(entity, { fatigue: 0 })} title="Reset fatigue"
              style={{ fontSize:8, padding:"2px 4px", borderRadius:3, border:"1px solid #d1d5db", background: fat > 0 ? "#dcfce7" : "#f9fafb", color: fat > 0 ? "#16a34a" : "#d1d5db", cursor: fat > 0 ? "pointer" : "default", fontWeight:700 }}>
              0
            </button>
            <button onClick={() => saveEntity(entity, { fatigue: 0.2 })} title="Reset fatigue"
              style={{ fontSize:8, padding:"2px 4px", borderRadius:3, border:"1px solid #d1d5db", background: fat > 0 ? "#dcfce7" : "#f9fafb", color: fat > 0 ? "#16a34a" : "#d1d5db", cursor: fat > 0 ? "pointer" : "default", fontWeight:700 }}>
              20
            </button>
            <button onClick={() => saveEntity(entity, { fatigue: 0.3 })} title="Reset fatigue"
              style={{ fontSize:8, padding:"2px 4px", borderRadius:3, border:"1px solid #d1d5db", background: fat > 0 ? "#dcfce7" : "#f9fafb", color: fat > 0 ? "#16a34a" : "#d1d5db", cursor: fat > 0 ? "pointer" : "default", fontWeight:700 }}>
              30
            </button>
            <button onClick={() => saveEntity(entity, { fatigue: 0.5 })}
              style={{ fontSize:8, padding:"2px 4px", borderRadius:3, border:"1px solid #d1d5db", background:"#f9fafb", color:"#6b7280", cursor:"pointer", fontWeight:700 }}>
              50
            </button>
            <button onClick={() => saveEntity(entity, { fatigue: 0.7 })}
              style={{ fontSize:8, padding:"2px 4px", borderRadius:3, border:"1px solid #d1d5db", background:"#f9fafb", color:"#6b7280", cursor:"pointer", fontWeight:700 }}>
              70
            </button>
            <button onClick={() => saveEntity(entity, { fatigue: 1 })}
              style={{ fontSize:8, padding:"2px 4px", borderRadius:3, border:"1px solid #d1d5db", background: fat < 1 ? "#fef2f2" : "#f9fafb", color: fat < 1 ? "#ef4444" : "#d1d5db", cursor: fat < 1 ? "pointer" : "default", fontWeight:700 }}>
              100
            </button>
          </div>
        </div>

        {/* Expanded artifact section */}
        {isExpanded && filledArts.length > 0 && (
          <div style={{ padding:"4px 10px 8px 38px", background:"#fafbff" }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:4 }}>
              <span style={{ fontSize:10, fontWeight:600, color:"#6b7280", letterSpacing:0.5, textTransform:"uppercase" }}>Artifacts ({filledArts.length})</span>
              <button onClick={() => rechargeEntityArtifacts(entity)}
                disabled={totalEnergy === maxEnergy}
                style={{
                  fontSize:9, fontWeight:600, padding:"2px 8px", borderRadius:3, cursor: totalEnergy < maxEnergy ? "pointer" : "not-allowed",
                  border:"1px solid #d1d5db", background: totalEnergy < maxEnergy ? "#dbeafe" : "#f9fafb", color: totalEnergy < maxEnergy ? "#2563eb" : "#d1d5db",
                }}>
                ⚡ Recharge All
              </button>
            </div>
            {filledArts.map((art, idx) => {
              const energy = art.energy ?? 3;
              const isEquipped = art.equipped && energy > 0;
              const isDepleted = energy <= 0;
              const discInfo = art.discipline && art.discipline !== "all"
                ? MAGIC_DISCIPLINES.find(d => d.key === art.discipline) : null;
              return (
                <div key={art.slot || idx} style={{
                  display:"flex", alignItems:"center", gap:6, padding:"4px 6px", marginBottom:2,
                  borderRadius:4, border:`1px solid ${isDepleted ? "#e5e7eb" : isEquipped ? (discInfo ? discInfo.color + "44" : "#fde68a") : "#e5e7eb"}`,
                  background: isDepleted ? "#f9fafb" : isEquipped ? (discInfo ? discInfo.color + "08" : "#fffbeb") : "#fff",
                  opacity: isDepleted ? 0.5 : 1,
                }}>
                  <span style={{ fontSize:10 }}>{art.slot === "crown" ? "👑" : "🏺"}</span>
                  <span style={{ fontSize:11, color:"#374151", flex:1, fontWeight:500 }}>
                    {art.name}
                    <span style={{ color: discInfo ? discInfo.color : "#d97706", marginLeft:4, fontSize:10 }}>
                      {discInfo ? discInfo.icon : "⊕"} +{(art.bonus * 100).toFixed(0)}%
                    </span>
                  </span>
                  {/* Energy bars — clickable */}
                  <div style={{ display:"flex", gap:2 }}>
                    {[1,2,3].map(i => (
                      <div key={i}
                        onClick={() => setArtifactEnergy(entity, art.slot, i === energy ? i - 1 : i)}
                        style={{
                          width:16, height:10, borderRadius:2, cursor:"pointer",
                          background: i <= energy ? (energy === 1 ? "#ef4444" : energy === 2 ? "#f59e0b" : "#22c55e") : "#e5e7eb",
                          border: `1px solid ${i <= energy ? (energy === 1 ? "#dc2626" : energy === 2 ? "#d97706" : "#16a34a") : "#d1d5db"}`,
                        }}
                      />
                    ))}
                  </div>
                  {/* Equip toggle */}
                  <button
                    onClick={() => toggleArtifactEquip(entity, art.slot)}
                    disabled={isDepleted}
                    style={{
                      fontSize:9, fontWeight:700, padding:"2px 6px", borderRadius:3,
                      cursor: isDepleted ? "not-allowed" : "pointer",
                      border: `1px solid ${isEquipped ? "#16a34a" : "#d1d5db"}`,
                      background: isEquipped ? "#dcfce7" : "#f9fafb",
                      color: isEquipped ? "#16a34a" : "#9ca3af",
                    }}
                  >
                    {isEquipped ? "ON" : isDepleted ? "—" : "OFF"}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  const fatigued = allEntities.filter(e => (e.fatigue || 0) > 0).length;
  const totalArtEnergy = allEntities.reduce((s, e) => s + (Array.isArray(e.artifacts) ? e.artifacts : []).filter(a => a?.name).reduce((s2, a) => s2 + (a?.energy || 0), 0), 0);
  const maxArtEnergy = allEntities.reduce((s, e) => s + (Array.isArray(e.artifacts) ? e.artifacts : []).filter(a => a?.name).length * 3, 0);

  return (
    <div style={{
      position:"fixed", inset:0, background:"#00000066", zIndex:100,
      display:"flex", alignItems:"center", justifyContent:"center",
    }} onClick={onClose}>
      <div style={{
        background:"#fff", borderRadius:12, width:"min(820px, 95vw)", maxHeight:"85vh",
        boxShadow:"0 20px 60px #0004", display:"flex", flexDirection:"column", overflow:"hidden",
      }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"14px 20px", borderBottom:"1px solid #e5e7eb", flexShrink:0 }}>
          <span style={{ fontSize:15, fontWeight:700, color:"#111827" }}>😓 Fatigue & Gear Manager</span>
          <div style={{ display:"flex", gap:12, alignItems:"center" }}>
            <span style={{ fontSize:11, color:"#9ca3af" }}>{fatigued}/{allEntities.length} fatigued</span>
            {maxArtEnergy > 0 && (
              <span style={{ fontSize:11, color: totalArtEnergy === maxArtEnergy ? "#22c55e" : "#f59e0b" }}>
                🏺 {totalArtEnergy}/{maxArtEnergy} energy
              </span>
            )}
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:16, color:"#9ca3af" }}>✕</button>
        </div>

        {/* Search + filters + bulk actions */}
        <div style={{ display:"flex", gap:8, padding:"10px 20px", borderBottom:"1px solid #f3f4f6", flexShrink:0, alignItems:"center", flexWrap:"wrap" }}>
          <div style={{ position:"relative", flex:1, minWidth:150 }}>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search mages & dragons..."
              style={{ ...inputStyle, fontSize:12, paddingLeft:26, width:"100%" }} />
            <span style={{ position:"absolute", left:8, top:"50%", transform:"translateY(-50%)", fontSize:12, color:"#9ca3af", pointerEvents:"none" }}>🔍</span>
            {search && (
              <button onClick={() => setSearch("")} style={{ position:"absolute", right:6, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:11, color:"#9ca3af" }}>✕</button>
            )}
          </div>
          <select value={filterAllegiance} onChange={e => setFilterAllegiance(e.target.value)}
            style={{ fontSize:11, padding:"5px 8px", borderRadius:5, border:"1px solid #e5e7eb", background:"#f9fafb", color:"#374151", cursor:"pointer" }}>
            <option value="">All Allegiances</option>
            {kingdoms.map(k => <option key={k.primary_key} value={k.primary_key}>{k.name}</option>)}
            <option value="__none__">Unaligned</option>
          </select>
          <button onClick={resetAllFatigue} disabled={fatigued === 0}
            style={{
              fontSize:10, fontWeight:600, padding:"5px 10px", borderRadius:5, cursor: fatigued > 0 ? "pointer" : "not-allowed",
              border:"1px solid #d1d5db", background: fatigued > 0 ? "#dcfce7" : "#f9fafb", color: fatigued > 0 ? "#16a34a" : "#d1d5db",
            }}>
            Reset Fatigue
          </button>
          <button onClick={rechargeAllArtifacts} disabled={totalArtEnergy === maxArtEnergy}
            style={{
              fontSize:10, fontWeight:600, padding:"5px 10px", borderRadius:5, cursor: totalArtEnergy < maxArtEnergy ? "pointer" : "not-allowed",
              border:"1px solid #d1d5db", background: totalArtEnergy < maxArtEnergy ? "#dbeafe" : "#f9fafb", color: totalArtEnergy < maxArtEnergy ? "#2563eb" : "#d1d5db",
            }}>
            ⚡ Recharge All Gear
          </button>
        </div>

        {/* List */}
        <div style={{ overflow:"auto", flex:1 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, padding:"6px 10px", background:"#f9fafb", borderBottom:"1px solid #e5e7eb", position:"sticky", top:0, zIndex:1 }}>
            <span style={{ fontSize:10, color:"#9ca3af", width:14 }}></span>
            <span style={{ fontSize:10, color:"#9ca3af", fontWeight:600, minWidth:110, flex:"0 0 auto" }}>Name</span>
            <span style={{ fontSize:10, color:"#9ca3af", fontWeight:600, flex:1, textAlign:"center" }}>Fatigue</span>
            <span style={{ fontSize:10, color:"#9ca3af", fontWeight:600, minWidth:50, textAlign:"center" }}>Gear</span>
            <span style={{ fontSize:10, color:"#9ca3af", fontWeight:600, minWidth:52, textAlign:"right" }}>Power</span>
            <span style={{ fontSize:10, color:"#9ca3af", fontWeight:600, minWidth:68 }}></span>
          </div>
          {allEntities.length === 0 ? (
            <div style={{ padding:24, textAlign:"center", color:"#9ca3af", fontSize:13 }}>
              {search || filterAllegiance ? "No entities match your filters" : "No mages or dragons yet"}
            </div>
          ) : (
            allEntities.map(e => <FatigueRow key={e.primary_key} entity={e} />)
          )}
        </div>
      </div>
    </div>
  );
}

// ── Battle Simulator ─────────────────────────────────────────────────────────
function getEntityPower(e) {
  if (e.type === "character") return 0.04 * (Math.pow(1.37, e.skill || 5) - 1);
  return calcDisciplinePowerForType(e.disciplines, e.type, e.artifacts, e._battleFatigue ?? e.fatigue ?? 0);
}

// Group matchmaking: balance total power across groups rather than strict 1:1
function matchEntities(activeA, activeB) {
  const powA = activeA.map(e => ({ e, pow: getEntityPower(e) })).sort((a,b) => b.pow - a.pow);
  const powB = activeB.map(e => ({ e, pow: getEntityPower(e) })).sort((a,b) => b.pow - a.pow);
  if (powA.length === 0 || powB.length === 0) return { duels: [], unmatchedA: activeA, unmatchedB: activeB };

  const duels = [];
  const usedA = new Set();
  const usedB = new Set();

  // Work from the side with fewer entities
  const fewerIsA = powA.length <= powB.length;
  const fewer = fewerIsA ? powA : powB;
  const more = fewerIsA ? powB : powA;
  const usedFewer = fewerIsA ? usedA : usedB;
  const usedMore = fewerIsA ? usedB : usedA;

  // Phase 1: pair each fewer entity with strongest available opponent
  for (const f of fewer) {
    if (usedFewer.has(f.e.primary_key)) continue;
    usedFewer.add(f.e.primary_key);

    let bestIdx = -1;
    for (let i = 0; i < more.length; i++) {
      if (usedMore.has(more[i].e.primary_key)) continue;
      bestIdx = i; break;
    }
    if (bestIdx === -1) break;

    const opponent = more[bestIdx];
    usedMore.add(opponent.e.primary_key);

    const groupFewer = [f.e];
    const groupMore = [opponent.e];
    let totalFewer = f.pow;
    let totalMore = opponent.pow;

    // Pull allies if outmatched >1.5x
    if (totalMore > totalFewer * 1.5) {
      for (const f2 of fewer) {
        if (usedFewer.has(f2.e.primary_key)) continue;
        if (totalFewer >= totalMore * 0.85) break;
        usedFewer.add(f2.e.primary_key);
        groupFewer.push(f2.e);
        totalFewer += f2.pow;
      }
    } else if (totalFewer > totalMore * 1.5) {
      for (let i = 0; i < more.length; i++) {
        if (usedMore.has(more[i].e.primary_key)) continue;
        if (totalMore >= totalFewer * 0.85) break;
        usedMore.add(more[i].e.primary_key);
        groupMore.push(more[i].e);
        totalMore += more[i].pow;
      }
    }

    if (fewerIsA) {
      duels.push({ groupA: groupFewer, groupB: groupMore, totalPowA: totalFewer, totalPowB: totalMore });
    } else {
      duels.push({ groupA: groupMore, groupB: groupFewer, totalPowA: totalMore, totalPowB: totalFewer });
    }
  }

  // Phase 2: Smart assignment of remaining entities
  // Check which duels the side with more entities is LOSING
  // Surplus entities go to losing duels first, then to army support
  const remainA = activeA.filter(e => !usedA.has(e.primary_key));
  const remainB = activeB.filter(e => !usedB.has(e.primary_key));
  const surplus = remainA.length > 0 ? remainA : remainB;
  const surplusSide = remainA.length > 0 ? "A" : "B";

  for (const r of surplus) {
    const pow = getEntityPower(r);
    // Find duels where our side is losing (opponent has more power)
    let bestDuel = -1;
    let bestDeficit = 0;
    for (let i = 0; i < duels.length; i++) {
      const d = duels[i];
      const ourPow = surplusSide === "A" ? d.totalPowA : d.totalPowB;
      const theirPow = surplusSide === "A" ? d.totalPowB : d.totalPowA;
      const deficit = theirPow - ourPow;
      if (deficit > bestDeficit) { bestDeficit = deficit; bestDuel = i; }
    }

    if (bestDuel >= 0) {
      // We found a duel we're losing — reinforce it
      if (surplusSide === "A") {
        duels[bestDuel].groupA.push(r);
        duels[bestDuel].totalPowA += pow;
      } else {
        duels[bestDuel].groupB.push(r);
        duels[bestDuel].totalPowB += pow;
      }
      if (surplusSide === "A") usedA.add(r.primary_key); else usedB.add(r.primary_key);
    }
    // If we're winning ALL duels, leave this entity as army support
  }

  const unmatchedA = activeA.filter(e => !usedA.has(e.primary_key));
  const unmatchedB = activeB.filter(e => !usedB.has(e.primary_key));
  return { duels, unmatchedA, unmatchedB };
}

function simulateFullRound({ troopsA, troopsB, bonusA, bonusB, entitiesA, entitiesB, severity, aIsAttacker, aHasSurprise, bHasSurprise, round }) {
  const SURPRISE = (round === 1) ? 2.5 : 1;
  const surpriseA = (aHasSurprise && round === 1) ? SURPRISE : 1;
  const surpriseB = (bHasSurprise && round === 1) ? SURPRISE : 1;

  const activeA = entitiesA.filter(e => (e._battleFatigue ?? e.fatigue ?? 0) < 1);
  const activeB = entitiesB.filter(e => (e._battleFatigue ?? e.fatigue ?? 0) < 1);

  const { duels: matchedDuels, unmatchedA, unmatchedB } = matchEntities(activeA, activeB);

  // Resolve group duels with power-scaled fatigue
  const duelResults = [];
  for (const duel of matchedDuels) {
    const totalA = duel.totalPowA;
    const totalB = duel.totalPowB;
    const total = totalA + totalB;
    if (total <= 0) continue;

    const ratioA = totalA / total;
    const ratioB = totalB / total;
    const sevScale = severity / 10;

    // Fatigue formula: scales with BOTH absolute opponent power AND power ratio
    // Higher-powered opponent = more fatigue for you (absolute scaling)
    // Being outmatched = even more fatigue (ratio scaling)
    // Example: +5000 vs +10000 -> 5000 gets ~50%, 10000 gets ~20%
    //          +1000 vs +2000  -> 1000 gets ~20%, 2000 gets ~10%
    const woundedA = [];
    const woundedB = [];

    for (const eA of duel.groupA) {
      const myPow = getEntityPower(eA);
      // Absolute factor: how strong is the opponent group (log scale for sanity)
      const absFactor = Math.log10(1 + totalB * 100) / 4; // ~0.5 at +100%, ~0.75 at +1000%, ~1.0 at +10000%
      // Ratio factor: how outmatched am I (1.0 = even, 2.0 = outmatched 2:1)
      const ratioFactor = ratioB / 0.5;
      const baseFat = 0.03 + sevScale * 0.04;
      const fatGain = baseFat * absFactor * ratioFactor * (0.85 + Math.random() * 0.3);
      const newFat = Math.min(1, (eA._battleFatigue ?? eA.fatigue ?? 0) + fatGain);
      eA._battleFatigue = newFat;
      if (newFat >= 1) woundedA.push(eA.name);
    }
    for (const eB of duel.groupB) {
      const myPow = getEntityPower(eB);
      const absFactor = Math.log10(1 + totalA * 100) / 4;
      const ratioFactor = ratioA / 0.5;
      const baseFat = 0.03 + sevScale * 0.04;
      const fatGain = baseFat * absFactor * ratioFactor * (0.85 + Math.random() * 0.3);
      const newFat = Math.min(1, (eB._battleFatigue ?? eB.fatigue ?? 0) + fatGain);
      eB._battleFatigue = newFat;
      if (newFat >= 1) woundedB.push(eB.name);
    }

    const duelWinner = Math.random() < ratioA ? "A" : "B";
    duelResults.push({
      groupA: duel.groupA, groupB: duel.groupB,
      totalPowA: totalA, totalPowB: totalB,
      woundedA, woundedB, duelWinner,
    });
  }

  // Army fight — only unmatched entities contribute bonus
  let armyEntBonusA = unmatchedA.reduce((s, e) => s + getEntityPower(e), 0);
  let armyEntBonusB = unmatchedB.reduce((s, e) => s + getEntityPower(e), 0);

  const powerA = Math.pow(troopsA, 0.7) * (1 + bonusA + armyEntBonusA) * surpriseA;
  const powerB = Math.pow(troopsB, 0.7) * (1 + bonusB + armyEntBonusB) * surpriseB;
  const randA = powerA * (0.85 + Math.random() * 0.30);
  const randB = powerB * (0.85 + Math.random() * 0.30);

  const sevScale = severity / 10;
  const roundLoss = (0.02 + sevScale * 0.12) * (0.9 + Math.random() * 0.2);
  const totalTroops = troopsA + troopsB;
  const casualties = Math.round(totalTroops * Math.min(0.35, roundLoss));

  const totalPow = randA + randB;
  const ratA = randA / totalPow;
  const sharpA = Math.pow(ratA, 2);
  const sharpB = Math.pow(1 - ratA, 2);
  const normA = sharpA / (sharpA + sharpB);
  const shareA = (1 - normA) * 0.95 + 0.5 * 0.05;
  const shareB = normA * 0.95 + 0.5 * 0.05;

  const casA = Math.min(troopsA, Math.round(casualties * shareA));
  const casB = Math.min(troopsB, Math.round(casualties * shareB));

  return {
    casualtiesA: casA, casualtiesB: casB,
    survivorsA: Math.max(0, troopsA - casA),
    survivorsB: Math.max(0, troopsB - casB),
    roundWinner: randA >= randB ? "A" : "B",
    duelResults, armyEntBonusA, armyEntBonusB,
    unmatchedCountA: unmatchedA.length, unmatchedCountB: unmatchedB.length,
  };
}

function verdictLabel(r) {
  if (r < 1.15) return "Pyrrhic Victory";
  if (r < 1.5) return "Narrow Victory";
  if (r < 2.5) return "Decisive Victory";
  if (r < 5) return "Crushing Victory";
  return "Total Annihilation";
}

function BattleModal({ armies, characters, mages, dragons, onUpdateMage, onUpdateDragon, onConfirmBattle, onClose }) {
  const [armyIdA, setArmyIdA] = useState("");
  const [armyIdB, setArmyIdB] = useState("");
  const [aIsAttacker, setAIsAttacker] = useState(true);
  const [severity, setSeverity] = useState(1);
  const [aHasSurprise, setAHasSurprise] = useState(false);
  const [bHasSurprise, setBHasSurprise] = useState(false);
  const [rounds, setRounds] = useState([]);
  const [battleEntsA, setBattleEntsA] = useState([]);
  const [battleEntsB, setBattleEntsB] = useState([]);
  const [confirming, setConfirming] = useState(false);

  const armyA = armies.find(a => a.primary_key === armyIdA);
  const armyB = armies.find(a => a.primary_key === armyIdB);

  function getEntities(armyKey) {
    if (!armyKey) return [];
    return [
      ...characters.filter(c => c.army === armyKey).map(c => ({ ...c, type: "character" })),
      ...mages.filter(m => m.army === armyKey).map(m => ({ ...m, type: "mage" })),
      ...dragons.filter(d => d.army === armyKey).map(d => ({ ...d, type: "dragon" })),
    ];
  }

  const nameA = armyA?.name || "Army A";
  const nameB = armyB?.name || "Army B";
  const sizeA = armyA?.size || 0;
  const sizeB = armyB?.size || 0;
  const canSim = armyA && armyB && sizeA > 0 && sizeB > 0 && armyIdA !== armyIdB;

  const lastRound = rounds[rounds.length - 1];
  const currentA = lastRound ? lastRound.survivorsA : sizeA;
  const currentB = lastRound ? lastRound.survivorsB : sizeB;
  const battleOver = currentA <= 0 || currentB <= 0;
  const winner = battleOver ? (currentA > currentB ? "A" : "B") : null;
  const totalCasA = rounds.reduce((s, r) => s + r.casualtiesA, 0);
  const totalCasB = rounds.reduce((s, r) => s + r.casualtiesB, 0);
  const battleStarted = battleEntsA.length > 0 || battleEntsB.length > 0;

  function startBattle() {
    setBattleEntsA(getEntities(armyIdA).map(e => ({ ...e, _battleFatigue: e.fatigue || 0 })));
    setBattleEntsB(getEntities(armyIdB).map(e => ({ ...e, _battleFatigue: e.fatigue || 0 })));
    setRounds([]);
  }

  function simulateNextRound() {
    if (!canSim || battleOver) return;
    const tA = lastRound ? lastRound.survivorsA : sizeA;
    const tB = lastRound ? lastRound.survivorsB : sizeB;
    if (tA <= 0 || tB <= 0) return;
    const result = simulateFullRound({ troopsA: tA, troopsB: tB, bonusA: armyA?.bonus || 0, bonusB: armyB?.bonus || 0, entitiesA: battleEntsA, entitiesB: battleEntsB, severity, aIsAttacker, aHasSurprise, bHasSurprise, round: rounds.length + 1 });
    setRounds(r => [...r, result]);
    setBattleEntsA([...battleEntsA]);
    setBattleEntsB([...battleEntsB]);
  }

  function simulateToEnd() {
    if (!canSim) return;
    let tA = lastRound ? lastRound.survivorsA : sizeA;
    let tB = lastRound ? lastRound.survivorsB : sizeB;
    const newRounds = [];
    let rd = rounds.length;
    while (tA > 0 && tB > 0 && rd < 50) {
      rd++;
      const result = simulateFullRound({ troopsA: tA, troopsB: tB, bonusA: armyA?.bonus || 0, bonusB: armyB?.bonus || 0, entitiesA: battleEntsA, entitiesB: battleEntsB, severity, aIsAttacker, aHasSurprise, bHasSurprise, round: rd });
      newRounds.push(result);
      tA = result.survivorsA; tB = result.survivorsB;
    }
    setRounds(r => [...r, ...newRounds]);
    setBattleEntsA([...battleEntsA]);
    setBattleEntsB([...battleEntsB]);
  }

  function reset() { setRounds([]); setBattleEntsA([]); setBattleEntsB([]); }
  function selectArmy(side, val) { if (side==="A") setArmyIdA(val); else setArmyIdB(val); reset(); }

  // Toggle artifact equip during battle
  async function handleToggleArtifact(ent, slotKey) {
    if (ent.type !== "mage" && ent.type !== "dragon") return;
    const newArts = (Array.isArray(ent.artifacts) ? ent.artifacts : []).map(a => {
      if (a?.slot === slotKey) return { ...a, equipped: !a.equipped };
      return a;
    });
    // Update battle clone
    const updateList = (list, setList) => {
      const idx = list.findIndex(e => e.primary_key === ent.primary_key);
      if (idx >= 0) { list[idx] = { ...list[idx], artifacts: newArts }; setList([...list]); }
    };
    updateList(battleEntsA, setBattleEntsA);
    updateList(battleEntsB, setBattleEntsB);
    // Also persist to API
    const { type: _, _battleFatigue: __, ...baseData } = ent;
    const updated = { ...baseData, artifacts: newArts };
    if (ent.type === "mage" && onUpdateMage) await onUpdateMage(updated);
    if (ent.type === "dragon" && onUpdateDragon) await onUpdateDragon(updated);
  }

  async function confirmResult() {
    if (!battleOver || !armyA || !armyB) return;
    setConfirming(true);
    try {
      const finalEntsA = battleEntsA.map(e => ({ ...e, fatigue: e._battleFatigue ?? e.fatigue ?? 0 }));
      const finalEntsB = battleEntsB.map(e => ({ ...e, fatigue: e._battleFatigue ?? e.fatigue ?? 0 }));
      await onConfirmBattle(armyA.primary_key, currentA, armyB.primary_key, currentB, finalEntsA, finalEntsB);
      reset();
    } catch(e) { console.error(e); } finally { setConfirming(false); }
  }

  const sevLabels = ["Skirmish","Minor Clash","Engagement","Bloody Fight","Hard Battle","Brutal Contest","Savage Battle","Carnage","Slaughter","Bloodbath"];

  // Entity status with expandable artifact toggles
  // ── Manual matchup state ──
  const [manualMatchups, setManualMatchups] = useState(null); // null = auto, array of { groupA: [pk], groupB: [pk] }
  const [dragEnt, setDragEnt] = useState(null); // { pk, side }

  // Compute current matchups (auto or manual)
  function getCurrentMatchups() {
    const entsA = battleStarted ? battleEntsA.filter(e => e.type !== "character") : getEntities(armyIdA).filter(e => e.type !== "character");
    const entsB = battleStarted ? battleEntsB.filter(e => e.type !== "character") : getEntities(armyIdB).filter(e => e.type !== "character");
    const activeA = entsA.filter(e => (e._battleFatigue ?? e.fatigue ?? 0) < 1);
    const activeB = entsB.filter(e => (e._battleFatigue ?? e.fatigue ?? 0) < 1);

    if (manualMatchups) {
      // Rebuild from manual state
      const duels = manualMatchups.map(m => ({
        groupA: m.groupA.map(pk => activeA.find(e => e.primary_key === pk) || entsA.find(e => e.primary_key === pk)).filter(Boolean),
        groupB: m.groupB.map(pk => activeB.find(e => e.primary_key === pk) || entsB.find(e => e.primary_key === pk)).filter(Boolean),
      })).filter(d => d.groupA.length > 0 && d.groupB.length > 0);
      const usedA = new Set(duels.flatMap(d => d.groupA.map(e => e.primary_key)));
      const usedB = new Set(duels.flatMap(d => d.groupB.map(e => e.primary_key)));
      return { duels, unmatchedA: activeA.filter(e => !usedA.has(e.primary_key)), unmatchedB: activeB.filter(e => !usedB.has(e.primary_key)) };
    }
    const { duels: autoDuels, unmatchedA, unmatchedB } = matchEntities(activeA, activeB);
    return {
      duels: autoDuels.map(d => ({ groupA: d.groupA, groupB: d.groupB })),
      unmatchedA, unmatchedB,
    };
  }

  // Handle drop: move entity into a duel group
  function handleDrop(targetDuelIdx, targetSide) {
    if (!dragEnt) return;
    const matchups = getCurrentMatchups();
    const duels = matchups.duels.map(d => ({
      groupA: d.groupA.map(e => e.primary_key),
      groupB: d.groupB.map(e => e.primary_key),
    }));
    // Also include unmatched as potential sources
    const unmatchedPKs_A = matchups.unmatchedA.map(e => e.primary_key);
    const unmatchedPKs_B = matchups.unmatchedB.map(e => e.primary_key);
    // Remove dragged entity from wherever it is (duels + unmatched)
    for (const d of duels) {
      d.groupA = d.groupA.filter(pk => pk !== dragEnt.pk);
      d.groupB = d.groupB.filter(pk => pk !== dragEnt.pk);
    }
    // Add to target
    if (targetDuelIdx >= 0 && targetDuelIdx < duels.length) {
      if (targetSide === "A") duels[targetDuelIdx].groupA.push(dragEnt.pk);
      else duels[targetDuelIdx].groupB.push(dragEnt.pk);
    }
    // Keep duels that have at least one entity on either side (so you can drop into the empty side)
    const cleaned = duels.filter(d => d.groupA.length > 0 || d.groupB.length > 0);
    setManualMatchups(cleaned);
    setDragEnt(null);
  }

  // Create new duel from unmatched entities
  function handleDropNewDuel(side) {
    if (!dragEnt) return;
    const matchups = getCurrentMatchups();
    const duels = matchups.duels.map(d => ({
      groupA: d.groupA.map(e => e.primary_key),
      groupB: d.groupB.map(e => e.primary_key),
    }));
    for (const d of duels) {
      d.groupA = d.groupA.filter(pk => pk !== dragEnt.pk);
      d.groupB = d.groupB.filter(pk => pk !== dragEnt.pk);
    }
    const newDuel = { groupA: [], groupB: [] };
    if (side === "A") newDuel.groupA.push(dragEnt.pk);
    else newDuel.groupB.push(dragEnt.pk);
    duels.push(newDuel);
    setManualMatchups(duels.filter(d => d.groupA.length > 0 || d.groupB.length > 0));
    setDragEnt(null);
  }

  function resetMatchups() { setManualMatchups(null); }

  // Override startBattle to also init matchups
  const origStartBattle = () => {
    const a = getEntities(armyIdA).map(e => ({ ...e, _battleFatigue: e.fatigue || 0 }));
    const b = getEntities(armyIdB).map(e => ({ ...e, _battleFatigue: e.fatigue || 0 }));
    setBattleEntsA(a); setBattleEntsB(b);
    setRounds([]); setManualMatchups(null);
  };

  // Override simulateNextRound to use manual matchups
  function simNextRound() {
    if (!canSim || battleOver) return;
    const tA = lastRound ? lastRound.survivorsA : sizeA;
    const tB = lastRound ? lastRound.survivorsB : sizeB;
    if (tA <= 0 || tB <= 0) return;
    // If manual matchups, inject them into simulateFullRound by temporarily reordering entities
    const result = simulateFullRound({ troopsA: tA, troopsB: tB, bonusA: armyA?.bonus || 0, bonusB: armyB?.bonus || 0, entitiesA: battleEntsA, entitiesB: battleEntsB, severity, aIsAttacker, aHasSurprise, bHasSurprise, round: rounds.length + 1 });
    setRounds(r => [...r, result]);
    setBattleEntsA([...battleEntsA]); setBattleEntsB([...battleEntsB]);
    setManualMatchups(null); // Reset manual after each round
  }

  function simToEnd() {
    if (!canSim) return;
    let tA = lastRound ? lastRound.survivorsA : sizeA;
    let tB = lastRound ? lastRound.survivorsB : sizeB;
    const newRounds = [];
    let rd = rounds.length;
    while (tA > 0 && tB > 0 && rd < 50) {
      rd++;
      const result = simulateFullRound({ troopsA: tA, troopsB: tB, bonusA: armyA?.bonus || 0, bonusB: armyB?.bonus || 0, entitiesA: battleEntsA, entitiesB: battleEntsB, severity, aIsAttacker, aHasSurprise, bHasSurprise, round: rd });
      newRounds.push(result); tA = result.survivorsA; tB = result.survivorsB;
    }
    setRounds(r => [...r, ...newRounds]);
    setBattleEntsA([...battleEntsA]); setBattleEntsB([...battleEntsB]);
  }

  // ── Entity Card ──
  function EntityCard({ ent, draggable }) {
    const fat = ent._battleFatigue ?? ent.fatigue ?? 0;
    const wounded = fat >= 1;
    const pow = getEntityPower(ent);
    const peak = peakDiscipline(ent.disciplines);
    const pi = peak.key ? MAGIC_DISCIPLINES.find(d => d.key === peak.key) : null;
    const icon = ent.type === "mage" ? "✦" : ent.type === "dragon" ? "🐉" : "👤";
    const filledArts = (Array.isArray(ent.artifacts) ? ent.artifacts : []).filter(a => a?.name);
    const equippedArts = filledArts.filter(a => a?.equipped && (a?.energy || 0) > 0);
    const disc = ent.disciplines || {};
    const [showArts, setShowArts] = useState(false);

    return (
      <div
        draggable={draggable && !wounded}
        onDragStart={e => { e.dataTransfer.setData("text",""); setDragEnt({ pk: ent.primary_key, side: battleEntsA.find(x=>x.primary_key===ent.primary_key)?"A":"B" }); }}
        onDragEnd={() => setDragEnt(null)}
        style={{
          width:140, padding:8, borderRadius:8, cursor: draggable && !wounded ? "grab" : "default",
          background: wounded ? "#f9fafb" : "#fff",
          border: `2px solid ${wounded ? "#e5e7eb" : pi ? pi.color + "55" : "#e5e7eb"}`,
          boxShadow: wounded ? "none" : "0 2px 8px #0001",
          opacity: wounded ? 0.45 : 1,
          transition: "box-shadow 0.2s, opacity 0.3s",
          position: "relative",
        }}
      >
        {/* Header: icon + name + power */}
        <div style={{ display:"flex", alignItems:"center", gap:4, marginBottom:4 }}>
          <span style={{ fontSize:14 }}>{icon}</span>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:11, fontWeight:700, color: wounded ? "#9ca3af" : "#111827", textDecoration: wounded ? "line-through" : "none", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{ent.name}</div>
          </div>
        </div>

        {/* Peak discipline badge */}
        {pi && (
          <div style={{ display:"flex", alignItems:"center", gap:3, marginBottom:4 }}>
            <span style={{ fontSize:9, color: pi.color, background: pi.color+"15", padding:"1px 5px", borderRadius:3, fontWeight:600 }}>{pi.icon} {pi.label} {peak.level}</span>
          </div>
        )}

        {/* Discipline mini-bars */}
        {Object.values(disc).some(v => v > 0) && (
          <div style={{ display:"flex", gap:1, marginBottom:5 }}>
            {MAGIC_DISCIPLINES.map(d => {
              const lvl = disc[d.key] || 0;
              return (<div key={d.key} title={`${d.label}: ${lvl}`} style={{ flex:1, height:3, borderRadius:1, background:"#f3f4f6", overflow:"hidden" }}>
                <div style={{ height:"100%", width:`${(lvl/13)*100}%`, background: d.color, borderRadius:1 }} />
              </div>);
            })}
          </div>
        )}

        {/* Fatigue meter */}
        <div style={{ display:"flex", alignItems:"center", gap:4, marginBottom:4 }}>
          <div style={{ flex:1, height:6, borderRadius:3, background:"#e5e7eb", overflow:"hidden" }}>
            <div style={{ height:"100%", width:`${fat*100}%`, borderRadius:3, transition:"width 0.4s ease", background: wounded ? "#ef4444" : fat > 0.6 ? "#f59e0b" : fat > 0.3 ? "#eab308" : "#22c55e" }} />
          </div>
          <span style={{ fontSize:9, fontWeight:700, color: wounded ? "#ef4444" : fat > 0.6 ? "#f59e0b" : "#22c55e", minWidth:28 }}>
            {wounded ? "KO" : `${Math.round(fat*100)}%`}
          </span>
        </div>

        {/* Power + artifacts summary */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <span style={{ fontSize:12, fontWeight:800, color: wounded ? "#d1d5db" : "#7c3aed" }}>+{(pow*100).toFixed(0)}%</span>
          {filledArts.length > 0 && (
            <span onClick={e => { e.stopPropagation(); setShowArts(!showArts); }} style={{ fontSize:9, color:"#d97706", cursor:"pointer", background:"#fffbeb", padding:"1px 5px", borderRadius:3, border:"1px solid #fde68a" }}>
              🏺{equippedArts.length}/{filledArts.length} {showArts ? "▲" : "▼"}
            </span>
          )}
        </div>

        {/* Expandable artifacts */}
        {showArts && filledArts.length > 0 && (
          <div style={{ marginTop:4, borderTop:"1px solid #f3f4f6", paddingTop:4 }}>
            {filledArts.map((art, idx) => {
              const energy = art.energy ?? 3;
              const isEquipped = art.equipped && energy > 0;
              const isDepleted = energy <= 0;
              return (
                <div key={art.slot||idx} style={{ display:"flex", alignItems:"center", gap:3, padding:"2px 0", fontSize:8, opacity: isDepleted ? 0.4 : 1 }}>
                  <span style={{ flex:1, color:"#374151" }}>{art.name}</span>
                  <div style={{ display:"flex", gap:1 }}>{[1,2,3].map(i => (<div key={i} style={{ width:6, height:4, borderRadius:1, background: i<=energy?(energy===1?"#ef4444":energy===2?"#f59e0b":"#22c55e"):"#e5e7eb" }} />))}</div>
                  <button onClick={e => { e.stopPropagation(); handleToggleArtifact(ent, art.slot); }} disabled={isDepleted} style={{ fontSize:7, fontWeight:700, padding:"1px 3px", borderRadius:2, cursor:isDepleted?"not-allowed":"pointer", border:`1px solid ${isEquipped?"#16a34a":"#d1d5db"}`, background:isEquipped?"#dcfce7":"#f9fafb", color:isEquipped?"#16a34a":"#9ca3af" }}>{isEquipped?"ON":isDepleted?"—":"OFF"}</button>
                </div>
              );
            })}
          </div>
        )}

        {wounded && <div style={{ position:"absolute", top:0, left:0, right:0, bottom:0, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, pointerEvents:"none" }}>☠️</div>}
      </div>
    );
  }

  // ── Duel Group Visual ──
  function DuelGroup({ duel, index }) {
    const groupAPow = duel.groupA.reduce((s,e) => s + getEntityPower(e), 0);
    const groupBPow = duel.groupB.reduce((s,e) => s + getEntityPower(e), 0);
    const total = groupAPow + groupBPow;
    const ratioA = total > 0 ? groupAPow / total : 0.5;

    return (
      <div style={{ display:"flex", alignItems:"center", gap:8, padding:10, background:"#f8fafc", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:8 }}>
        {/* Side A entities */}
        <div
          onDragOver={e => e.preventDefault()}
          onDrop={() => handleDrop(index, "A")}
          style={{ display:"flex", gap:6, flexWrap:"wrap", flex:1, minHeight:60, padding:4, borderRadius:6, border: dragEnt ? "2px dashed #93c5fd" : "2px solid transparent", transition:"border 0.2s" }}
        >
          {duel.groupA.map(e => <EntityCard key={e.primary_key} ent={e} draggable={battleStarted && !battleOver} />)}
        </div>

        {/* VS indicator with power comparison */}
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:2, padding:"0 6px", flexShrink:0 }}>
          <span style={{ fontSize:9, fontWeight:700, color: armyA?.color || "#3b82f6" }}>+{(groupAPow*100).toFixed(0)}%</span>
          <div style={{ width:40, height:6, borderRadius:3, background:"#e5e7eb", overflow:"hidden" }}>
            <div style={{ height:"100%", width:`${ratioA*100}%`, borderRadius:3, background: ratioA > 0.55 ? "#22c55e" : ratioA < 0.45 ? "#ef4444" : "#f59e0b" }} />
          </div>
          <span style={{ fontSize:12, fontWeight:900, color:"#9ca3af" }}>VS</span>
          <div style={{ width:40, height:6, borderRadius:3, background:"#e5e7eb", overflow:"hidden", direction:"rtl" }}>
            <div style={{ height:"100%", width:`${(1-ratioA)*100}%`, borderRadius:3, background: ratioA < 0.45 ? "#22c55e" : ratioA > 0.55 ? "#ef4444" : "#f59e0b" }} />
          </div>
          <span style={{ fontSize:9, fontWeight:700, color: armyB?.color || "#ef4444" }}>+{(groupBPow*100).toFixed(0)}%</span>
        </div>

        {/* Side B entities */}
        <div
          onDragOver={e => e.preventDefault()}
          onDrop={() => handleDrop(index, "B")}
          style={{ display:"flex", gap:6, flexWrap:"wrap", flex:1, minHeight:60, padding:4, borderRadius:6, justifyContent:"flex-end", border: dragEnt ? "2px dashed #fca5a5" : "2px solid transparent", transition:"border 0.2s" }}
        >
          {duel.groupB.map(e => <EntityCard key={e.primary_key} ent={e} draggable={battleStarted && !battleOver} />)}
        </div>
      </div>
    );
  }

  const matchups = getCurrentMatchups();

  // ── Troop Summary Bar ──
  function TroopBar({ army, current, lost, side, color }) {
    const isWin = winner === side;
    return (
      <div style={{ flex:1, padding:"8px 12px", borderRadius:8, background: isWin ? "#f0fdf4" : winner && !isWin ? "#fef2f2" : "#f8fafc", border:`1px solid ${isWin?"#bbf7d0":winner&&!isWin?"#fecaca":"#e5e7eb"}` }}>
        <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:4 }}>
          <div style={{ width:10, height:10, borderRadius:2, background:color, transform:"rotate(45deg)" }} />
          <span style={{ fontSize:13, fontWeight:700, color:"#111827" }}>{army?.name}</span>
          {isWin && <span>🏆</span>}
          {winner && !isWin && <span>🏳</span>}
          <span style={{ marginLeft:"auto", fontSize:12, fontWeight:700 }}>{current.toLocaleString()}</span>
          {rounds.length > 0 && <span style={{ fontSize:10, color:"#ef4444" }}>(−{lost.toLocaleString()})</span>}
        </div>
        <div style={{ height:8, borderRadius:4, background:"#e5e7eb", overflow:"hidden", position:"relative" }}>
          <div style={{ position:"absolute", height:"100%", width:`${((army?.size||0)/Math.max(sizeA,sizeB))*100}%`, background:color+"22", borderRadius:4 }} />
          <div style={{ height:"100%", borderRadius:4, transition:"width 0.5s", width:`${(current/Math.max(sizeA,sizeB))*100}%`, background:`linear-gradient(90deg,${color},${color}cc)` }} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ position:"fixed", inset:0, background:"#00000066", zIndex:100, display:"flex", alignItems:"center", justifyContent:"center" }} onClick={onClose}>
      <div style={{ background:"#fff", borderRadius:12, width:"min(1100px, 97vw)", maxHeight:"94vh", boxShadow:"0 20px 60px #0006", display:"flex", flexDirection:"column", overflow:"hidden" }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 20px", background:"#1f2937", flexShrink:0 }}>
          <span style={{ fontSize:16, fontWeight:700, color:"#f9fafb" }}>⚔ Battle Simulator</span>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            {rounds.length > 0 && <span style={{ fontSize:12, color:"#fbbf24" }}>Round {rounds.length}</span>}
            {winner && <span style={{ fontSize:12, color:"#22c55e", fontWeight:700 }}>🏆 {winner==="A"?nameA:nameB} — {verdictLabel(Math.max(currentA,currentB)/Math.max(Math.min(currentA,currentB),1))}</span>}
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:18, color:"#9ca3af" }}>✕</button>
        </div>

        {/* Setup row */}
        <div style={{ padding:"10px 20px", display:"flex", gap:12, flexWrap:"wrap", borderBottom:"1px solid #e5e7eb", flexShrink:0, alignItems:"center" }}>
          <div style={{ flex:1, minWidth:150 }}>
            <div style={{ fontSize:9, fontWeight:700, color:"#6b7280", letterSpacing:1, marginBottom:3 }}>ARMY A</div>
            <select value={armyIdA} onChange={e=>selectArmy("A",e.target.value)} disabled={battleStarted} style={{ ...inputStyle, cursor:"pointer", fontSize:11, opacity:battleStarted?0.6:1 }}>
              <option value="">— Choose —</option>
              {armies.filter(a=>a.primary_key!==armyIdB).map(a=>(<option key={a.primary_key} value={a.primary_key}>{a.name} ({(a.size||0).toLocaleString()})</option>))}
            </select>
          </div>
          <span style={{ fontSize:14, fontWeight:800, color:"#d1d5db" }}>VS</span>
          <div style={{ flex:1, minWidth:150 }}>
            <div style={{ fontSize:9, fontWeight:700, color:"#6b7280", letterSpacing:1, marginBottom:3 }}>ARMY B</div>
            <select value={armyIdB} onChange={e=>selectArmy("B",e.target.value)} disabled={battleStarted} style={{ ...inputStyle, cursor:"pointer", fontSize:11, opacity:battleStarted?0.6:1 }}>
              <option value="">— Choose —</option>
              {armies.filter(a=>a.primary_key!==armyIdA).map(a=>(<option key={a.primary_key} value={a.primary_key}>{a.name} ({(a.size||0).toLocaleString()})</option>))}
            </select>
          </div>
          <div style={{ minWidth:150 }}>
            <div style={{ fontSize:9, fontWeight:700, color:"#6b7280", letterSpacing:1, marginBottom:3 }}>SEVERITY ({severity}/10)</div>
            <div style={{ display:"flex", gap:2 }}>{Array.from({length:10},(_,i)=>{const n=i+1;return<div key={n} onClick={()=>{if(!battleStarted)setSeverity(n);}} style={{ flex:1,height:14,borderRadius:2,cursor:battleStarted?"default":"pointer",background:n<=severity?(n<=3?"#86efac":n<=6?"#fbbf24":"#ef4444"):"#f3f4f6"}} />;})}</div>
            <div style={{ fontSize:9, color:"#374151", fontWeight:600, textAlign:"center", marginTop:2 }}>{sevLabels[severity-1]}</div>
          </div>
          {canSim&&!battleStarted&&(
            <div style={{ display:"flex", flexDirection:"column", gap:3 }}>
              <div style={{ display:"flex", gap:2 }}>{[["⚔ Atk",true],["🛡 Def",false]].map(([l,v])=>(<button key={l} onClick={()=>setAIsAttacker(v)} style={{ flex:1,padding:"3px 6px",borderRadius:3,border:"1px solid #e5e7eb",cursor:"pointer",fontSize:9,fontWeight:600,background:aIsAttacker===v?"#1f2937":"#f9fafb",color:aIsAttacker===v?"#fff":"#6b7280"}}>{l}</button>))}</div>
              <div style={{ display:"flex", gap:2 }}>
                <button onClick={()=>{setAHasSurprise(s=>!s);setBHasSurprise(false);}} style={{ flex:1,padding:"2px 4px",borderRadius:3,fontSize:8,fontWeight:600,cursor:"pointer",border:`1px solid ${aHasSurprise?"#f59e0b":"#e5e7eb"}`,background:aHasSurprise?"#fffbeb":"#f9fafb",color:aHasSurprise?"#92400e":"#9ca3af"}}>⚡A</button>
                <button onClick={()=>{setBHasSurprise(s=>!s);setAHasSurprise(false);}} style={{ flex:1,padding:"2px 4px",borderRadius:3,fontSize:8,fontWeight:600,cursor:"pointer",border:`1px solid ${bHasSurprise?"#f59e0b":"#e5e7eb"}`,background:bHasSurprise?"#fffbeb":"#f9fafb",color:bHasSurprise?"#92400e":"#9ca3af"}}>⚡B</button>
              </div>
            </div>
          )}
        </div>

        {/* Troop summary */}
        {canSim && (
          <div style={{ padding:"8px 20px", display:"flex", gap:12, flexShrink:0 }}>
            <TroopBar army={armyA} current={currentA} lost={totalCasA} side="A" color={armyA?.color||"#3b82f6"} />
            <TroopBar army={armyB} current={currentB} lost={totalCasB} side="B" color={armyB?.color||"#ef4444"} />
          </div>
        )}

        {/* Controls */}
        {canSim && (
          <div style={{ padding:"4px 20px 8px", display:"flex", gap:6, alignItems:"center", flexShrink:0 }}>
            {!battleStarted&&<button onClick={origStartBattle} style={{ background:"#1f2937",color:"#fff",border:"none",borderRadius:6,padding:"7px 18px",fontSize:12,fontWeight:700,cursor:"pointer"}}>⚔ Begin Battle</button>}
            {battleStarted&&!battleOver&&<button onClick={simNextRound} style={{ background:"#1f2937",color:"#fff",border:"none",borderRadius:6,padding:"7px 18px",fontSize:12,fontWeight:700,cursor:"pointer"}}>⚔ Next Round</button>}
            {battleStarted&&!battleOver&&<button onClick={simToEnd} style={{ background:"#7c3aed",color:"#fff",border:"none",borderRadius:6,padding:"7px 18px",fontSize:12,fontWeight:700,cursor:"pointer"}}>⚡ Fight to End</button>}
            {battleStarted && manualMatchups && <button onClick={resetMatchups} style={{ background:"none",border:"1px solid #c7d2fe",borderRadius:6,padding:"7px 12px",fontSize:10,color:"#7c3aed",cursor:"pointer"}}>Auto Match</button>}
            {battleStarted&&<button onClick={()=>{reset();setManualMatchups(null);}} style={{ background:"none",border:"1px solid #e5e7eb",borderRadius:6,padding:"7px 12px",fontSize:11,color:"#6b7280",cursor:"pointer"}}>↺ Reset</button>}
            {battleStarted && !battleOver && <span style={{ fontSize:9, color:"#9ca3af", marginLeft:8 }}>Drag cards to rearrange matchups</span>}
            {battleOver&&<button onClick={confirmResult} disabled={confirming} style={{ background:"#dc2626",color:"#fff",border:"none",borderRadius:6,padding:"7px 18px",fontSize:12,fontWeight:700,cursor:confirming?"wait":"pointer",marginLeft:"auto"}}>{confirming?"Applying...":"✓ Confirm & Apply"}</button>}
          </div>
        )}

        {/* Battle Arena — duel matchups */}
        {canSim && (matchups.duels.length > 0 || matchups.unmatchedA.length > 0 || matchups.unmatchedB.length > 0) && (
          <div style={{ flex:1, overflow:"auto", borderTop:"1px solid #e5e7eb", padding:"12px 20px" }}>
            {/* Duels */}
            {matchups.duels.length > 0 && (
              <div style={{ marginBottom:12 }}>
                <div style={{ fontSize:10, fontWeight:700, color:"#374151", letterSpacing:0.5, marginBottom:6, textTransform:"uppercase" }}>⚔ Entity Duels ({matchups.duels.length})</div>
                {matchups.duels.map((d, i) => <DuelGroup key={i} duel={d} index={i} />)}
              </div>
            )}
            {/* Unmatched — army support */}
            {(matchups.unmatchedA.length > 0 || matchups.unmatchedB.length > 0) && (
              <div>
                <div style={{ fontSize:10, fontWeight:700, color:"#7c3aed", letterSpacing:0.5, marginBottom:6, textTransform:"uppercase" }}>→ Army Support (unmatched)</div>
                <div style={{ display:"flex", gap:16 }}>
                  {matchups.unmatchedA.length > 0 && (
                    <div onDragOver={e => e.preventDefault()} onDrop={() => handleDropNewDuel("A")} style={{ flex:1, display:"flex", gap:6, flexWrap:"wrap", padding:8, borderRadius:8, background:"#f5f3ff", border: dragEnt ? "2px dashed #93c5fd" : "1px solid #e9d5ff", minHeight:40 }}>
                      {matchups.unmatchedA.map(e => <EntityCard key={e.primary_key} ent={e} draggable={battleStarted && !battleOver} />)}
                    </div>
                  )}
                  {matchups.unmatchedB.length > 0 && (
                    <div onDragOver={e => e.preventDefault()} onDrop={() => handleDropNewDuel("B")} style={{ flex:1, display:"flex", gap:6, flexWrap:"wrap", padding:8, borderRadius:8, background:"#fef2f2", border: dragEnt ? "2px dashed #fca5a5" : "1px solid #fecdd3", minHeight:40, justifyContent:"flex-end" }}>
                      {matchups.unmatchedB.map(e => <EntityCard key={e.primary_key} ent={e} draggable={battleStarted && !battleOver} />)}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Round log — compact below the arena */}
            {rounds.length > 0 && (
              <div style={{ marginTop:16, borderTop:"1px solid #e5e7eb", paddingTop:8 }}>
                <div style={{ fontSize:10, fontWeight:700, color:"#374151", letterSpacing:0.5, marginBottom:6, textTransform:"uppercase" }}>Round History</div>
                {rounds.map((r, i) => {
                  const maxTroops = Math.max(sizeA, sizeB);
                  return (
                    <div key={i} style={{ display:"flex", alignItems:"center", padding:"4px 0", borderBottom:"1px solid #f3f4f6", gap:4, fontSize:10 }}>
                      <span style={{ width:30, fontWeight:700, color:"#9ca3af" }}>R{i+1}</span>
                      <span style={{ fontWeight:600, color:r.roundWinner==="A"?"#16a34a":"#374151", minWidth:40 }}>{r.survivorsA.toLocaleString()}</span>
                      <div style={{ flex:1, height:5, borderRadius:3, background:"#f3f4f6", overflow:"hidden" }}>
                        <div style={{ height:"100%", borderRadius:3, width:`${(r.survivorsA/maxTroops)*100}%`, background:armyA?.color||"#3b82f6" }} />
                      </div>
                      <span style={{ color:"#ef4444", minWidth:50, textAlign:"center" }}>−{r.casualtiesA.toLocaleString()} {r.roundWinner==="A"?"◀":"▶"} −{r.casualtiesB.toLocaleString()}</span>
                      <div style={{ flex:1, height:5, borderRadius:3, background:"#f3f4f6", overflow:"hidden", direction:"rtl" }}>
                        <div style={{ height:"100%", borderRadius:3, width:`${(r.survivorsB/maxTroops)*100}%`, background:armyB?.color||"#ef4444" }} />
                      </div>
                      <span style={{ fontWeight:600, color:r.roundWinner==="B"?"#16a34a":"#374151", minWidth:40, textAlign:"right" }}>{r.survivorsB.toLocaleString()}</span>
                      {r.duelResults.length>0&&<span style={{ fontSize:8, color:"#9ca3af" }}>{r.duelResults.length} duels{r.duelResults.some(d=>d.woundedA.length>0||d.woundedB.length>0)?" ☠️":""}</span>}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {!canSim&&armyIdA&&armyIdB&&armyIdA===armyIdB&&<div style={{ padding:20, textAlign:"center", color:"#ef4444", fontSize:13 }}>Cannot battle an army against itself</div>}
        {(!armyIdA||!armyIdB)&&<div style={{ padding:40, textAlign:"center", color:"#9ca3af", fontSize:13 }}>Select two armies above to begin</div>}
      </div>
    </div>
  );
}

// ── Sidebar helpers ───────────────────────────────────────────────────────────
function SidebarItem({ color, label, shape, sub, active, onClick }) {
  return (
    <div onClick={onClick} style={{ display:"flex", alignItems:"center", gap:6, cursor:"pointer", padding:"3px 4px", borderRadius:4, background: active ? "#f3f4f6" : "transparent" }}>
      <span style={{ width:10, height:10, background:color, display:"inline-block", flexShrink:0, borderRadius: shape === "circle" ? "50%" : 2, transform: shape === "diamond" ? "rotate(45deg)" : "none" }} />
      <div style={{ overflow:"hidden" }}>
        <div style={{ fontSize:12, color:"#374151", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{label}</div>
        {sub && <div style={{ fontSize:10, color:"#9ca3af" }}>{sub}</div>}
      </div>
    </div>
  );
}
function ToolSection({ label, children }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
      <div style={{ fontSize:10, letterSpacing:1.5, color:"#9ca3af", fontWeight:600, borderBottom:"1px solid #f3f4f6", paddingBottom:4, marginBottom:2 }}>{label}</div>
      {children}
    </div>
  );
}
function ToolBtn({ children, active, onClick }) {
  return (
    <button onClick={onClick} style={{
      background: active ? "#f3f4f6" : "transparent",
      border: `1px solid ${active ? "#d1d5db" : "transparent"}`,
      color: active ? "#111827" : "#4b5563",
      borderRadius:5, padding:"5px 10px", cursor:"pointer", fontSize:13,
      textAlign:"left", display:"flex", alignItems:"center", gap:6,
      transition:"all 0.12s", fontWeight: active ? 500 : 400,
    }}>
      {children}
    </button>
  );
}